/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/** Kopfdaten eines Entwurfs. */
export interface AiDraftDto {
  /**
   * Kennung.
   * @format guid
   */
  id?: string;
  /** Anzeigename. */
  name?: string;
  /** Bearbeitungsstand. */
  status?: string;
  /**
   * Verknüpftes Projekt, falls vorhanden.
   * @format guid
   */
  projektId?: string | null;
  /**
   * Zeitpunkt des letzten Zugs (UTC).
   * @format date-time
   */
  updatedAt?: string;
  /**
   * Verbrauch, aufsummiert.
   * @format int32
   */
  inputTokens?: number;
  /**
   * Verbrauch, aufsummiert.
   * @format int32
   */
  outputTokens?: number;
  /**
   * Aus dem Cache gelesen — zeigt, ob das Caching greift.
   * @format int32
   */
  cachedTokens?: number;
  /**
   * Werkzeugrunden insgesamt.
   * @format int32
   */
  iterations?: number;
  /**
   * Aufsummierte Dauer aller Züge.
   * @format int64
   */
  durationMs?: number;
}

/** Anfrage zum Anlegen eines Entwurfs. */
export interface CreateAiDraftRequest {
  /** Anzeigename, meist der Kundenname. */
  name?: string | null;
  /**
   * Optionales Ausgangsprojekt.
   * @format guid
   */
  projektId?: string | null;
}

/** Ergebnis eines Gesprächszugs. */
export interface AiDraftTurnDto {
  /** Ist der Zug durchgelaufen? */
  ok?: boolean;
  /** Antworttext des Assistenten. */
  reply?: string | null;
  /** Klartext-Ursache bei Misserfolg. */
  error?: string | null;
  /**
   * Werkzeugrunden dieses Zugs.
   * @format int32
   */
  toolCalls?: number;
  /**
   * Dauer dieses Zugs.
   * @format int64
   */
  elapsedMilliseconds?: number;
  /** Der Entwurf nach dem Zug. */
  draft?: AiDraftDto;
}

/** Ein Gesprächszug des Vertrieblers. */
export interface AiDraftTurnRequest {
  /** Was der Kunde gesagt hat bzw. was der Vertriebler mitteilt. */
  text?: string;
}

/** Vollständiger Stand eines Entwurfs. */
export interface AiDraftDetailDto {
  /** Kopfdaten. */
  draft?: AiDraftDto;
  /** Der Dialog, ohne die Werkzeug-Rohdaten. */
  messages?: AiDraftMessageDto[];
  /** Das Frage-Antwort-Protokoll für die Nachvollziehbarkeit. */
  protocol?: AiProtocolEntryDto[];
}

/** Ein Beitrag des Dialogs für die Anzeige. */
export interface AiDraftMessageDto {
  /** "user" oder "assistant". */
  role?: string;
  /** Der Beitrag. */
  text?: string;
  /**
   * Wie viele Werkzeugrunden davor lagen. Die Oberfläche fasst sie zu einer aufklappbaren Zeile
   * zusammen — als Chatblasen würden sie den Dialog ersäufen.
   *
   * @format int32
   */
  toolCalls?: number;
}

/** Ein Eintrag des Gesprächsprotokolls. */
export interface AiProtocolEntryDto {
  /** Themenbereich. */
  topic?: string;
  /** Gestellte Frage. */
  question?: string;
  /** Antwort des Kunden. */
  answer?: string;
  /** Was daraus im Entwurf wurde. */
  outcome?: string | null;
  /**
   * Zeitpunkt (UTC).
   * @format date-time
   */
  recordedAt?: string;
}

/** Was beim Übernehmen in den Kalkulator wandert. */
export interface AiDraftApplyDto {
  /** Die erarbeiteten Positionen. */
  project?: ProjectInput;
  /** Die Gesprächsnotiz als Markdown, oder null. */
  notes?: string | null;
}

/**
 * Eingabe eines kompletten Angebots/Projekts: Projektname + Instanzliste + Standorte. Zugleich das
 * JSON-Austauschformat (Ersatz für die alte Excel-/.creq-Ablage); wird so gespeichert/geladen.
 */
export interface ProjectInput {
  /** Freitext-Projekt-/Kundenname. */
  projektname?: string;
  /** Die konfigurierten Anforderungs-Instanzen. */
  instanzen?: RequirementInstance[];
  /**
   * Die für dieses Projekt definierten Standorte (Auswahl für die Instanz-Zuordnung). null/leer =
   * nur der Standard-Standort. Über WithStandorte stets inklusive Standard normalisierbar.
   */
  standorte?: Standort[] | null;
  /**
   * Einleitender Freitext, der im Angebot vor der Anforderungsliste steht (z. B. Bezug auf
   * die Ausschreibung oder ein Gespräch). Preisneutral.
   */
  vorbemerkung?: string | null;
  /**
   * Beschreibung des Vorhabens für das Angebot. Preisneutral — Sonderleistungen mit Preis gehören
   * als FreiePosition in FreiePositionen, nicht hierhin.
   */
  projektbeschreibung?: string | null;
  /** Abschließender Freitext, der im Angebot nach der Anforderungsliste steht. Preisneutral. */
  zusammenfassung?: string | null;
  /**
   * Frei erfasste Positionen ohne Katalogartikel (Sonderentwicklung, Projektleistung, Pauschale).
   * Sie durchlaufen nicht die Engine, sondern werden dem Kalkulationsergebnis nachträglich
   * hinzugefügt und in die Summen eingerechnet.
   */
  freiePositionen?: FreiePosition[] | null;
}

/**
 * Eine konkrete Instanz einer Anforderung im Projekt – mehrfach (geklont) mit jeweils eigener
 * Konfiguration möglich (z.B. eine Funklinie mit Aufzeichnung, eine ohne). Entspricht einem
 * Top-Level-Request der alten Web-Engine (mit setId je Instanz).
 */
export interface RequirementInstance {
  /** Die xml:id der Anforderung. */
  requirementId?: string;
  /**
   * Anzahl gleicher, identisch konfigurierter Einheiten dieser Instanz.
   * @format double
   */
  menge?: number;
  /** Standort/Bereich (Vorgabe "A"). */
  area?: string;
  /** Optionaler Satz-Name; sonst wird der Anforderungstitel verwendet. */
  setName?: string | null;
  /** Die für diese Instanz gewählten Optionen. */
  options?: OptionSelection[] | null;
}

/**
 * Eine je Instanz gewählte Option (verweist auf eine Options-Anforderung) mit eigener Menge und
 * ggf. eigenen Unteroptionen. Gegenstück zu den verschachtelten optionen der alten
 * Web-Engine (rekursiv).
 */
export interface OptionSelection {
  /** Die xml:id der gewählten Options-Anforderung. */
  requirementId?: string;
  /**
   * Options-Menge je Eltern-Einheit (wird mit der Eltern-Menge multipliziert).
   * @format double
   */
  menge?: number;
  /** Verschachtelte Unter-Optionen. */
  options?: OptionSelection[] | null;
}

/**
 * Ein vorab definierter Standort eines Projekts (entspricht dem Area/Bereich der Instanzen).
 * Die Standortliste wird mit dem Projekt gespeichert/geladen und dient der UI als Auswahl (Dropdown).
 */
export interface Standort {
  /** Stabile Kennung; identisch zum Area-Wert der zugeordneten Instanzen. */
  id?: string;
  /** Anzeigename (z.B. "Hauptwache", "Schlauchturm"). */
  name?: string;
  /** Standort-Art (Vorgabe StandAlone). */
  typ?: StandortTyp;
  /** Bei Child/Connected: Id des versorgenden/verbundenen Standorts (der die Zentraltechnik stellt); sonst null. */
  gehoertZu?: string | null;
}

/**
 * Art eines Standorts – steuert (später) die Vernetzungs-/Zentraltechnik-Logik. Child und
 * Connected haben keinen eigenen Controller und verweisen über GehoertZu
 * auf den versorgenden/verbundenen Standort.
 */
export enum StandortTyp {
  StandAlone = "StandAlone",
  Child = "Child",
  Connected = "Connected",
}

/**
 * Eine frei erfasste Angebotsposition ohne Katalogartikel — typischerweise eine
 * Sonderentwicklung, eine Projektleistung oder eine Pauschale.
 */
export interface FreiePosition {
  /** Kurztext der Position — erscheint so im Angebot. */
  bezeichnung?: string;
  /**
   * Anzahl der Einheiten. Negative Werte sind unzulässig.
   * @format double
   */
  menge?: number;
  /** Mengeneinheit als Freitext, z. B. "Stk", "Std", "psch", "km". */
  einheit?: string;
  /**
   * Preis je Einheit (netto). 0 ist zulässig (z. B. Beistellung).
   * @format decimal
   */
  einzelpreis?: number;
  /**
   * a_gruppe-Code für die Einordnung in die Angebotssummen (siehe Rubrics).
   * Vorgabe I (Inbetriebnahme/Dienstleistung) — dort gehören Sonderleistungen üblicherweise hin.
   */
  rubrik?: string;
  /** Optionale Position (Eventualposition), zählt nicht in die Hauptsumme. */
  istOption?: boolean;
  /** Optionaler Langtext unter der Bezeichnung. */
  beschreibung?: string | null;
  /** Optionaler Standort; leer = keine Zuordnung. */
  area?: string;
  /**
   * Gesamtpreis der Position (netto) = Menge × Einzelpreis.
   * @format decimal
   */
  gesamtpreis?: number;
  /**
   * Die Bezeichnung inklusive Einheit für die Angebotsausgabe, z. B.
   * "Sonderentwicklung Schnittstelle (Std)". Die Einheit steht in Klammern, weil die
   * Positionstabelle keine eigene Einheiten-Spalte hat.
   */
  angebotsText?: string;
}

/** Eine Rückmeldung, wie sie in der Pflegeliste erscheint. */
export interface AiFeedbackDto {
  /**
   * Kennung.
   * @format guid
   */
  id?: string;
  /** Art der Meldung. */
  kind?: AiFeedbackKind;
  /** Der Begriff bzw. das Thema. */
  term?: string;
  /** Gesprächsausschnitt. */
  context?: string | null;
  /** Zugehörige Anforderung, falls bekannt. */
  requirementId?: string | null;
  /** Melder. */
  createdBy?: string | null;
  /**
   * Zeitpunkt (UTC).
   * @format date-time
   */
  createdAt?: string;
  /** Erledigt? */
  resolved?: boolean;
  transcriptMarkdown?: string | null;
}

/** Art einer Rückmeldung aus dem Gespräch. */
export enum AiFeedbackKind {
  MissingQuestion = "MissingQuestion",
  UnknownTerm = "UnknownTerm",
  MissingRequirement = "MissingRequirement",
}

/** Eine Rückmeldung aus dem Gespräch. */
export interface ReportAiFeedbackRequest {
  /** MissingQuestion oder UnknownTerm. */
  kind?: AiFeedbackKind;
  /** Der Begriff bzw. das Thema. */
  term?: string;
  /** Gesprächsausschnitt für den Zusammenhang. */
  context?: string | null;
  /** Zugehörige Anforderung, falls schon bekannt. */
  requirementId?: string | null;
}

/**
 * Die Einstellungen des KI-Assistenten, wie sie an die Oberfläche gehen.
 *
 */
export interface AiSettingsDto {
  /** Master-Schalter. */
  enabled?: boolean;
  /** Anbieter des Textmodells. */
  provider?: AiProvider;
  /** Basis-URL; leer = Vorgabe des Anbieters. */
  baseUrl?: string;
  /** Ist ein Schlüssel hinterlegt? */
  hasApiKey?: boolean;
  /** Modell für die anspruchsvollen Schritte. */
  model?: string;
  /** Schnelles Modell für „nächste Frage"; leer = Model. */
  fastModel?: string;
  /** Aufwandsstufe des großen Modells. */
  effort?: string;
  /**
   * Obergrenze der Werkzeugrunden je Zug.
   * @format int32
   */
  maxIterations?: number;
  /**
   * Obergrenze der Ausgabe-Token je Aufruf.
   * @format int32
   */
  maxOutputTokens?: number;
  /**
   * Zeitlimit eines Modellaufrufs.
   * @format int32
   */
  timeoutSeconds?: number;
  /**
   * Monatsbudget in Euro; 0 = keine Begrenzung.
   * @format decimal
   */
  monthlyBudgetEur?: number;
  /**
   * Warnschwelle in Prozent des Budgets.
   * @format int32
   */
  warnAtPercent?: number;
  /**
   * Erwartete Obergrenze der Antwortzeit.
   * @format int32
   */
  latencyBudgetMs?: number;
  /** Spracherkennung eingeschaltet? */
  speechEnabled?: boolean;
  /** Anbieter der Spracherkennung. */
  speechProvider?: AiSpeechProvider;
  /** Basis-URL des Spracherkennungsdienstes. */
  speechBaseUrl?: string;
  /** Modell der Spracherkennung. */
  speechModel?: string;
  /** Ist ein Schlüssel für die Spracherkennung hinterlegt? */
  hasSpeechApiKey?: boolean;
  /**
   * Es liegt ein Schlüssel in der Ablage, er ließ sich aber nicht entschlüsseln. Anderer Fall als
   * „nicht hinterlegt" — und einer, der ohne diese Unterscheidung gleich aussieht.
   *
   */
  apiKeyUnreadable?: boolean;
  /** Dasselbe für die Spracherkennung. */
  speechApiKeyUnreadable?: boolean;
}

/** Anbieter des Textmodells. */
export enum AiProvider {
  Anthropic = "Anthropic",
  Ollama = "Ollama",
}

/** Anbieter der Spracherkennung. Bewusst eine eigene Aufzählung, siehe AiRuntimeSettings. */
export enum AiSpeechProvider {
  LocalWhisper = "LocalWhisper",
  OpenAiCompatible = "OpenAiCompatible",
}

/**
 * Änderungswunsch an den Einstellungen.
 *
 */
export interface UpdateAiSettingsRequest {
  enabled?: boolean;
  /** Anbieter des Textmodells. */
  provider?: AiProvider;
  baseUrl?: string | null;
  apiKey?: string | null;
  model?: string;
  fastModel?: string | null;
  effort?: string | null;
  /** @format int32 */
  maxIterations?: number;
  /** @format int32 */
  maxOutputTokens?: number;
  /** @format int32 */
  timeoutSeconds?: number;
  /** @format decimal */
  monthlyBudgetEur?: number;
  /** @format int32 */
  warnAtPercent?: number;
  /** @format int32 */
  latencyBudgetMs?: number;
  speechEnabled?: boolean;
  /** Anbieter der Spracherkennung. Bewusst eine eigene Aufzählung, siehe AiRuntimeSettings. */
  speechProvider?: AiSpeechProvider;
  speechBaseUrl?: string | null;
  speechModel?: string | null;
  speechApiKey?: string | null;
}

/**
 * Ergebnis des Verbindungstests.
 *
 */
export interface AiTestResultDto {
  /** Hat das Modell geantwortet? */
  success?: boolean;
  /** Klartext-Ergebnis für die Anzeige. */
  message?: string;
  /**
   * Gemessene Antwortzeit des vollständigen Aufrufs.
   * @format int64
   */
  elapsedMilliseconds?: number;
  /**
   * Liegt die Antwortzeit im erwarteten Rahmen? null, wenn der Aufruf gescheitert ist.
   * Ein Assistent, der im laufenden Telefonat souffliert, ist bei 20 Sekunden Antwortzeit
   * technisch in Ordnung und fachlich unbrauchbar — deshalb wird das getrennt gemeldet.
   *
   */
  withinLatencyBudget?: boolean | null;
  /** Das Modell, das geantwortet hat. */
  model?: string | null;
  /** Die Antwort des Modells, gekürzt — Beleg, dass wirklich etwas ankam. */
  reply?: string | null;
}

/** Stand des Nachfüllens von Gesprächsfragen. */
export interface QuestionBacklogDto {
  /**
   * Anforderungen ohne Frage oder ohne Stichworte (implizite ausgenommen). Die Größe der
   * Pflegeaufgabe.
   *
   * @format int32
   */
  missingCount?: number;
  /**
   * Anforderungen, die aktuell in der Warteschlange stehen. Fällt auf 0, wenn der
   * Hintergrunddienst durch ist.
   *
   * @format int32
   */
  pendingCount?: number;
}

/** Verbrauch eines Monats. */
export interface AiUsageDto {
  /**
   * Erster Tag des Monats (UTC).
   * @format date-time
   */
  month?: string;
  /**
   * Anzahl Entwürfe, an denen gearbeitet wurde.
   * @format int32
   */
  drafts?: number;
  /**
   * Summe der Eingabe-Token.
   * @format int64
   */
  inputTokens?: number;
  /**
   * Summe der Ausgabe-Token.
   * @format int64
   */
  outputTokens?: number;
  /**
   * Aus dem Cache gelesene Token — je höher, desto besser greift das Caching.
   * @format int64
   */
  cachedTokens?: number;
  /**
   * Geschätzte Kosten in Euro.
   * @format decimal
   */
  estimatedEur?: number;
  /**
   * Konfiguriertes Monatsbudget; 0 = unbegrenzt.
   * @format decimal
   */
  budgetEur?: number;
  /** Budget überschritten — weitere Züge werden abgelehnt. */
  overBudget?: boolean;
  /** Warnschwelle erreicht. */
  nearBudget?: boolean;
}

/** Response model for the alive/health check endpoint */
export interface AliveResponse {
  /**
   * Current server date and time
   * @format date-time
   */
  date?: string;
  /** Server version */
  version?: string;
  /** Server status */
  status?: string;
}

/**
 * Response returned exactly once after creating an API key.
 * Key is shown here and never retrievable again.
 *
 */
export interface CreateApiKeyResponse {
  /** @format guid */
  id?: string;
  name?: string;
  keyPrefix?: string;
  /**
   * The full, plaintext API key. Only returned on creation — the server stores only a hash.
   *
   */
  key?: string;
  /** @format date-time */
  createdAt?: string;
  /** @format date-time */
  expiresAt?: string | null;
}

/**
 * Request body when creating a new API key.
 *
 */
export interface CreateApiKeyRequest {
  /**
   * Human-readable label for the key (e.g. "Claude Desktop – MacBook").
   *
   */
  name?: string;
  /**
   * Optional expiration timestamp. If omitted, defaults to +1 year from creation.
   * Pass null explicitly via a separate flag if a never-expiring key is desired;
   * the server treats a missing value as "use default".
   *
   * @format date-time
   */
  expiresAt?: string | null;
  /**
   * When true, no expiration is set (overrides ExpiresAt).
   *
   */
  neverExpires?: boolean;
}

/**
 * Sanitized view of a stored API key (no hash, no plaintext).
 *
 */
export interface ApiKeyDto {
  /** @format guid */
  id?: string;
  name?: string;
  keyPrefix?: string;
  /** @format date-time */
  createdAt?: string;
  /** @format date-time */
  lastUsedAt?: string | null;
  /** @format date-time */
  expiresAt?: string | null;
  /** @format date-time */
  revokedAt?: string | null;
}

/**
 * Represents the data structure for a file type, including host system info
 * and the latest file per host system (without matching files).
 */
export interface GetFileTypeLatestHostSystemFileData {
  /**
   * Gets or sets the unique identifier for the file type.
   * @format guid
   * @minLength 1
   */
  id: string;
  /**
   * Gets or sets the name of the file type.
   * @minLength 1
   */
  name: string;
  /** Value is shown on public endpoints */
  public: boolean;
  /** File Type Class for filtering */
  type: FileTypeClass;
  /**
   * Latest files per host system (only entries with a file).
   *
   */
  latestFiles?: LatestHostSystemFileDto[];
  /**
   * Package identifier (used primarily for Android or iOS license generation).
   *
   */
  packageId?: string | null;
  /**
   * Gets or sets the unique identifier for the icon.
   * @format guid
   */
  iconId?: string | null;
  /** Gets or sets the unique identifiers for screenshots. */
  screenshotIds?: string[];
}

/** FileType Class - For display purposes */
export enum FileTypeClass {
  UNDEFINED = "UNDEFINED",
  APPLICATION = "APPLICATION",
  DOCUMENTATION = "DOCUMENTATION",
  OTHER = "OTHER",
}

/**
 * Latest file info for a host system (flattened).
 *
 */
export interface LatestHostSystemFileDto {
  /**
   * The HostSystem ID this file is for.
   *
   * @format guid
   */
  hostSystemId?: string;
  /**
   * The HostSystem name this file is for.
   *
   */
  hostSystemName?: string;
  /**
   * Indicates if this HostSystem is used for documentation
   *
   */
  isDocumentation?: boolean;
  /**
   * File identifier.
   *
   */
  fileId?: string | null;
  /**
   * Version key without product id.
   *
   */
  versionKey?: LatestVersionKey | null;
  /**
   * Version stage (e.g., BETA, RELEASE).
   *
   */
  stage?: EVersionStage;
}

/**
 * Version key without product id.
 *
 */
export interface LatestVersionKey {
  /**
   * The major version number.
   * @format int32
   */
  major?: number;
  /**
   * The minor version number.
   * @format int32
   */
  minor?: number;
  /**
   * The patch version number.
   * @format int32
   */
  patch?: number;
}

/**
 * Version Stage
 *
 */
export enum EVersionStage {
  INTERNAL = 0,
  ALPHA = 1,
  BETA = 2,
  RELEASE_CANDIDATE = 3,
  RELEASE = 4,
  APPROVED = 5,
}

/** Filter for documentation HostSystems */
export enum DocumentationFilter {
  All = "All",
  OnlyDocumentation = "OnlyDocumentation",
  ExcludeDocumentation = "ExcludeDocumentation",
}

/**
 * Represents the data structure for a file type, including associated host system,
 * matching files, and filter tags.
 */
export interface GetFileTypeData {
  /**
   * Gets or sets the unique identifier for the file type.
   * @format guid
   * @minLength 1
   */
  id: string;
  /**
   * Gets or sets the name of the file type.
   * @minLength 1
   */
  name: string;
  /** Value is shown on public endpoints */
  public: boolean;
  /** File Type Class for filtering */
  type: FileTypeClass;
  /**
   * Gets or sets the description of the file type.
   * Provides additional information about its purpose or usage.
   */
  description?: string;
  /**
   * Platform-specific configurations for this FileType.
   * Each entry links the FileType to a HostSystem with platform-specific MatchingFiles.
   *
   */
  platformConfigurations?: FileTypePlatformConfigurationDto[];
  /**
   * Package identifier (used primarily for Android or iOS license generation).
   *
   */
  packageId?: string | null;
  /** Version used for creating the License Key */
  version?: number;
  /** File type variants for the current file type (empty list: only Default) */
  variants?: FileTypeVariantsDto[];
  /**
   * Gets or sets a list of filter tags used for the current host system.
   * These tags help categorize or identify the file type for filtering or searching.
   */
  filterTags?: GetFilterTagData[];
  /** Gets or sets the list of related file type IDs. */
  relatedFileTypeIds?: string[];
  /**
   * Gets or sets the unique identifier for the icon.
   * @format guid
   */
  iconId?: string | null;
  /** Gets or sets the unique identifier for the icon. */
  screenshotIds?: string[];
}

/**
 * Platform-specific configuration for a FileType-HostSystem relationship.
 *
 */
export interface FileTypePlatformConfigurationDto {
  /**
   * The HostSystem ID this configuration is for.
   *
   * @format guid
   */
  hostSystemId?: string;
  /**
   * The HostSystem name this configuration is for.
   *
   */
  hostSystemName?: string;
  /**
   * Platform-specific matching file patterns.
   *
   */
  matchingFiles?: string[] | null;
}

export interface FileTypeVariantsDto {
  tag?: string;
  name?: string;
}

/**
 * HTTP return value for filter tags
 *
 */
export interface GetFilterTagData {
  /**
   * Individual identifier of the filter tag. Will be set by user
   *
   * @example "con_BosCompact"
   */
  identifier?: string;
  /**
   * Custom name to describe filter tag
   *
   * @example "BosCompact"
   */
  name?: string;
}

export interface GetVersionFileData {
  id?: string;
  /** Represents the version key of a product. */
  versionKey?: VersionKey;
  fileName?: string;
  /**
   * Represents the data structure for a file type, including associated host system,
   * matching files, and filter tags.
   */
  fileType?: GetFileTypeData;
  /**
   * HostSystem/Platform for this file (Windows, Android, iOS, etc.)
   * @format guid
   */
  hostSystemId?: string | null;
  /** HostSystem/Platform name */
  hostSystemName?: string | null;
  /** User can download this file */
  canDownload?: boolean;
}

/** Represents the version key of a product. */
export interface VersionKey {
  /**
   * The major version number.
   * @format int32
   * @example 3
   */
  major?: number;
  /**
   * The minor version number.
   * @format int32
   * @example 1
   */
  minor?: number;
  /**
   * The patch version number.
   * @format int32
   * @example 0
   */
  patch?: number;
  /**
   * The unique identifier for the product.
   * @format guid
   * @example "3D290374-8689-4856-B5C4-35E0414F66E8"
   */
  productId?: string;
}

export interface ImageDto {
  /** @format guid */
  id?: string;
  fileName?: string;
  contentType?: string;
  description?: string;
}

/** Model for device registration using a license code. */
export interface RegisterDeviceModel {
  /** Name of the device. */
  name?: string;
  /** License code provided by administrator. */
  licenseCode?: string;
  /** Optional device hardware identifier. */
  deviceId?: string | null;
  /** Operating system version (e.g., "Android 14", "iOS 17"). */
  osVersion?: string;
}

/**
 * AppStore configuration data transfer object.
 *
 */
export interface AppStoreConfigDto {
  /**
   * Indicates whether the AppStore FileType ID is configured.
   *
   */
  configured?: boolean;
  /**
   * The configured FileType ID for the AppStore APK.
   *
   * @format guid
   */
  fileTypeId?: string | null;
  /**
   * Optional message (e.g., success or error message).
   *
   */
  message?: string | null;
}

/**
 * AppStore APK information data transfer object.
 *
 */
export interface AppStoreInfoDto {
  /**
   * Indicates whether the AppStore APK is available.
   *
   */
  available?: boolean;
  /**
   * Name of the file type.
   *
   */
  fileTypeName?: string | null;
  /**
   * Version string (e.g., "1.2.3").
   *
   */
  version?: string | null;
  /**
   * Version ID.
   *
   */
  versionId?: string | null;
  /**
   * File name of the APK.
   *
   */
  fileName?: string | null;
  /**
   * Optional message (e.g., error message when not available).
   *
   */
  message?: string | null;
}

/** Persisted audit entry for device/license related operations. */
export interface AuditLogEntry {
  /**
   * Primary key of the audit entry.
   * @format guid
   */
  id?: string;
  /**
   * UTC timestamp when the event was recorded.
   * @format date-time
   */
  timestamp?: string;
  /** User identifier (usually email) that triggered the action. */
  user?: string | null;
  /** Logical domain of the reference, e.g. Device, License, SupportContract. */
  referenceType?: string;
  /** Identifier of the referenced entity. String to support Guid and non-Guid IDs. */
  referenceId?: string;
  /** Technical function/action name, e.g. Register, Delete, AssignSupportCode. */
  function?: string;
  /** Human-readable audit message. */
  message?: string;
  /** Optional additional details in free text format. */
  details?: string | null;
  /** Client IP address from which the action originated. */
  clientIp?: string | null;
  /** User-Agent header of the client request. */
  userAgent?: string | null;
}

/**
 * Paged search result for audit log queries.
 *
 */
export interface AuditLogSearchResult {
  /**
   * Total number of rows matching the filter (ignoring Skip/Limit).
   *
   * @format int32
   */
  totalCount?: number;
  /**
   * The current page of entries, newest first.
   *
   */
  entries?: AuditLogEntry[];
}

export interface ProblemDetails {
  type?: string | null;
  title?: string | null;
  /** @format int32 */
  status?: number | null;
  detail?: string | null;
  instance?: string | null;
  [key: string]: any;
}

/**
 * Die mit Git steuerbaren Datenbereiche des Kalkulators. Wird auf die konfigurierten
 * Verzeichnisse (Office:DataDir bzw. Office:ArticleDir) abgebildet; ein
 * beliebiger Dateisystem-Pfad ist von außen NICHT wählbar.
 *
 */
export enum CalculatorGitArea {
  Office = "Office",
  Artikel = "Artikel",
}

/** Anfrage zum Erstellen eines Commits über alle Änderungen eines Bereichs. */
export interface GitCommitRequest {
  /**
   * Die Commit-Nachricht (Pflichtfeld).
   * @minLength 1
   */
  message: string;
}

/**
 * Anmeldedaten für eine Remote-Operation (fetch/pull/push). Werden ausschließlich für diese
 * eine Operation verwendet und nicht gespeichert.
 *
 */
export interface GitRemoteCredentialsRequest {
  /**
   * Der Remote-Benutzername (Pflichtfeld).
   * @minLength 1
   */
  username: string;
  /**
   * Passwort oder Token (Pflichtfeld).
   * @minLength 1
   */
  password: string;
}

/** Anfrage zur Auflösung eines einzelnen Merge-Konflikts. */
export interface GitResolveConflictRequest {
  /**
   * Repository-relativer Pfad der konfliktbehafteten Datei (Pflichtfeld).
   * @minLength 1
   */
  path: string;
  /** Welche Seite des Konflikts übernommen wird (Ours/Theirs). */
  side: GitConflictSide;
}

/** Welche Seite eines Merge-Konflikts bei der Auflösung übernommen wird. */
export enum GitConflictSide {
  Ours = "Ours",
  Theirs = "Theirs",
}

/**
 * Ob und wie der angemeldete Benutzer den Kalender benutzen kann.
 *
 */
export interface CalendarAccessDto {
  /**
   * Kann der Benutzer den Kalender jetzt abrufen? Nur dann liefern die Kalender-Endpunkte Daten.
   *
   */
  available?: boolean;
  /** Ist die Anbindung eingeschaltet? */
  enabled?: boolean;
  /** Ist die Anbindung vollständig konfiguriert? */
  configured?: boolean;
  /** Ist am Benutzerkonto ein LabelBenutzer hinterlegt? */
  hasLabelUser?: boolean;
  /** Der hinterlegte LabelBenutzer. */
  labelUser?: string | null;
  /**
   * Darf der Benutzer Einträge anlegen, verschieben und löschen? Hängt am Schalter der
   * Anbindung, nicht an der Person.
   *
   */
  allowWrites?: boolean;
  /** Der zugeordnete Labelwin-Mitarbeiter, sofern auflösbar. */
  employee?: CalendarEmployeeDto | null;
  /** Klartext-Begründung für die Anzeige — immer gesetzt. */
  message?: string;
}

/**
 * Ein Mitarbeiter aus der Labelwin-Personalstammdatei (personal).
 *
 */
export interface CalendarEmployeeDto {
  /**
   * Personalnummer (personal.montnr).
   * @format int32
   */
  employeeId?: number;
  /** Anzeigename, „Nachname, Vorname". */
  name?: string | null;
  /** Kürzel. */
  shortCode?: string | null;
  /** Der Labelwin-Anmeldename — der Anker zum Support-Benutzer. */
  labelUser?: string | null;
  /** Externe Mailadresse. */
  mail?: string | null;
  /** Interne Mailadresse. */
  mailInternal?: string | null;
  /** Ist der Mitarbeiter Servicetechniker? */
  isServiceTechnician?: boolean;
  /** Gehört der Mitarbeiter zur Verwaltung? */
  isAdministration?: boolean;
}

/**
 * Der Kalender einer Person in einem Zeitfenster.
 *
 */
export interface CalendarViewDto {
  /** Der Mitarbeiter, zu dem der Kalender gehört. */
  employee?: CalendarEmployeeDto | null;
  /**
   * Erster Tag des Zeitfensters.
   * @format date
   */
  from?: string;
  /**
   * Letzter Tag des Zeitfensters.
   * @format date
   */
  to?: string;
  /**
   * Die Einträge aus der Plantafel (kdbelegttag + kdbelegt).
   *
   */
  entries?: CalendarEntryDto[];
  /**
   * Die Wiedervorlagen aus termine — eine getrennte Quelle, die ebenfalls zu dieser
   * Person gehört.
   *
   */
  tasks?: CalendarTaskDto[];
}

/**
 * Ein Eintrag der Labelwin-Plantafel (kdbelegttag + kdbelegt).
 *
 */
export interface CalendarEntryDto {
  /**
   * Id des Tagessatzes (kdbelegttag).
   * @format int32
   */
  id?: number;
  /**
   * Id des Kopfsatzes (kdbelegt).
   * @format int32
   */
  headId?: number;
  /**
   * Personalnummer, zu der der Eintrag gehört.
   * @format int32
   */
  employeeId?: number;
  /**
   * Der Tag des Eintrags.
   * @format date
   */
  date?: string | null;
  /**
   * Beginn als fertiger Zeitstempel (Wanduhrzeit, ohne Zeitzone).
   * @format date-time
   */
  start?: string | null;
  /**
   * Ende als fertiger Zeitstempel (Wanduhrzeit, ohne Zeitzone).
   * @format date-time
   */
  end?: string | null;
  /** Ganztägiger Eintrag? */
  isAllDay?: boolean;
  /**
   * Lesbare Kategorie: Order, Appointment, Absence, Project,
   * Task. Bewusst als Text und nicht als Aufzählung — eine Lookup-Tabelle für
   * RawKind existiert in Projdat nicht, die Werte sind aus Produktivdaten
   * erschlossen. Ein neuer Wert darf die Abfrage nicht zum Absturz bringen.
   *
   */
  kind?: string | null;
  /**
   * Rohwert belegart aus Projdat. Sicher belegt sind 0 (Urlaub), 1 (Krank), 4
   * (KD-Auftrag) und 100 (freier Kalendereintrag). Wer Logik darauf aufbaut, prüft diesen Wert,
   * nicht Kind.
   *
   * @format int32
   */
  rawKind?: number;
  /** Betreff. */
  subject?: string | null;
  /** Langtext, wie ihn der Labelwin-Client als Tooltip zeigt. */
  tooltip?: string | null;
  /** Projektnummer des Eintrags. */
  project?: string | null;
  /**
   * Interne Auftrags-Id (kd.lfdnr), oder null ohne Auftragsbezug — LabelConnect
   * normalisiert das -1 aus Projdat weg.
   *
   * @format int32
   */
  orderId?: number | null;
  /** Auftragsnummer (z. B. 26-0187) — hierauf wird Zeit gebucht. */
  orderNumber?: string | null;
  /** Projektnummer des Auftrags. */
  orderProject?: string | null;
  /**
   * Dauer in Stunden.
   * @format double
   */
  hours?: number | null;
  /**
   * Beginn des gesamten Balkens, falls der Eintrag Teil eines Balkens ist.
   * @format date-time
   */
  spanStart?: string | null;
  /**
   * Ende des gesamten Balkens.
   * @format date-time
   */
  spanEnd?: string | null;
  /**
   * Gehört der Tagessatz zu einem mehrtägigen Balken? Solche Einträge sind über diese API
   * nicht änderbar.
   *
   */
  isPartOfSpan?: boolean;
  /** Die Anmerkung des Eintrags (anmerkung) — unbegrenzt und mehrzeilig. */
  note?: string | null;
  /** Der Auftrag hinter dem Eintrag, sofern einer dranhängt. */
  order?: CalendarOrderDto | null;
}

/**
 * Der Auftrag hinter einem Kalendereintrag — aus kd und den daran hängenden Tabellen.
 * Alle Felder sind optional.
 *
 */
export interface CalendarOrderDto {
  /** Auftragsnummer (kd.auftrnr), z. B. 26-0187. */
  number?: string | null;
  /** Auftragsinhalt (kd.auftragtext). */
  subject?: string | null;
  /** Fehlerbild in den Worten des Kunden (kd.kommentar). */
  comment?: string | null;
  /** Ansprechpartner (kd.anrufer). */
  contactName?: string | null;
  /** Telefonnummer des Ansprechpartners. */
  contactPhone?: string | null;
  /** E-Mail-Adresse des Ansprechpartners. */
  contactMail?: string | null;
  /** Auf welchem Weg der Auftrag herankam, z. B. „telefonisch". */
  channel?: string | null;
  /** Kunde. */
  customerName?: string | null;
  /** Ort des Kunden. */
  customerCity?: string | null;
  /** Support-Id der betroffenen Anlage (anlagen.deviceid). */
  supportId?: string | null;
  /** Anlagenbezeichnung. */
  systemName?: string | null;
  /** Vertragsnummer, sofern der Auftrag an einem Vertrag hängt. */
  contractNumber?: string | null;
  /**
   * Priorität; höher ist dringender.
   * @format int32
   */
  priority?: number | null;
  /**
   * Geplante Stunden.
   * @format double
   */
  plannedHours?: number | null;
}

/**
 * Ein Termin aus dem Outlook-Kalender des angemeldeten Benutzers. Zeitpunkte sind
 * Wanduhrzeiten in derselben Zeitzone wie die Labelwin-Termine.
 *
 */
export interface OutlookEventDto {
  /** Graph-Id des Termins. Stabil, taugt als Schlüssel. */
  id?: string;
  /** Betreff. */
  subject?: string | null;
  /**
   * Beginn als Wanduhrzeit.
   * @format date-time
   */
  start?: string | null;
  /**
   * Ende als Wanduhrzeit.
   * @format date-time
   */
  end?: string | null;
  /** Ganztägiger Termin. */
  isAllDay?: boolean;
  /** Ort, wie er im Termin steht. */
  location?: string | null;
  /** Name des Organisators. */
  organizer?: string | null;
  /** E-Mail-Adresse des Organisators. */
  organizerMail?: string | null;
  /** Anzeige als free, tentative, busy, oof oder workingElsewhere. */
  showAs?: string | null;
  /** Vertraulichkeit (normal, personal, private, confidential). */
  sensitivity?: string | null;
  /** Abgesagter Termin. */
  isCancelled?: boolean;
  /** Eigene Antwort auf die Einladung. */
  responseStatus?: string | null;
  /**
   * Anzahl der Teilnehmer.
   * @format int32
   */
  attendeeCount?: number;
  /** Ist eine Online-Besprechung hinterlegt (in der Regel Teams)? */
  isOnlineMeeting?: boolean;
  /** Beitrittslink der Online-Besprechung. */
  onlineMeetingUrl?: string | null;
  /** Die ersten Zeilen des Termintexts. */
  preview?: string | null;
  /** Link, der den Termin in Outlook im Web öffnet. */
  webLink?: string | null;
}


/**
 * Die Belegung einer Person im Zeitstrahl des Planers. Beide Quellen stehen getrennt und mit
 * eigenem Zustand — eine Person ohne jede Quelle bleibt als leere Zeile stehen.
 *
 */
export interface PlannerPersonDto {
  /** Die Kennung, unter der die Person angefragt wurde (E-Mail). */
  identifier?: string;
  /** Anzeigename aus der Labelwin-Personalstammdatei, sofern gefunden. */
  name?: string | null;
  /**
   * Personalnummer, sofern gefunden.
   * @format int32
   */
  employeeId?: number | null;
  /** Konnte der Labelwin-Kalender gelesen werden? */
  labelwinAvailable?: boolean;
  /** Begründung, wenn nicht. */
  labelwinMessage?: string | null;
  /** Einträge der Plantafel. */
  entries?: CalendarEntryDto[];
  /** Wiedervorlagen. */
  tasks?: CalendarTaskDto[];
  /** Konnte der Outlook-Kalender gelesen werden? */
  outlookAvailable?: boolean;
  /** Begründung, wenn nicht. */
  outlookMessage?: string | null;
  /** Termine aus Outlook. */
  outlookEntries?: OutlookEventDto[];
  /**
   * Der Teams-Status, sofern lesbar. null heißt „keine Auskunft" — sei es, weil die Berechtigung
   * fehlt, die Person kein Teams-Konto hat oder Microsoft gerade nichts liefert.
   */
  presence?: TeamsPresenceDto | null;
}

/**
 * Der Planer: mehrere Personen über demselben Zeitfenster.
 *
 */
export interface PlannerViewDto {
  /**
   * Erster Tag des Zeitfensters.
   * @format date
   */
  from?: string;
  /**
   * Letzter Tag des Zeitfensters.
   * @format date
   */
  to?: string;
  /** Eine Zeile je angefragter Person, in der angefragten Reihenfolge. */
  people?: PlannerPersonDto[];
}

/**
 * Eine persönliche Einstellung des angemeldeten Benutzers.
 *
 */
export interface UserSettingDto {
  /** Schlüssel der Einstellung. */
  key?: string;
  /** Der Wert, oder null wenn nichts hinterlegt ist. */
  value?: string | null;
}

/**
 * Neuer Wert einer persönlichen Einstellung. Leer löscht die Einstellung.
 *
 */
export interface UpdateUserSettingRequest {
  /** Der Wert. Leer oder null löscht die Einstellung. */
  value?: string | null;
}

/**
 * Der Outlook-Kalender des angemeldeten Benutzers in einem Zeitfenster. Antwortet immer mit
 * HTTP 200; available sagt, ob die Quelle angeboten werden kann, message begründet es.
 *
 */
export interface OutlookCalendarViewDto {
  /** Konnten Termine gelesen werden? */
  available?: boolean;
  /** Klartext-Begründung für die Anzeige — immer gesetzt. */
  message?: string;
  /** Das abgefragte Postfach. */
  userPrincipalName?: string | null;
  /**
   * Erster Tag des Zeitfensters.
   * @format date
   */
  from?: string;
  /**
   * Letzter Tag des Zeitfensters.
   * @format date
   */
  to?: string;
  /** Die gelesenen Termine. */
  entries?: OutlookEventDto[];
}

/**
 * Eine Wiedervorlage aus termine, die an einem Tag fällig ist.
 *
 */
export interface CalendarTaskDto {
  /**
   * Schlüssel (termine.lfdnr).
   * @format int32
   */
  id?: number;
  /**
   * Zugeordneter Mitarbeiter (termine.perslfdnr → personal.montnr).
   * @format int32
   */
  employeeId?: number;
  /**
   * Fälligkeitstag (termine.termintag).
   * @format date
   */
  date?: string | null;
  /**
   * Beginn, oder null wenn die Aufgabe keine Uhrzeit hat.
   * @format date-time
   */
  start?: string | null;
  /**
   * Ende, oder null wenn die Aufgabe keine Uhrzeit hat.
   * @format date-time
   */
  end?: string | null;
  /** Betreff (termine.betreff). */
  subject?: string | null;
  /** Bearbeitungsstand, meist offen oder erledigt. */
  status?: string | null;
  /** Art der Aufgabe aus termintaetigkeit, z. B. „Bitte um Rückruf". */
  activity?: string | null;
  /** LabelBenutzer, der die Aufgabe angelegt hat (termine.anlageuser). */
  createdBy?: string | null;
  /**
   * Bezug auf einen Serviceauftrag, sonst null.
   * @format int32
   */
  customerServiceId?: number | null;
  /**
   * Bezug auf ein Projekt, sonst null.
   * @format int32
   */
  projectId?: number | null;
  /**
   * Wichtigkeit (termine.wichtigkeit); höher ist dringender.
   * @format int32
   */
  priority?: number;
  /** Zeigt Labelwin die Aufgabe in seiner Kalenderansicht? */
  showInCalendar?: boolean;
}

/**
 * Anlegen eines freien Kalendereintrags.
 *
 */
export interface CreateCalendarEntryRequest {
  /**
   * Beginn. Wanduhrzeit ohne Zeitzone (2026-08-25T09:00:00). Ein Zeitpunkt mit Zeitzone
   * wird in die Zeitzone der Plantafel umgerechnet.
   *
   * @format date-time
   */
  start?: string;
  /**
   * Ende. Muss am selben Tag wie Start liegen.
   * @format date-time
   */
  end?: string;
  /** Betreff, darf nicht leer sein. */
  subject?: string;
}

/**
 * Verschieben eines freien Kalendereintrags.
 *
 */
export interface MoveCalendarEntryRequest {
  /**
   * Neuer Beginn.
   * @format date-time
   */
  start?: string;
  /**
   * Neues Ende, am selben Tag wie Start.
   * @format date-time
   */
  end?: string;
  /** Neuer Betreff; ohne Angabe bleibt der bestehende Text. */
  subject?: string | null;
}

/**
 * Dashboard statistics response.
 *
 */
export interface DashboardStatisticsDto {
  /**
   * Number of active support contracts.
   *
   * @format int32
   */
  activeContracts?: number;
  /**
   * Number of support contracts expiring soon.
   *
   * @format int32
   */
  expiringSoonContracts?: number;
  /**
   * Number of expired support contracts.
   *
   * @format int32
   */
  expiredContracts?: number;
  /**
   * Number of open tickets.
   *
   * @format int32
   */
  openTickets?: number;
  /**
   * Number of recent versions in the selected time window.
   *
   * @format int32
   */
  recentVersionsCount?: number;
  /**
   * Total number of available downloads.
   *
   * @format int32
   */
  availableDownloads?: number;
  /**
   * Number of available version files.
   *
   * @format int32
   */
  availableVersionDownloads?: number;
  /**
   * Number of available shared files.
   *
   * @format int32
   */
  availableSharedFiles?: number;
  /**
   * List of recently uploaded versions.
   *
   */
  recentVersions?: RecentVersionDto[];
}

/**
 * Compact version information for recent version lists.
 *
 */
export interface RecentVersionDto {
  /**
   * Version ID as computed string.
   *
   */
  versionId?: string;
  /**
   * Major version as number.
   *
   * @format int32
   */
  major?: number;
  /**
   * Minor version as number.
   *
   * @format int32
   */
  minor?: number;
  /**
   * Patch version as number.
   *
   * @format int32
   */
  patch?: number;
  /**
   * Subtitle of the version.
   *
   */
  subtitle?: string;
  /**
   * Date when the version was approved.
   *
   * @format date
   */
  approved?: string | null;
  /**
   * Date when the version entry was created.
   *
   * @format date-time
   */
  createdAt?: string;
  /**
   * Product ID connected to this version.
   *
   */
  productId?: string;
  /**
   * Product name connected to this version.
   *
   */
  productName?: string;
  /**
   * Version stage.
   *
   */
  stage?: EVersionStage;
  /**
   * Summary of critical update. If empty, version is not critical.
   *
   */
  criticalUpdate?: string | null;
}

/** DTO for device query responses. */
export interface DeviceQueryModel {
  /**
   * Gets or sets the unique identifier for the device query.
   * @format guid
   */
  id?: string;
  /** Gets or sets the device identifier (Hardware-ID / HostID). */
  deviceId?: string | null;
  /** Kundenseitige Geräte-ID (z.B. "Maschine-Halle-3"). Wird vom Kunden beim Bestell-Flow gesetzt. */
  customerDeviceId?: string | null;
  /**
   * True, wenn dem Gerät bereits eine Hardware-ID zugewiesen wurde.
   * Wird vom Frontend genutzt, um Download-Aktionen zu gaten ("Hardware-ID noch nicht zugewiesen").
   */
  hardwareIdAssigned?: boolean;
  /** Gets or sets the name of the device. */
  name?: string;
  /** Gets or sets the name of the host system. */
  hostSystemName?: string | null;
  /** Gets or sets the operating system version. */
  osVersion?: string | null;
  /** Gets or sets the support code. */
  supportCode?: string | null;
  /** Gets or sets the status of the device. */
  deviceStatus?: DeviceStatusEnum;
  /** License code used for device registration. */
  licenseCode?: string;
  /**
   * Months of updates assigned to this device.
   * @format int32
   */
  updatesMonths?: number;
  /**
   * Date when the device was registered. Used for automatic update calculation.
   * @format date-time
   */
  registrationDate?: string | null;
  /**
   * Calculated date when updates expire (RegistrationDate + UpdatesMonths).
   * @format date-time
   */
  updatesExpirationDate?: string | null;
  /** Whether updates are still valid (before expiration date). */
  updatesValid?: boolean;
  /**
   * Count of assigned active licenses.
   * @format int32
   */
  licenseCount?: number;
  /**
   * Bereits lizenzierte Service-Einheiten (Summe über alle aktiven/genehmigten Lizenzen).
   * @format decimal
   */
  licensedServiceEinheiten?: number;
  /**
   * Angefragte Service-Einheiten (Summe über alle offenen Lizenzanfragen mit Status "Draft" oder "Requested").
   * @format decimal
   */
  requestedServiceEinheiten?: number;
  /** Customer ID from the associated support contract. */
  customerId?: string | null;
  /** Customer name from the associated support contract. */
  customerName?: string | null;
  /**
   * Interne Beschreibung der XML-Konfiguration. Quelle der semantischen
   * Suche; wird vom Support-Personal gepflegt (PUT /Device/{id}/ServiceBeschreibung).
   */
  serviceBeschreibung?: string | null;
  /**
   * Adresse des Anlagen-Standorts als Freitext. Gepflegt über
   * PUT /Device/{id}/Location.
   */
  locationAddress?: string | null;
  /** Normalisierte Adresse des Geocoding-Treffers, aus dem die Koordinaten stammen. */
  locationDisplayName?: string | null;
  /**
   * Breitengrad des Standorts (WGS84). Null, wenn noch nicht geocodiert.
   * @format double
   */
  locationLatitude?: number | null;
  /**
   * Längengrad des Standorts (WGS84). Null, wenn noch nicht geocodiert.
   * @format double
   */
  locationLongitude?: number | null;
  /** Postleitzahl des Standorts. */
  locationPostalCode?: string | null;
  /** Ort des Standorts. */
  locationCity?: string | null;
  /** ISO-3166-1-alpha-2 Ländercode des Standorts (z.B. "de"). */
  locationCountryCode?: string | null;
  /**
   * Zeitpunkt der letzten erfolgreichen Geocodierung.
   * @format date-time
   */
  locationGeocodedAt?: string | null;
}

/** Enum for the status of a device used for DeviceManagement */
export enum DeviceStatusEnum {
  Pending = "Pending",
  Active = "Active",
  Inactive = "Inactive",
  Deleted = "Deleted",
}

/** Model for changing device status. */
export interface SetDeviceStatusModel {
  /**
   * Internal device ID (Guid).
   * @format guid
   */
  deviceId?: string;
  /** New status to set. */
  newStatus?: DeviceStatusEnum;
}

/** Model for creating a new device (admin only). */
export interface CreateDeviceModel {
  /** Name of the device. */
  name?: string;
  /**
   * Optional device identifier (Hardware-ID / HostID).
   * Kunden dürfen diesen Wert nicht bei Anlage setzen - er wird später per AssignHostId zugewiesen.
   */
  deviceId?: string | null;
  /**
   * Kundenseitige Geräte-ID (z.B. "Maschine-Halle-3"). Für Kunden beim Bestell-Flow erforderlich,
   * für Admin/OFFICE optional. Eindeutig innerhalb eines SupportCodes.
   */
  customerDeviceId?: string | null;
  /**
   * Host system ID for the device. Determines which apps are displayed.
   * @format guid
   */
  hostSystemId?: string;
  /**
   * Months of updates assigned to this device. Defaults to 12 if not specified.
   * @format int32
   */
  updatesMonths?: number | null;
  /** Support code ID to assign this device to. Required for customers. */
  supportCodeId?: string | null;
  /**
   * Optionaler Standort der Anlage. Kommen keine Koordinaten mit, wird die
   * Adresse serverseitig geocodiert.
   */
  location?: SetDeviceLocationModel | null;
}

/** Setzt den Standort einer Anlage (Device). */
export interface SetDeviceLocationModel {
  /** Die Adresse des Standorts als Freitext (z.B. "Musterstraße 1, 12345 Berlin"). */
  address?: string;
  /**
   * Optionaler Breitengrad (WGS84). Nur zusammen mit Longitude gültig.
   * @format double
   */
  latitude?: number | null;
  /**
   * Optionaler Längengrad (WGS84). Nur zusammen mit Latitude gültig.
   * @format double
   */
  longitude?: number | null;
  /** Optionale normalisierte Adresse des ausgewählten Treffers. */
  displayName?: string | null;
  /** Optionale Postleitzahl des ausgewählten Treffers. */
  postalCode?: string | null;
  /** Optionaler Ort des ausgewählten Treffers. */
  city?: string | null;
  /** Optionaler ISO-3166-1-alpha-2 Ländercode des ausgewählten Treffers. */
  countryCode?: string | null;
}

/** Model for assigning a support code to a device. */
export interface AssignSupportCodeModel {
  /** Support code ID to assign to the device. */
  supportCodeId?: string;
}

/**
 * Request-Modell für das Setzen der internen Service-Beschreibung eines
 * Devices. Leerer/null Wert löscht die Beschreibung (und das zugehörige
 * Embedding wird beim nächsten Hintergrund-Lauf entfernt).
 */
export interface SetServiceBeschreibungModel {
  /**
   * Freitext-Beschreibung der XML-Konfiguration des Geräts. Wird für die
   * semantische Suche eingebettet (bge-m3).
   */
  serviceBeschreibung?: string | null;
}

/** Request-Modell für das Umbenennen einer Anlage (Device). */
export interface RenameDeviceModel {
  /** Neuer Anzeigename der Anlage. Darf nicht leer sein. */
  name?: string;
}

/** Model for updating device host system */
export interface UpdateDeviceHostSystemModel {
  /**
   * The new host system ID
   * @format guid
   */
  hostSystemId?: string;
}

/**
 * Request-Modell für die einmalige Zuweisung einer Hardware-ID (HostID) durch den Kunden
 * an ein bestelltes Pending-Gerät.
 */
export interface AssignHostIdModel {
  /** Die Hardware-ID (HostID) im Format XXXX-XXXX-XXXX-XXXX-XXXX. */
  hostId?: string;
}

/** Request model for releasing the host-id binding from a device. */
export interface ReleaseHostIdModel {
  /** Optional reason text that is stored in the audit log. */
  reason?: string | null;
}

/**
 * Represents a Bad Request Response.
 *
 */
export interface BadRequestResponse {
  /**
   * The HTTP Status code of the bad request.
   *
   * @format int32
   * @example 400
   */
  statusCode?: number;
  /**
   * Custom defined error message.
   *
   * @example "Invalid access rights"
   */
  message?: string;
  /**
   * Stack trace of the error if provided.
   *
   */
  stackTrace?: string | null;
}

export interface CloneDeviceModel {
  newHostId?: string | null;
  newDeviceName?: string | null;
}

/**
 * Data Transfer Object for shared file information
 * Used for returning file information to clients
 */
export interface SharedFileDto {
  /**
   * Unique identifier of the file, used for storage and reference
   * @format guid
   * @minLength 1
   */
  id: string;
  /**
   * Display title of the file (custom title or original filename)
   * @minLength 1
   */
  title: string;
  /**
   * File extension including the dot (e.g., ".pdf", ".xml")
   * @minLength 1
   */
  fileExtension: string;
  /**
   * Size of the file in bytes
   * @format int64
   */
  fileSize: number;
  /**
   * MIME type of the file (e.g., "application/pdf")
   * @minLength 1
   */
  contentType: string;
  /** Indicates whether this is a configuration file (XML/JSON) */
  isConfigFile: boolean;
  /**
   * ID of the support contract this file belongs to
   * @format guid
   * @minLength 1
   */
  supportContractId: string;
  /**
   * ID of the user who created/uploaded the file
   * @format guid
   * @minLength 1
   */
  createdById: string;
  /**
   * Display name of the user who created/uploaded the file
   * Can be null in rare cases
   */
  createdByName?: string | null;
  /**
   * Timestamp when the file was created
   * @format date-time
   * @minLength 1
   */
  created: string;
  /**
   * Timestamp when the file was last modified
   * @format date-time
   * @minLength 1
   */
  modified: string;
  /**
   * Actual filename used in storage (UUID + extension)
   * @minLength 1
   */
  storageFileName: string;
}

/**
 * HTTP Return value for host system data
 *
 */
export interface GetHostSystemData {
  /**
   * Internal id of the host system
   *
   */
  id?: string;
  /**
   * Public name
   * BosCompakt
   *
   */
  name?: string;
  /**
   * Minimum OS Version
   *
   */
  minVersion?: string;
  /**
   * Maximum OS Version
   *
   */
  maxVersion?: string;
  /**
   * Short description (for internal use)
   *
   */
  description?: string;
  /**
   * List of used filter tags for current host system
   *
   */
  filterTags?: GetFilterTagData[];
  /** Custom id for internal usage */
  hostSystemCustomId?: string | null;
  /** Indicates if this HostSystem is used for documentation instead of a real platform */
  isDocumentation?: boolean;
}

export interface AddHostSystemData {
  name?: string;
  minVersion?: string;
  maxVersion?: string | null;
  description?: string;
  filterTags?: string[];
  /** Custom id for internal usage */
  hostSystemCustomId?: string | null;
  /** Indicates if this HostSystem is used for documentation instead of a real platform */
  isDocumentation?: boolean;
}

export interface AddFileTypeData {
  /**
   * Common name of the file type
   *
   */
  name?: string;
  /**
   * Description of the file type
   *
   */
  description?: string;
  /**
   * Used filter tags for current file
   *
   */
  filterTags?: string[];
  /**
   * Platform-specific configurations for this FileType.
   * Each entry links the FileType to a HostSystem with platform-specific MatchingFiles.
   *
   */
  platformConfigurations?: AddFileTypePlatformConfigurationDto[];
  /**
   * Package identifier (used primarily for Android or iOS license generation).
   *
   */
  packageId?: string | null;
  /** Version used for creating the License Key */
  version?: number;
  /** File type variants for the current file type (empty list: only Default) */
  variants?: FileTypeVariantsDto[];
  /** File Type Class for filtering */
  type?: FileTypeClass;
  /** Value is shown on public endpoints */
  public?: boolean;
}

/**
 * DTO for adding a platform configuration to a FileType.
 *
 */
export interface AddFileTypePlatformConfigurationDto {
  /**
   * The HostSystem ID this configuration is for.
   *
   * @format guid
   */
  hostSystemId?: string;
  /**
   * Platform-specific matching file patterns.
   *
   */
  matchingFiles?: string[] | null;
}

/**
 * HTTP Post data to add new filter tag
 *
 */
export interface AddFilterTagData {
  /**
   * Individual identifier of the filter tag. Will be set by user
   *
   * @example "con_BosCompact"
   */
  identifier?: string;
  /**
   * Custom name to describe filter tag
   *
   * @example "BosCompact"
   */
  name?: string;
}

export interface StacktraceReportDto {
  /** @format int32 */
  buildId?: number;
  buildPipeline?: string;
  buildVersion?: string | null;
  debug?: boolean;
  identifier?: string | null;
  message?: string | null;
  exceptionType?: string | null;
  exceptionStacktrace?: string;
  addr2LineCmd?: string | null;
  osVersion?: string | null;
  platform?: string | null;
  systemName?: string | null;
  supportId?: string | null;
}

export interface WorkerHeartbeatDto {
  workerName?: string;
  version?: string | null;
  /** @format int32 */
  maxConcurrent?: number;
  /** @format int32 */
  running?: number;
  containerRuntimeAvailable?: boolean;
  availableImages?: string[];
  diagnostics?: string | null;
}

export interface AnalysisJobDto {
  /** @format guid */
  id?: string;
  kind?: AnalysisKind;
  /** @format int32 */
  buildId?: number;
  buildPipeline?: string;
  debug?: boolean;
  osVersion?: string | null;
  platform?: string | null;
  dumpFileName?: string | null;
  stacktrace?: StacktraceReportDto | null;
  /** @format int32 */
  attempts?: number;
}

export enum AnalysisKind {
  CoreDump = 0,
  Stacktrace = 1,
}

export interface ClaimJobRequestDto {
  workerName?: string;
  /** @format int32 */
  capacity?: number;
}

export interface AnalysisResultDto {
  kind?: AnalysisKind;
  symbolsAvailable?: boolean;
  signal?: string | null;
  faultAddress?: string | null;
  analyzerImage?: string | null;
  analyzerImageDigest?: string | null;
  threads?: AnalysisThreadDto[];
  rawOutput?: string | null;
  gdbMiRecords?: GdbMiRecord[] | null;
  diagnostics?: string[];
}

export interface AnalysisThreadDto {
  /** @format int32 */
  number?: number;
  name?: string | null;
  crashed?: boolean;
  frames?: AnalysisFrameDto[];
}

export interface AnalysisFrameDto {
  /** @format int32 */
  level?: number;
  module?: string | null;
  function?: string | null;
  file?: string | null;
  /** @format int32 */
  line?: number | null;
  /** @format uint64 */
  address?: number;
  /** @format uint64 */
  moduleOffset?: number;
  resolved?: boolean;
}

export interface GdbMiRecord {
  typeDiscriminator?: string;
}

export interface GetCoreDumpDTO {
  /**
   * Individual ID. Also filename on storage
   * Filename+Extension = Filename on Storage
   *
   * @format guid
   */
  id?: string;
  /**
   * The build number of the software.
   *
   * @format int32
   */
  buildId?: number;
  buildPipeline?: string;
  /**
   * Defines if the software is running in debug mode.
   *
   */
  debug?: boolean;
  /**
   * The OS name of the machine running the software.
   *
   */
  osName?: string;
  /**
   * The OS release of the machine running the software.
   *
   */
  osRelease?: string;
  /**
   * The platform the software is running on.
   *
   */
  platform?: string;
  /** Navigation property to the SupportCode */
  supportCode?: GetSupportCodeData | null;
  /**
   * The system name of the machine running the software.
   *
   */
  systemName?: string;
  /**
   * The version of the software.
   *
   */
  version?: GetVersionData | null;
  /**
   * Parameter if CoreDumpService sucessfully finished the coredump
   *
   * @format date-time
   */
  sucessfullyFinished?: string | null;
  /**
   * Parameter if CoreDumpService sucessfully finished the coredump
   *
   * @format date-time
   */
  created?: string | null;
  /** File deleted from storage */
  isDeletedFromStorage?: boolean;
  /**
   * Comment to the core dump by the service team
   *
   */
  serviceComment?: string;
  /** Error while handling GDB Data */
  error?: string | null;
  /** Not mapped colum to Serialize Metadata */
  metadata?: any;
}

/**
 * HTTP Return value for support code data
 *
 */
export interface GetSupportCodeData {
  /**
   * Support code id
   *
   */
  id?: string;
  /**
   * Date time when support code was created
   *
   * @format date-time
   */
  createdAt?: string;
  /**
   * Date time when support code was updated
   *
   * @format date-time
   */
  updatedAt?: string | null;
  /**
   * Support ID (will be generated by system)
   * AC3-B7Q
   *
   */
  supportId?: string;
  /**
   * Redirect url, where support code should redirect to
   *
   */
  redirectUrl?: string;
  /**
   * Name of the support code (can be used to describe the system)
   *
   */
  name?: string;
  /**
   * Generated url to generate QR code
   *
   *     https://support.reichert-gmbh.com/quicksupport?data=niubadifhb201823biadjbcoSDIUBF
   *
   *
   */
  customUrl?: string;
}

/**
 * HTTP GET of internal version data
 *
 */
export type GetVersionData = GetVersionDataCustomer & {
  /**
   * Internal information for office / development in company
   *
   */
  internalInformation?: string;
};

/**
 * HTTP GET of customer based version data
 *
 */
export type GetVersionDataCustomer = GetVersionDataPublic & {
  /**
   * Short description of the version
   *
   */
  description?: string;
  /** Header of version */
  header?: string | null;
  /** Footer of version */
  footer?: string | null;
  /**
   * Version stage. Used to display version stage in UI
   *
   */
  stage?: EVersionStage;
  /**
   * Summary of critical version. If empty current version is NOT a critical version.
   *
   */
  criticalUpdate?: string | null;
  /**
   * Date on which the version was revoked. null if not revoked.
   * A revoked version is still visible but should be displayed with a hint.
   *
   * @format date
   */
  revokedAt?: string | null;
  /**
   * Optional reason text shown when the version is revoked.
   *
   */
  revokedReason?: string | null;
  /**
   * When true downloads of this version are blocked. The version itself stays visible.
   *
   */
  downloadBlocked?: boolean;
  /**
   * Optional reason text shown when the download is blocked.
   *
   */
  downloadBlockedReason?: string | null;
  /**
   * List of downloadable files
   *
   */
  files?: VersionVersionFileData[];
};

export interface VersionVersionFileData {
  id?: string;
  fileName?: string;
  /**
   * Represents the data structure for a file type, including associated host system,
   * matching files, and filter tags.
   */
  type?: GetFileTypeData;
  /**
   * HostSystem/Platform for this file (Windows, Android, iOS, etc.)
   * @format guid
   */
  hostSystemId?: string | null;
  /** HostSystem/Platform name */
  hostSystemName?: string | null;
  /**
   * Users (Mitarbeiter / SPA-Login) that have downloaded this file.
   * Only populated for OFFICE/DEVELOPMENT requests.
   */
  downloadedBy?: GetUserDataShort[];
  /**
   * Geräte (Device-Auth via LicenseCode/SupportCode) die diese Datei
   * heruntergeladen haben — typischer Kundenfall.
   * Nur für OFFICE/DEVELOPMENT befüllt.
   */
  downloadedByDevice?: DownloadedByDeviceInfo[];
}

/**
 * Short user data e.G. for list of users which downloaded a file
 *
 */
export interface GetUserDataShort {
  /**
   * UUID of the User
   *
   * @format guid
   */
  id?: string;
  /**
   * Email of the user
   *
   */
  name?: string;
  /**
   * Email of the user
   *
   */
  eMail?: string;
}

/** Slim projection of a Devices entry für die Download-Liste. */
export interface DownloadedByDeviceInfo {
  /**
   * Device-PK.
   * @format guid
   */
  id?: string;
  /** Anzeigename des Geräts. */
  name?: string;
  /** Hardware-/Device-Identifier (falls registriert). */
  deviceId?: string | null;
  /** Vom Kunden vergebener Identifier (z.B. Fahrzeug-Nr.). */
  customerDeviceId?: string | null;
  /** Kundenname, falls Gerät über einen SupportCode-/Vertrags-Bezug verfügt. */
  customerName?: string | null;
}

/**
 * HTTP GET of public version data
 *
 */
export interface GetVersionDataPublic {
  /**
   * Version ID as computed string.
   *
   */
  versionId?: string;
  /**
   * Major version as number
   *
   * @format int32
   */
  major?: number;
  /**
   * Minor version as number
   *
   * @format int32
   */
  minor?: number;
  /**
   * Patch version as number
   *
   * @format int32
   */
  patch?: number;
  /**
   * Subtitle of the version (first line to describe content)
   *
   */
  subtitle?: string;
  /**
   * Version changes as object
   *
   */
  changes?: VersionChanges;
  /**
   * DateTime when version was approved
   *
   * @format date
   */
  approved?: string | null;
  /** Cild versions of the current version. Can also be null */
  childVersions?: GetVersionData[] | null;
  /** Id of product connected to this version */
  productId?: string;
}

/**
 * Version changes structure for storage as JSON in Databaseö
 *
 */
export interface VersionChanges {
  /**
   * List of bugfixes as list of strings
   *
   */
  bugfixes?: string[];
  /**
   * List of features as list of strings
   *
   */
  features?: string[];
  /**
   * List of highlights as list of strings
   *
   */
  highlights?: string[];
}

/**
 * State of a registered crash analysis worker, as shown to operators.
 *
 */
export interface AnalysisWorkerDTO {
  /**
   * Stable name of the worker.
   *
   */
  name?: string;
  /**
   * Assembly version the worker reported.
   *
   */
  version?: string | null;
  /**
   * Time of the last heartbeat.
   *
   * @format date-time
   */
  lastSeen?: string;
  /**
   * Whether the last heartbeat is recent enough for the worker to count as available.
   *
   */
  alive?: boolean;
  /**
   * How many jobs the worker runs in parallel at most.
   *
   * @format int32
   */
  maxConcurrent?: number;
  /**
   * How many jobs the worker was running at its last heartbeat.
   *
   * @format int32
   */
  running?: number;
  /**
   * Whether the worker's container runtime answered its startup probe.
   *
   */
  containerRuntimeAvailable?: boolean;
  /**
   * Analyzer images the worker has available locally.
   *
   */
  availableImages?: string[];
  /**
   * Reason the worker reported itself unavailable, when it did.
   *
   */
  diagnostics?: string | null;
}

/** Ein Geocoding-Treffer, wie ihn die API an den Client liefert. */
export interface GeocodeResultModel {
  /** Vollständige, normalisierte Adresse des Treffers (Anzeigetext). */
  displayName?: string;
  /**
   * Breitengrad (WGS84).
   * @format double
   */
  latitude?: number;
  /**
   * Längengrad (WGS84).
   * @format double
   */
  longitude?: number;
  /** Straße inkl. Hausnummer, sofern der Treffer so genau ist. */
  street?: string | null;
  /** Postleitzahl des Treffers. */
  postalCode?: string | null;
  /** Ort des Treffers. */
  city?: string | null;
  /** ISO-3166-1-alpha-2 Ländercode (z.B. "de"). */
  countryCode?: string | null;
}

/** Die aktuell wirksamen Geocoding-Einstellungen für die Verwaltungs-UI. */
export interface GeocodingSettingsDto {
  /** Master-Schalter. Bei false werden Adressen ohne Koordinaten gespeichert. */
  enabled?: boolean;
  /** Basis-URL der Nominatim-Instanz. */
  baseUrl?: string;
  /** User-Agent für ausgehende Anfragen — laut Usage-Policy Pflicht. */
  userAgent?: string;
  /** Kontakt-E-Mail, die als email-Parameter mitgeschickt wird. */
  contactEmail?: string;
  /** Bevorzugte Sprache der Ergebnisse. */
  language?: string;
  /** Länder-Einschränkung als Komma-Liste von ISO-Codes. Leer = weltweit. */
  countryCodes?: string;
  /**
   * Maximale Trefferzahl pro Suchanfrage.
   * @format int32
   */
  maxResults?: number;
  /**
   * Timeout einer einzelnen HTTP-Anfrage in Sekunden.
   * @format int32
   */
  timeoutSeconds?: number;
  /**
   * Mindestabstand zwischen zwei Anfragen in Millisekunden.
   * @format int32
   */
  minRequestIntervalMs?: number;
  /**
   * Cache-Dauer für Treffer in Minuten. 0 = nicht cachen.
   * @format int32
   */
  cacheMinutes?: number;
  /**
   * true, wenn die Pflichtangaben vorliegen. Ist Enabled gesetzt,
   * dies aber nicht, ist die Anbindung halb konfiguriert.
   */
  isComplete?: boolean;
}

/**
 * Änderung der Geocoding-Einstellungen. Vollständige PUT-Semantik: alle Felder
 * werden übernommen.
 */
export interface UpdateGeocodingSettingsRequest {
  /** Master-Schalter der Geocodierung. */
  enabled?: boolean;
  /** Basis-URL der Nominatim-Instanz (absolute http/https-URL). */
  baseUrl?: string;
  /**
   * User-Agent für ausgehende Anfragen. Muss den Betreiber erkennbar machen —
   * die öffentliche Instanz blockt anonyme Anfragen.
   */
  userAgent?: string;
  /** Kontakt-E-Mail. Leer lassen, um den Parameter wegzulassen. */
  contactEmail?: string | null;
  /** Bevorzugte Sprache der Ergebnisse (z.B. de). */
  language?: string;
  /**
   * Länder-Einschränkung als Komma-Liste von ISO-3166-1-alpha-2 Codes (z.B. de,at,ch).
   * Leer = weltweit suchen.
   */
  countryCodes?: string | null;
  /**
   * Maximale Trefferzahl pro Suchanfrage (1–50).
   * @format int32
   */
  maxResults?: number;
  /**
   * Timeout einer einzelnen HTTP-Anfrage in Sekunden (1–120).
   * @format int32
   */
  timeoutSeconds?: number;
  /**
   * Mindestabstand zwischen zwei Anfragen in Millisekunden (0–60000). Für die
   * öffentliche Instanz nicht unter 1000 setzen — die Usage-Policy erlaubt
   * maximal eine Anfrage pro Sekunde.
   * @format int32
   */
  minRequestIntervalMs?: number;
  /**
   * Cache-Dauer für Treffer in Minuten (0–1440). 0 = nicht cachen.
   * @format int32
   */
  cacheMinutes?: number;
}

/**
 * Ergebnis eines Verbindungstests gegen die konfigurierte Nominatim-Instanz.
 * Liefert Klartext statt eines Fehlers im Server-Log, damit die Einrichtung
 * ohne Konsolenzugriff verifizierbar ist.
 */
export interface GeocodingTestResultDto {
  /** Hat die Testanfrage funktioniert? */
  success?: boolean;
  /** Ergebnis in Klartext (auch im Fehlerfall gefüllt). */
  message?: string;
  /**
   * Dauer des Versuchs.
   * @format int64
   */
  elapsedMilliseconds?: number;
  /**
   * Anzahl der Treffer. null, wenn die Anfrage fehlgeschlagen ist.
   * @format int32
   */
  resultCount?: number | null;
  /** Der erste Treffer als Stichprobe. null, wenn es keinen gab. */
  firstResult?: GeocodeResultModel | null;
}

/** Daten-Repräsentation eines Jobs für API-Antworten und SignalR-Events. */
export interface GeodataConversionJobInfo {
  /** @format guid */
  id?: string;
  /** Lebenszyklus einer Tile-Konvertierung. */
  status?: GeodataConversionJobStatus;
  /** Output-Format der Konvertierung. */
  outputFormat?: GeodataConversionOutputFormat;
  inputFileName?: string;
  /** @format int64 */
  inputSizeBytes?: number;
  outputFileName?: string | null;
  /** @format int64 */
  outputSizeBytes?: number | null;
  /** @format int32 */
  progressPercent?: number;
  statusMessage?: string | null;
  errorMessage?: string | null;
  /** @format date-time */
  createdAt?: string;
  /** @format date-time */
  startedAt?: string | null;
  /** @format date-time */
  completedAt?: string | null;
  /** @format date-time */
  expiresAt?: string | null;
  /** @format guid */
  createdByUserId?: string | null;
  createdByUserName?: string | null;
}

/** Lebenszyklus einer Tile-Konvertierung. */
export enum GeodataConversionJobStatus {
  Queued = 0,
  Running = 1,
  Completed = 2,
  Failed = 3,
  Cancelled = 4,
  Expired = 5,
}

/** Output-Format der Konvertierung. */
export enum GeodataConversionOutputFormat {
  Mbtiles = 0,
  Pmtiles = 1,
}

/**
 * Snapshot des Preflight-Ergebnisses. Wird vom GeodataConversionPreflightService
 * einmal beim Start gesetzt und danach nicht mehr verändert.
 */
export interface GeodataConversionAvailabilityState {
  isAvailable?: boolean;
  /** Begründung in Klartext (für Logs und 503-Response). */
  reason?: string;
  /** "native" oder "docker" — was tatsächlich beim Preflight probiert wurde. */
  executionMode?: string;
  /** Output-Snippet aus dem Preflight (z.B. tilemaker-Versionszeile). */
  detail?: string | null;
  /** @format date-time */
  checkedAt?: string;
}

/** Response-Modell für Host-ID Informationen */
export interface HostIdResponse {
  /** Die vollständige Host-ID (24 Zeichen) */
  hostid?: string;
  /** Ob die Checksumme gültig ist */
  checksum_valid?: boolean;
  /**
   * Das Checksummen-Byte
   * @format int32
   */
  checksum_byte?: number;
  /**
   * OS-Typ ID (0=Linux, 1=Windows, 2=macOS, 3=iOS, 4=Android)
   * @format int32
   */
  os_type_id?: number;
  /** OS-Typ als lesbarer String */
  os_type?: string;
  /**
   * Identifier-Quellen ID (0=System UUID, 1=Ethernet MAC, 2=WiFi MAC, 3=Other MAC, 4=Generated Token)
   * @format int32
   */
  identifier_source_id?: number;
  /** Identifier-Quelle als lesbarer String */
  identifier_source?: string;
  /**
   * Ausführungskontext ID (0=Real Hardware, 1=Virtual Machine, 2=Container)
   * @format int32
   */
  execution_context_id?: number;
  /** Ausführungskontext als lesbarer String */
  execution_context?: string;
}

/** Response-Modell für Bibliotheksversion */
export interface HostIdVersionResponse {
  /** Ob die Bibliothek verfügbar ist */
  available?: boolean;
  /** Version der Bibliothek */
  version?: string;
}

/**
 * Die Einstellungen der LabelConnect-Anbindung für die Verwaltungs-Oberfläche — ohne den
 * API-Schlüssel, nur mit dem Hinweis, ob einer hinterlegt ist.
 *
 */
export interface LabelConnectSettingsDto {
  /** Master-Schalter der Anbindung. */
  enabled?: boolean;
  /** Basis-URL des LabelConnect-Dienstes. */
  baseUrl?: string;
  /** Ist ein API-Schlüssel hinterlegt? */
  apiKeyConfigured?: boolean;
  /**
   * Zeitlimit einer einzelnen Anfrage in Sekunden.
   * @format int32
   */
  timeoutSeconds?: number;
  /** Darf in die Labelwin-Plantafel geschrieben werden? */
  allowWrites?: boolean;
  /**
   * Haltezeit der Mitarbeiterliste in Minuten.
   * @format int32
   */
  employeeCacheMinutes?: number;
  /**
   * Vorgabespanne einer Kalenderabfrage in Tagen.
   * @format int32
   */
  defaultRangeDays?: number;
  /**
   * Obergrenze der Spanne einer Kalenderabfrage in Tagen.
   * @format int32
   */
  maxRangeDays?: number;
  /** Zeitzone der Plantafel (IANA-Kennung). */
  timeZone?: string;
  /** Liegen alle Pflichtangaben vor? */
  isComplete?: boolean;
  /**
   * Es liegt ein gespeicherter Schlüssel vor, der sich nicht entschlüsseln lässt — dann muss er
   * neu eingegeben werden.
   *
   */
  apiKeyUnreadable?: boolean;
}

/**
 * Neue Einstellungen der LabelConnect-Anbindung (vollständige PUT-Semantik).
 *
 */
export interface UpdateLabelConnectSettingsRequest {
  /** Master-Schalter der Anbindung. */
  enabled?: boolean;
  /** Basis-URL des LabelConnect-Dienstes. */
  baseUrl?: string;
  /**
   * Der API-Schlüssel. null lässt den gespeicherten Wert unverändert (das Formular
   * schickt Geheimnisse nicht bei jedem Speichern erneut mit), "" löscht ihn.
   *
   */
  apiKey?: string | null;
  /**
   * Zeitlimit einer einzelnen Anfrage in Sekunden.
   * @format int32
   */
  timeoutSeconds?: number;
  /** Darf in die Labelwin-Plantafel geschrieben werden? */
  allowWrites?: boolean;
  /**
   * Haltezeit der Mitarbeiterliste in Minuten.
   * @format int32
   */
  employeeCacheMinutes?: number;
  /**
   * Vorgabespanne einer Kalenderabfrage in Tagen.
   * @format int32
   */
  defaultRangeDays?: number;
  /**
   * Obergrenze der Spanne einer Kalenderabfrage in Tagen.
   * @format int32
   */
  maxRangeDays?: number;
  /** Zeitzone der Plantafel (IANA-Kennung, z. B. Europe/Berlin). */
  timeZone?: string;
}

/**
 * Ergebnis des Verbindungstests gegen LabelConnect. Antwortet auch im Fehlerfall mit HTTP 200;
 * die Ursache steht in Message.
 *
 */
export interface LabelConnectTestResultDto {
  /** Hat der Test funktioniert? */
  success?: boolean;
  /** Klartext-Ergebnis für die Anzeige. */
  message?: string;
  /**
   * Dauer des Tests.
   * @format int64
   */
  elapsedMilliseconds?: number;
  /**
   * Anzahl der gelesenen Mitarbeiter, sofern die Abfrage durchlief.
   * @format int32
   */
  employeeCount?: number | null;
  /**
   * Der zum LabelBenutzer des Prüfers passende Mitarbeiter. Zeigt in einem Schritt, ob die
   * Anbindung steht und ob die Personenzuordnung greift.
   *
   */
  matchedEmployee?: CalendarEmployeeDto | null;
}

/**
 * Die Einstellungen der Microsoft-365-Anbindung für die Verwaltungs-Oberfläche — ohne den
 * geheimen Clientschlüssel, nur mit dem Hinweis, ob einer hinterlegt ist.
 *
 */
export interface O365SettingsDto {
  /** Master-Schalter der Anbindung. */
  enabled?: boolean;
  /** Verzeichnis-ID (Mandant) der App-Registrierung. */
  tenantId?: string;
  /** Anwendungs-ID (Client) der App-Registrierung. */
  clientId?: string;
  /** Ist ein geheimer Clientschlüssel hinterlegt? */
  clientSecretConfigured?: boolean;
  /**
   * Zeitlimit einer einzelnen Graph-Anfrage in Sekunden.
   * @format int32
   */
  timeoutSeconds?: number;
  /** Liegen alle Pflichtangaben vor? */
  isComplete?: boolean;
  /**
   * Es liegt ein gespeicherter Schlüssel vor, der sich nicht entschlüsseln lässt — dann muss er
   * neu eingegeben werden.
   *
   */
  clientSecretUnreadable?: boolean;
}

/**
 * Neue Einstellungen der Microsoft-365-Anbindung (vollständige PUT-Semantik).
 *
 */
export interface UpdateO365SettingsRequest {
  /** Master-Schalter der Anbindung. */
  enabled?: boolean;
  /** Verzeichnis-ID (Mandant) — GUID oder Mandanten-Domain wie firma.onmicrosoft.com. */
  tenantId?: string;
  /** Anwendungs-ID (Client) — eine GUID. */
  clientId?: string;
  /**
   * Der geheime Clientschlüssel (der Wert, nicht die Geheimnis-ID). null lässt den
   * gespeicherten Wert unverändert (das Formular schickt Geheimnisse nicht bei jedem Speichern
   * erneut mit), "" löscht ihn.
   *
   */
  clientSecret?: string | null;
  /**
   * Zeitlimit einer einzelnen Graph-Anfrage in Sekunden.
   * @format int32
   */
  timeoutSeconds?: number;
}

/**
 * Anfrage für den Verbindungstest.
 *
 */
export interface TestO365ConnectionRequest {
  /**
   * Postfach, dessen Kalender probeweise gelesen wird. Ohne Angabe der UPN des angemeldeten
   * Kontos — die Angabe hilft, wenn der prüfende Admin selbst kein AD-Konto hat.
   *
   */
  userPrincipalName?: string | null;
}

/**
 * Ein Schritt des Verbindungstests. Die Stufen zeigen, welcher Teil der Einrichtung
 * fehlt: Anmeldung schlägt fehl = Mandant/Client/Schlüssel falsch, Kalenderzugriff schlägt
 * fehl = Berechtigung, Admin-Zustimmung oder Zugriffsrichtlinie.
 *
 */
export interface O365TestStepDto {
  /** Kurzname des Schritts für die Anzeige. */
  name?: string;
  /** true/false, oder null wenn nicht ausgeführt. */
  success?: boolean | null;
  /** Klartext-Ergebnis des Schritts. */
  detail?: string;
}

/**
 * Eine Graph-Berechtigung, die das Support-System für eine bestimmte Fähigkeit braucht.
 *
 */
export interface O365PermissionDto {
  /** Der Name, wie er im Entra-Portal steht (z. B. Calendars.Read). */
  name?: string;
  /** Ist sie der App-Registrierung erteilt und zugestimmt? */
  granted?: boolean;
  /** Muss sie vorhanden sein, damit der Grundbetrieb funktioniert? */
  required?: boolean;
  /** Wofür sie gebraucht wird — in Klartext, nicht als Berechtigungsjargon. */
  purpose?: string;
}

/**
 * Welche Berechtigungen die App-Registrierung tatsächlich hat. Gelesen aus dem Zugriffstoken
 * selbst, in das Microsoft die erteilten Anwendungsberechtigungen schreibt.
 *
 */
export interface O365PermissionsDto {
  /** Konnte ein Token geholt und gelesen werden? */
  available?: boolean;
  /** Klartext-Ergebnis für die Anzeige. */
  message?: string;
  /** Der Mandant, für den das Token ausgestellt wurde. */
  tenantId?: string | null;
  /** Alle erteilten Berechtigungen, wie sie im Token stehen. */
  granted?: string[];
  /** Die vom Support-System benutzten Berechtigungen samt Zweck und Zustand. */
  capabilities?: O365PermissionDto[];
}

/**
 * Der Teams-Status einer Person. Der Kalender sagt, was geplant ist, die Präsenz, was gerade ist.
 *
 */
export interface TeamsPresenceDto {
  /**
   * available, availableIdle, away, beRightBack, busy, busyIdle, doNotDisturb, offline oder
   * presenceUnknown.
   */
  availability?: string | null;
  /** Feinere Angabe, z. B. inACall, inAMeeting, presenting. */
  activity?: string | null;
}

/**
 * Ergebnis des Verbindungstests gegen Microsoft Graph. Antwortet auch im Fehlerfall mit
 * HTTP 200; die Ursache steht in Message und den Schritten.
 *
 */
export interface O365TestResultDto {
  /** Haben alle Schritte funktioniert? */
  success?: boolean;
  /** Klartext-Gesamtergebnis für die Anzeige. */
  message?: string;
  /**
   * Dauer des Tests.
   * @format int64
   */
  elapsedMilliseconds?: number;
  /** Die Einzelschritte mit ihren Ergebnissen. */
  steps?: O365TestStepDto[];
  /** Das Postfach, gegen das der Kalenderzugriff geprüft wurde. */
  userPrincipalName?: string | null;
  /**
   * Anzahl der Termine der nächsten 7 Tage, sofern der Kalenderzugriff durchlief — macht den
   * Erfolg greifbar.
   * @format int32
   */
  eventCount?: number | null;
}

/**
 * Ob das eigene Konto auf AD-Anmeldung umgestellt werden kann — und wenn nicht, warum.
 * Antwortet immer mit HTTP 200.
 *
 */
export interface AdConversionStatusDto {
  /** Kann die Umstellung angeboten werden? */
  eligible?: boolean;
  /** Läuft die Anmeldung bereits über das AD? */
  alreadyConnected?: boolean;
  /** Der hinterlegte Benutzerprinzipalname, sofern vorhanden. */
  userPrincipalName?: string | null;
  /**
   * Das im AD erkannte Konto — damit die Person vor der Umstellung sieht, wer sie aus
   * Sicht des Verzeichnisses ist. null, wenn ohne Service-Account keine Suche möglich ist
   * oder kein Konto gefunden wurde (der Unterschied steht in Message).
   *
   */
  account?: AdConversionAccountDto | null;
  /** Klartext-Begründung für die Anzeige — immer gesetzt. */
  message?: string;
}

/**
 * Das im Active Directory erkannte Konto einer Person.
 *
 */
export interface AdConversionAccountDto {
  /** Anzeigename aus dem Verzeichnis. */
  displayName?: string;
  /** Der UPN, mit dem angemeldet wird. */
  userPrincipalName?: string;
  /** Die im AD hinterlegte E-Mail-Adresse. */
  mail?: string;
}

/**
 * Anfrage zur Umstellung des eigenen Kontos auf AD-Anmeldung.
 *
 */
export interface ConvertToAdRequest {
  /** Das AD-Passwort — der Besitznachweis für das AD-Konto. Wird nie gespeichert. */
  password?: string;
  /**
   * Optional der AD-Anmeldename (sAMAccountName oder UPN), falls er sich nicht aus der
   * Konto-Mail ableiten lässt — z. B. pnies bei der Konto-Mail patrick.nies@…. Ohne Angabe
   * wird mit der Konto-Mail gesucht.
   *
   */
  identifier?: string | null;
}

/**
 * Ergebnis einer erfolgreichen Umstellung auf AD-Anmeldung.
 *
 */
export interface AdConversionResultDto {
  /** Der ab jetzt hinterlegte Benutzerprinzipalname. */
  userPrincipalName?: string;
  /** Die Rolle nach der Umstellung (aus den AD-Gruppen, nie schlechter als vorher). */
  role?: EUserGroup;
  /** Klartext-Zusammenfassung für die Anzeige. */
  message?: string;
}

/**
 * Die Zielwerte, mit denen LabelConnect in Projdat schreibt — bisher fest im Code verdrahtet,
 * jetzt von außen änderbar.
 *
 */
export interface LabelwinConfigurationDto {
  /**
   * Projekt für Kontakte und Aufgaben aus dem Support-System (projgrund.lfdnr).
   * @format int32
   */
  defaultProjectId?: number;
  /**
   * Zugehörige Projektnummer (projgrund.projektnr). Wird von LabelConnect automatisch
   * nachgeschlagen und ist deshalb nur lesbar — so können Id und Nummer nicht auseinanderlaufen.
   *
   */
  defaultProjectNumber?: string | null;
  /**
   * Projekt für Support-Zeitbuchungen (projgrund.lfdnr).
   * @format int32
   */
  serviceProjectId?: number;
  /**
   * Stundenart der Zeitbuchung (stundenart.lfdnr), 31 = „Support".
   * @format int32
   */
  supportHourTypeId?: number;
  /**
   * Mitarbeiter für Datensätze aus dem Support (personal.montnr).
   * @format int32
   */
  supportEmployeeId?: number;
  /**
   * Mitarbeiter für Datensätze des Büros (personal.montnr).
   * @format int32
   */
  officeEmployeeId?: number;
  /**
   * Auftragsart.
   * @format int32
   */
  orderTypeId?: number;
  /**
   * Priorität.
   * @format int32
   */
  priorityId?: number;
  /**
   * Zeitpunkt der letzten Änderung (UTC), null solange die Vorgaben gelten.
   * @format date-time
   */
  changedAt?: string | null;
  /** LabelBenutzer, der zuletzt geändert hat. */
  changedBy?: string | null;
}

/**
 * Änderung an der LabelConnect-Konfiguration. Nur übergebene Felder werden geändert, der Rest
 * bleibt stehen (PATCH-Semantik).
 *
 */
export interface UpdateLabelwinConfigurationRequest {
  /**
   * Neues Projekt für Kontakte und Aufgaben.
   * @format int32
   */
  defaultProjectId?: number | null;
  /**
   * Neues Projekt für Support-Zeitbuchungen.
   * @format int32
   */
  serviceProjectId?: number | null;
  /**
   * Neue Stundenart der Zeitbuchung.
   * @format int32
   */
  supportHourTypeId?: number | null;
  /**
   * Neuer Mitarbeiter für Support-Datensätze.
   * @format int32
   */
  supportEmployeeId?: number | null;
  /**
   * Neuer Mitarbeiter für Büro-Datensätze.
   * @format int32
   */
  officeEmployeeId?: number | null;
  /**
   * Neue Auftragsart.
   * @format int32
   */
  orderTypeId?: number | null;
  /**
   * Neue Priorität.
   * @format int32
   */
  priorityId?: number | null;
  /** Ist überhaupt ein Feld gesetzt? */
  hasAnyValue?: boolean;
}

/**
 * Ein Projekt aus projgrund für die Auswahlliste — damit die Oberfläche ein Zielprojekt
 * anbieten kann, ohne interne Ids zu kennen.
 *
 */
export interface LabelwinProjectDto {
  /**
   * Interne Id (projgrund.lfdnr).
   * @format int32
   */
  projectId?: number;
  /** Projektnummer (projgrund.projektnr), z. B. 26-9001. */
  projectNumber?: string | null;
  /** Bezeichnung. */
  description?: string | null;
  /** Ort. */
  location?: string | null;
  /** Status, z. B. in_Arbeit. */
  status?: string | null;
}

/**
 * Die aktuell wirksamen LDAP-Verbindungseinstellungen für die Verwaltungs-UI.
 * Enthält bewusst kein Passwort — nur die Information, ob eines konfiguriert ist.
 *
 */
export interface LdapSettingsDto {
  /** Ist der LDAP-Login aktiv? */
  enabled?: boolean;
  /** FQDN des Domain-Controllers. */
  host?: string;
  /**
   * TCP-Port.
   * @format int32
   */
  port?: number;
  /** Verbindung direkt in TLS wickeln. */
  useLdaps?: boolean;
  /** Vor dem Bind per StartTLS hochziehen. */
  useStartTls?: boolean;
  /** Zertifikatsprüfung übersprungen (nur Dev/Staging). */
  acceptAnyCertificate?: boolean;
  /** Standard-UPN-Suffix für Logins ohne @. */
  upnSuffix?: string;
  /** Suchen laufen über den Service-Account statt über die Benutzerverbindung. */
  useServiceAccount?: boolean;
  /** UPN des Read-Only-Service-Accounts (nur relevant bei UseServiceAccount). */
  serviceAccountUpn?: string;
  /** Basis-DN der Benutzerobjekte. */
  baseDn?: string;
  /** Container-DN der Gruppen. */
  groupContainerDn?: string;
  /**
   * Connect-Timeout in Sekunden.
   * @format int32
   */
  connectTimeoutSeconds?: number;
  /**
   * true, wenn Ldap__ServiceAccountPassword gesetzt ist. Das Passwort selbst wird
   * nie ausgeliefert und nie in der Datenbank gespeichert.
   *
   */
  serviceAccountPasswordConfigured?: boolean;
  /**
   * true, wenn die Pflichtangaben für einen Verbindungsversuch vorliegen. Ist
   * Enabled gesetzt, aber dies nicht, ist die Anbindung halb konfiguriert
   * und der LDAP-Login bleibt inaktiv.
   *
   */
  isComplete?: boolean;
}

/**
 * Änderung der LDAP-Verbindungseinstellungen. Vollständige PUT-Semantik: alle Felder werden
 * übernommen. Das Service-Account-Passwort ist absichtlich nicht enthalten.
 *
 */
export interface UpdateLdapSettingsRequest {
  /** Master-Schalter des LDAP-Logins. */
  enabled?: boolean;
  /** FQDN des Domain-Controllers. */
  host?: string;
  /**
   * TCP-Port (1–65535).
   * @format int32
   */
  port?: number;
  /** Verbindung direkt in TLS wickeln. */
  useLdaps?: boolean;
  /** Vor dem Bind per StartTLS hochziehen. */
  useStartTls?: boolean;
  /** Zertifikatsprüfung überspringen — nur Dev/Staging. */
  acceptAnyCertificate?: boolean;
  /** Standard-UPN-Suffix für Logins ohne @ (z. B. reichert-gmbh.local). */
  upnSuffix?: string | null;
  /**
   * Suchen über den Service-Account statt über die Verbindung des sich anmeldenden Benutzers.
   * Nur einschalten, wenn das AD normalen Benutzern das Lesen von Gruppen verweigert.
   *
   */
  useServiceAccount?: boolean;
  /** UPN des Read-Only-Service-Accounts. */
  serviceAccountUpn?: string | null;
  /** Basis-DN der Benutzerobjekte. */
  baseDn?: string;
  /** Container-DN der Gruppen. Leer ⇒ BaseDn. */
  groupContainerDn?: string | null;
  /**
   * Connect-Timeout in Sekunden (1–120).
   * @format int32
   */
  connectTimeoutSeconds?: number;
  /**
   * Passwort des Service-Accounts. null (bzw. weggelassen) lässt ein bereits gespeichertes
   * Passwort unverändert — nur so kann das Formular gespeichert werden, ohne das Geheimnis erneut
   * durch den Browser zu schicken. Ein leerer String löscht das gespeicherte Passwort.
   * Gespeichert wird ausschließlich verschlüsselt (ASP.NET DataProtection); ausgeliefert wird es nie.
   *
   */
  serviceAccountPassword?: string | null;
}

/**
 * Ergebnis der Auto-Konfiguration. Enthält einen fertigen Einstellungs-Vorschlag, der nach
 * Sichtprüfung unverändert an PUT /LdapAdmin/Settings zurückgeschickt werden kann.
 *
 */
export interface LdapDiscoveryResultDto {
  /** Konnte eine Verbindung aufgebaut und das Verzeichnis gelesen werden? */
  success?: boolean;
  /** Ergebnis in Klartext. */
  message?: string;
  /** Der Einstellungs-Vorschlag, oder null bei Fehlschlag. */
  proposal?: UpdateLdapSettingsRequest | null;
  /** Der aus dem RootDSE gelesene FQDN des Domain-Controllers. */
  detectedDcHostName?: string | null;
  /** Der aus dem RootDSE gelesene defaultNamingContext. */
  detectedBaseDn?: string | null;
  /** Hinweise, die vor dem Speichern gelesen werden sollten (z. B. unverschlüsselte Verbindung). */
  warnings?: string[];
  /** Die Gruppen, in denen das angegebene Konto (transitiv) Mitglied ist — die naheliegendsten Kandidaten. */
  yourGroups?: LdapGroupDto[];
  /** Alle gefundenen Gruppen unter dem BaseDn, für die freie Zuordnung. */
  allGroups?: LdapGroupDto[];
}

/**
 * Eine im AD gefundene Gruppe. Vorlage für die Auswahl in der UI, damit CNs nicht getippt
 * werden müssen — ein Tippfehler würde sonst nur als stumme Login-Ablehnung auffallen.
 *
 */
export interface LdapGroupDto {
  /** Common Name der Gruppe — der Wert für LdapGroupCn. */
  cn?: string;
  /** Distinguished Name (Anzeige/Debug). */
  dn?: string;
  /** Beschreibung aus dem AD, falls gesetzt. */
  description?: string | null;
  /**
   * Anzahl direkter Mitglieder, falls ermittelbar.
   * @format int32
   */
  memberCount?: number | null;
  /**
   * Namen der Berechtigungs-Gruppen, die bereits auf diese CN verweisen. Zeigt in der UI, was
   * schon verknüpft ist.
   *
   */
  linkedPermissionGroups?: string[];
}

/**
 * Eingabe des Einrichtungs-Assistenten: ein Domain-Login. Alles Weitere wird daraus ermittelt.
 *
 */
export interface LdapDiscoveryRequest {
  /** Anmeldename inkl. Domain, z. B. patrick.nies@reichert-gmbh.local. */
  upn?: string;
  /** Passwort dieses Kontos. Wird nur für die Discovery verwendet und nicht gespeichert. */
  password?: string;
  /**
   * Optionaler DC-Host. Nur nötig, wenn der Server die Domain nicht per DNS auflösen kann —
   * normalerweise leer lassen.
   *
   */
  host?: string | null;
}

/**
 * Ergebnis eines Verbindungstests. Liefert Klartext statt eines Bind-Fehlers im Log, damit die
 * Einrichtung ohne ldapsearch-Zugriff auf dem Server verifizierbar ist.
 *
 */
export interface LdapTestResultDto {
  /** Hat der Service-Account-Bind funktioniert? */
  success?: boolean;
  /** Ergebnis in Klartext (auch im Fehlerfall gefüllt). */
  message?: string;
  /**
   * Dauer des Versuchs.
   * @format int64
   */
  elapsedMilliseconds?: number;
  /**
   * Anzahl der unter dem Gruppen-Container gefundenen Gruppen. null, wenn der Bind
   * bereits fehlgeschlagen ist.
   *
   * @format int32
   */
  groupsFound?: number | null;
}

/**
 * Optionale Anmeldedaten für Test und Gruppen-Browser. Bleiben sie leer, wird der
 * konfigurierte Service-Account verwendet — was ohne Service-Account fehlschlägt.
 *
 */
export interface LdapCredentials {
  /** Anmeldename inkl. Domain. */
  upn?: string | null;
  /** Passwort. Wird nicht gespeichert. */
  password?: string | null;
}

/** Response für generierte Lizenzdatei */
export interface LicenseFileResponse {
  /** Lizenz als Base64-String */
  licenseString?: string;
  /** Vorgeschlagener Dateiname */
  fileName?: string;
  /**
   * Größe in Zeichen
   * @format int32
   */
  estimatedSize?: number;
}

/**
 * Kompakte Lizenz-Datenstruktur für QR-Code-kompatible Lizenzdateien.
 * Verwendet kurze Property-Namen für minimale JSON-Größe.
 */
export interface LicenseData {
  /** Lizenz-ID (kurz: "id") */
  id?: string;
  /** Name des Lizenznehmers (kurz: "n") */
  n?: string;
  /** Hardware-ID / Device-ID (kurz: "hw") - Bindet Lizenz an spezifische Hardware (REQUIRED) */
  hw?: string;
  /**
   * Ausstellungsdatum (kurz: "iss") - Unix Timestamp
   * @format int64
   */
  iss?: number;
  /** Module/Features mit individuellen Einstellungen (kurz: "m") */
  m?: LicenseModule[];
  /** Zusätzliche kompakte Metadaten (kurz: "x") */
  x?: Record<string, string>;
}

/**
 * Flexibles Lizenz-Modul mit dynamischen Properties.
 * Kurze Property-Namen für minimale JSON-Größe.
 * Jedes Modul kann seine eigenen spezifischen Daten in "data" speichern.
 */
export interface LicenseModule {
  /**
   * Modul-Code (kurz: "c") - z.B. "core", "analytics", "debug", "product_xyz"
   * Definiert den Typ des Moduls und dessen Struktur
   */
  c?: string;
  /**
   * Ablaufdatum (kurz: "exp") - Unix Timestamp, null = unbegrenzt
   * @format int64
   */
  exp?: number | null;
  /**
   * Dynamische Modul-Daten (kurz: "d") - Flexibles Dictionary für modul-spezifische Daten
   * z.B. für Produkt-Modul: {"product": "S6", "version": "2.0"}
   * z.B. für Feature-Modul: {"features": "api,export,cloud"}
   * z.B. für Debug-Modul: {"debuggers": "gdb,lldb", "remote": "true"}
   * Native AOT-kompatibel durch Verwendung von JsonElement
   */
  d?: Record<string, any>;
}

/** Response-Modell für die Lizenz-Inspektion */
export interface LicenseInspectionResponse {
  /** True, wenn die Signatur gültig ist */
  signatureValid?: boolean;
  /** True, wenn Lizenzdaten geparsed wurden */
  parsed?: boolean;
  /** Lizenzdaten (falls parsebar) */
  licenseData?: LicenseData | null;
  /** Rohes JSON der Lizenz (falls dekodierbar) */
  rawJson?: string | null;
  /** Fehlertext (falls vorhanden) */
  error?: string | null;
}

/** Request-Modell für die Lizenzvalidierung */
export interface ValidateLicenseRequest {
  /** Lizenz als Base64-String */
  licenseString?: string;
}

/** DTO für LicenseOption ohne Navigation Properties (vermeidet zirkuläre Referenzen) */
export interface LicenseOptionDto {
  /**
   * LicenseOption ID
   * @format guid
   */
  id?: string;
  /** Technischer Identifier */
  identifier?: string;
  /** Anzeigename */
  commonName?: string;
  /** Optionale Beschreibung */
  description?: string | null;
  /** Datentyp der Option */
  type?: LicenseOptionType;
  /** Aggregations-Modus für Number-Optionen */
  aggregationMode?: LicenseOptionAggregationMode;
  /** Standardwert als JSON-String */
  defaultValue?: string | null;
  /**
   * Sortierung für UI
   * @format int32
   */
  displayOrder?: number;
  /** Aktiv-Status der Option */
  isActive?: boolean;
  /** Ist die Option für Kunden sichtbar? */
  isVisibleToCustomer?: boolean;
}

/** Typ der Lizenz-Option */
export enum LicenseOptionType {
  Number = 0,
  Boolean = 1,
  String = 2,
  Date = 3,
}

/** Aggregations-Modus für Number-Optionen bei mehreren Lizenzen */
export enum LicenseOptionAggregationMode {
  None = 0,
  Sum = 1,
  Max = 2,
}

/** Response-Modell für die Verwendung einer LicenseOption */
export interface LicenseOptionUsageResponse {
  /**
   * LicenseOption ID
   * @format guid
   */
  optionId?: string;
  /** Identifier der Option */
  identifier?: string;
  /** Anzeigename der Option */
  commonName?: string;
  /**
   * Anzahl der verwendenden FileTypes
   * @format int32
   */
  usageCount?: number;
  /** Liste der FileTypes die diese Option verwenden */
  usedByFileTypes?: FileTypeUsageInfo[];
}

/** Info über die Verwendung in einem FileType */
export interface FileTypeUsageInfo {
  /**
   * FileType ID
   * @format guid
   */
  fileTypeId?: string;
  /** FileType Name */
  fileTypeName?: string;
  /** Ist diese Option für diesen FileType verpflichtend? */
  isRequired?: boolean;
  /** FileType-spezifischer Default-Wert */
  fileTypeSpecificDefault?: string | null;
  /**
   * Service-Einheiten für diese Option innerhalb des FileTypes
   * @format int32
   */
  serviceEinheiten?: number | null;
}

/** Request-Modell für die Erstellung einer LicenseOption */
export interface CreateLicenseOptionRequest {
  /** Technischer Identifier der Option */
  identifier?: string;
  /** Anzeigename der Option */
  commonName?: string;
  /** Optionale Beschreibung */
  description?: string | null;
  /** Datentyp der Option */
  type?: LicenseOptionType;
  /** Aggregations-Modus für Number-Optionen */
  aggregationMode?: LicenseOptionAggregationMode;
  /** Standardwert als JSON-String */
  defaultValue?: string | null;
  /**
   * Sortierung für UI
   * @format int32
   */
  displayOrder?: number;
  /** Aktiv-Status der Option */
  isActive?: boolean;
  /** Ist die Option für Kunden sichtbar? */
  isVisibleToCustomer?: boolean;
}

/** Response-Modell für FileTypeLicenseOption mit LicenseOption Details (ohne zirkuläre Referenzen) */
export interface FileTypeLicenseOptionResponse {
  /**
   * FileTypeLicenseOption ID
   * @format guid
   */
  id?: string;
  /**
   * FileType ID
   * @format guid
   */
  fileTypeId?: string;
  /**
   * LicenseOption ID
   * @format guid
   */
  licenseOptionId?: string;
  /** Ist die Option verpflichtend? */
  isRequired?: boolean;
  /** Dateityp-spezifischer Standardwert */
  fileTypeSpecificDefault?: string | null;
  /**
   * Service-Einheiten für diese Option innerhalb des FileTypes
   * @format int32
   */
  serviceEinheiten?: number | null;
  /** LicenseOption Details */
  licenseOption?: LicenseOptionDto | null;
}

/** Request-Modell für das Hinzufügen einer LicenseOption zu einem FileType */
export interface AddLicenseOptionToFileTypeRequest {
  /**
   * LicenseOption ID
   * @format guid
   */
  licenseOptionId?: string;
  /** Ob die Option verpflichtend ist */
  isRequired?: boolean;
  /** Dateityp-spezifischer Standardwert als JSON-String */
  fileTypeSpecificDefault?: string | null;
  /**
   * Service-Einheiten für diese Option innerhalb des FileTypes
   * @format int32
   */
  serviceEinheiten?: number | null;
}

/** Request-Modell für die Aktualisierung einer FileType-LicenseOption */
export interface UpdateFileTypeLicenseOptionRequest {
  /** Ob die Option verpflichtend ist */
  isRequired?: boolean;
  /** Dateityp-spezifischer Standardwert als JSON-String */
  fileTypeSpecificDefault?: string | null;
  /**
   * Service-Einheiten für diese Option innerhalb des FileTypes
   * @format int32
   */
  serviceEinheiten?: number | null;
}

/** Response-Modell für FileTypeLicense */
export interface FileTypeLicenseResponse {
  /**
   * Lizenz-ID
   * @format guid
   */
  id?: string;
  /**
   * FileType ID
   * @format guid
   */
  fileTypeId?: string;
  /** FileType Name */
  fileTypeName?: string;
  /**
   * Device ID
   * @format guid
   */
  deviceId?: string;
  /** Device Name */
  deviceName?: string;
  /** Hardware-Id des Devices */
  deviceHardwareId?: string | null;
  /** Support Code ID des Devices */
  supportCode?: string | null;
  /** Kunden-ID aus dem Support Contract */
  customerId?: string | null;
  /** Kundenname aus dem Support Contract */
  customerName?: string | null;
  /** Signierte Lizenzdatei (Base64) */
  signedLicenseString?: string | null;
  /** Status der Lizenz */
  status?: FileTypeLicenseStatus;
  /**
   * Ausstellungsdatum
   * @format date-time
   */
  issuedAt?: string;
  /**
   * Ablaufdatum (optional)
   * @format date-time
   */
  expiresAt?: string | null;
  /** Notizen zur Lizenz */
  notes?: string | null;
  /** Lizenzdaten (dekodiert) */
  licenseData?: LicenseData | null;
  /** Benutzer der die Lizenz eingereicht hat */
  requestedBy?: GetUserDataShort | null;
  /** Benutzer der die Lizenz genehmigt hat (nur für Office) */
  approvedBy?: GetUserDataShort | null;
  /**
   * Berechnete Service-Einheiten dieser einzelnen Lizenz (basierend auf OptionValues × FileTypeLicenseOption.ServiceEinheiten)
   * @format decimal
   */
  serviceEinheiten?: number;
  /**
   * Persistierter Snapshot der Service-Einheiten (Stand bei Request/Approve, wird durch Reconcile aktualisiert)
   * @format decimal
   */
  serviceEinheitenSnapshot?: number;
  /**
   * Zeitpunkt der letzten Aktualisierung des Snapshots
   * @format date-time
   */
  serviceEinheitenSnapshotUpdatedAt?: string | null;
  /** Wenn true: Lizenz wird nicht in Vertrags-Gesamtsumme gezählt */
  excludeFromCalculation?: boolean;
  /** Grund des Ausschlusses (optional) */
  excludeFromCalculationReason?: string | null;
}

/** Status einer FileTypeLicense */
export enum FileTypeLicenseStatus {
  Draft = 0,
  Requested = 1,
  Approved = 2,
  Active = 3,
  Rejected = 4,
  Expired = 5,
}

/** Request-Modell für die Erstellung einer FileTypeLicense */
export interface CreateFileTypeLicenseRequest {
  /** Optional eigene Lizenz-ID */
  licenseId?: string | null;
  /** Optionaler Anzeigename der Lizenz */
  licenseName?: string | null;
  /**
   * FileType ID
   * @format guid
   */
  fileTypeId?: string;
  /**
   * Ablaufdatum der Lizenz (optional)
   * @format date-time
   */
  expiresAt?: string | null;
  /** Freitext/Notiz zur Lizenz */
  notes?: string | null;
  /**
   * Ersteller-UserId (optional)
   * @format guid
   */
  createdByUserId?: string | null;
  /** Optionen mit Werten */
  licenseOptions?: LicenseOptionValue[] | null;
}

/** Lizenz-Option mit Wert */
export interface LicenseOptionValue {
  /** Identifier der Option */
  identifier?: string;
  /** Wert der Option (typabhängig) */
  value?: any;
}

/** Response-Modell für die Lizenzsammlung eines Devices */
export interface DeviceLicenseCollectionResponse {
  /**
   * Device ID
   * @format guid
   */
  deviceId?: string;
  /** Device Name */
  deviceName?: string;
  /** Hardware-Id des Devices */
  deviceHardwareId?: string | null;
  /**
   * Live berechnete Service-Einheiten über alle Module (aktuelle Rezeptur × aktuelle Werte)
   * @format decimal
   */
  serviceEinheitenTotal?: number | null;
  /**
   * Persistierter Snapshot der Service-Einheiten auf dem Device (Aggregation aller aktiven, nicht ausgeschlossenen, nicht abgelaufenen Lizenz-Snapshots)
   * @format decimal
   */
  serviceEinheitenTotalSnapshot?: number;
  /**
   * Zeitpunkt der letzten Aktualisierung des Device-Snapshots
   * @format date-time
   */
  serviceEinheitenTotalUpdatedAt?: string | null;
  /** Module/Lizenzübersichten je FileType */
  modules?: DeviceModuleOverviewResponse[];
}

/** Modul-Übersicht pro FileType */
export interface DeviceModuleOverviewResponse {
  /**
   * FileType ID
   * @format guid
   */
  fileTypeId?: string;
  /** FileType Name */
  fileTypeName?: string;
  /** PackageId des Produkts (optional) */
  packageId?: string | null;
  /** Optionen für dieses Modul (Aggregationen + Einzelwerte) */
  options?: DeviceModuleOptionOverview[];
  /** Einzellizenzen (Teile) für dieses Modul */
  licenses?: DeviceLicensePartResponse[];
}

/** Option-Übersicht innerhalb eines Moduls */
export interface DeviceModuleOptionOverview {
  /** Technischer Identifier der Option */
  identifier?: string;
  /** Anzeigename der Option */
  commonName?: string;
  /** Datentyp der Option */
  type?: LicenseOptionType;
  /** Aggregations-Modus (None/Sum/Max) */
  aggregationMode?: LicenseOptionAggregationMode;
  /**
   * Service-Einheiten pro Option innerhalb des FileTypes
   * @format int32
   */
  serviceEinheiten?: number | null;
  /**
   * Gesammelte Service-Einheiten aus dem Wert
   * @format decimal
   */
  serviceEinheitenTotal?: number | null;
  /** Finaler Wert für Anzeige */
  value?: any;
}

/** Einzelne Teillizenz innerhalb der Sammlung */
export interface DeviceLicensePartResponse {
  /**
   * Lizenz-ID
   * @format guid
   */
  licenseId?: string;
  /** Status der Teillizenz */
  status?: FileTypeLicenseStatus;
  /**
   * Ausstellungsdatum
   * @format date-time
   */
  issuedAt?: string;
  /**
   * Ablaufdatum (optional)
   * @format date-time
   */
  expiresAt?: string | null;
  /** Notizen zur Teillizenz */
  notes?: string | null;
  /** Options der Teillizenz (Defaults + Overrides) */
  options?: Record<string, any>;
  /**
   * Persistierter Snapshot der Service-Einheiten dieser Teillizenz
   * @format decimal
   */
  serviceEinheitenSnapshot?: number;
  /** Wenn true: Lizenz ist aus der Vertrags-Gesamtsumme ausgenommen */
  excludeFromCalculation?: boolean;
}

/** Request-Modell für die Ablehnung einer Lizenzanfrage */
export interface RejectLicenseRequest {
  /** Grund der Ablehnung */
  rejectionReason?: string;
}

/**
 * Preview-Response für die Neuberechnung der Service-Einheiten einer einzelnen Lizenz.
 * Wird durch Reconcile-Endpoint erzeugt und durch Confirm-Endpoint mit Token persistiert.
 */
export interface LicenseReconciliationPreview {
  /**
   * Lizenz-ID
   * @format guid
   */
  licenseId?: string;
  /**
   * Aktuell gespeicherter Snapshot-Wert
   * @format decimal
   */
  current?: number;
  /**
   * Neu berechneter Wert auf Basis der aktuellen Rezeptur
   * @format decimal
   */
  recalculated?: number;
  /**
   * Differenz (Recalculated - Current)
   * @format decimal
   */
  delta?: number;
  /** Aufschlüsselung pro Option */
  options?: ReconciliationOptionDiff[];
  /** Token zur Bestätigung der Änderung (10 min gültig) */
  token?: string;
  /**
   * Ablaufzeitpunkt des Tokens
   * @format date-time
   */
  expiresAt?: string;
}

/** Diff für eine einzelne Option in der License-Reconcile-Preview. */
export interface ReconciliationOptionDiff {
  /** Technischer Identifier der Option */
  identifier?: string;
  /** Anzeigename der Option */
  commonName?: string;
  /**
   * Gespeicherter Snapshot-Wert der Option
   * @format decimal
   */
  current?: number;
  /**
   * Neu berechneter Wert
   * @format decimal
   */
  recalculated?: number;
  /**
   * Differenz (Recalculated - Current)
   * @format decimal
   */
  delta?: number;
}

/** Antwort nach erfolgreicher Bestätigung (Confirm) einer Reconcile-Preview für eine Lizenz. */
export interface LicenseReconciliationResult {
  /**
   * Lizenz-ID
   * @format guid
   */
  licenseId?: string;
  /**
   * Neuer, persistierter Snapshot der Lizenz
   * @format decimal
   */
  serviceEinheitenSnapshot?: number;
  /**
   * Zeitpunkt der Aktualisierung
   * @format date-time
   */
  updatedAt?: string;
}

/** Request-Body für Confirm-Endpoints. */
export interface ConfirmReconciliationRequest {
  /** Der Token aus der vorherigen Preview-Response */
  token?: string;
}

/** Request für den Exclude-Flag einer Lizenz. */
export interface SetLicenseExcludeRequest {
  /** True = Lizenz aus der Berechnung ausnehmen, False = wieder berücksichtigen */
  exclude?: boolean;
  /** Optionaler Grund */
  reason?: string | null;
}

/** Ergebnis des Admin-Endpoints zur kompletten Neuberechnung. */
export interface AdminRecalculateResult {
  /**
   * Anzahl aktualisierter Lizenzen
   * @format int32
   */
  licensesUpdated?: number;
  /**
   * Anzahl aktualisierter Verträge
   * @format int32
   */
  contractsUpdated?: number;
  /**
   * Zeitpunkt der Ausführung
   * @format date-time
   */
  completedAt?: string;
  /**
   * Dauer in Millisekunden
   * @format int64
   */
  durationMs?: number;
}

/**
 * Snapshot of a registered OIDC client for admin lists.
 *
 */
export interface OidcClientDto {
  /** Stable identifier. */
  clientId?: string;
  /** Human-readable label. */
  displayName?: string | null;
  /** confidential or public. */
  clientType?: string;
  /** implicit (trusted) or explicit. */
  consentType?: string;
  /** Allowed redirect URIs. */
  redirectUris?: string[];
  /** Allowed post-logout redirect URIs. */
  postLogoutRedirectUris?: string[];
  /** Permitted scopes (prefix stripped). */
  scopes?: string[];
}

/**
 * Result of POST /OidcClients — secret is returned once.
 *
 */
export interface OidcClientCreatedDto {
  /** The configured client id. */
  clientId?: string;
  /** The generated client secret (null for public clients). */
  clientSecret?: string | null;
  /** confidential or public. */
  clientType?: string;
  /** implicit (trusted) or explicit. */
  consentType?: string;
}

/**
 * Body for POST /OidcClients.
 *
 */
export interface CreateOidcClientRequest {
  /**
   * Stable identifier the third-party tool will send as client_id.
   * @minLength 1
   */
  clientId: string;
  /** Human-readable label, shown on the consent page. */
  displayName?: string | null;
  /**
   * confidential (default — server-side, gets a generated
   * secret) or public (SPA / native; secret omitted, PKCE-only).
   *
   */
  clientType?: string | null;
  /**
   * Allowed redirect URIs registered with the client. The OIDC spec
   * requires an exact match.
   *
   */
  redirectUris?: string[] | null;
  /** Optional post-logout redirect URIs. */
  postLogoutRedirectUris?: string[] | null;
  /**
   * Whether the client may also use the client_credentials
   * flow for service-to-service tokens. Off by default.
   *
   */
  allowClientCredentials?: boolean;
  /**
   * Scopes this client may request. If null, defaults to
   * support_api only.
   *
   */
  scopes?: string[] | null;
  /**
   * Trusted clients skip the consent screen (Implicit consent type).
   * Use only for first-party tools you control end-to-end.
   *
   */
  isTrusted?: boolean;
}

/** Eine im System bekannte Berechtigung für die Verwaltungs-UI. */
export interface PermissionDefinitionDto {
  /** Der Permission-Schlüssel. */
  key?: string;
  /** Anzeige-Kategorie. */
  category?: string;
  /** Beschreibung, was die Berechtigung erlaubt. */
  description?: string;
}

/** Kurzfassung einer Berechtigungs-Gruppe für Listen. */
export interface PermissionGroupSummaryDto {
  /**
   * Gruppen-Id.
   * @format guid
   */
  id?: string;
  /** Anzeigename. */
  name?: string;
  /** Optionale Beschreibung. */
  description?: string | null;
  /**
   * Anzahl Mitglieder.
   * @format int32
   */
  memberCount?: number;
  /**
   * Anzahl zugewiesener Berechtigungen.
   * @format int32
   */
  grantCount?: number;
  /**
   * Zeitpunkt der letzten Änderung (UTC).
   * @format date-time
   */
  updatedAt?: string;
  /** Verknüpfte AD-Gruppe, oder null bei rein manueller Pflege. */
  ldapGroupCn?: string | null;
  /** Rolle, die die AD-Gruppe zusätzlich verleiht, oder null. */
  ldapRole?: EUserGroup | null;
}

/**
 * User Group Enum
 *
 */
export enum EUserGroup {
  SUPER_ADMIN = 0,
  ADMIN = 1,
  DEVELOPMENT = 2,
  OFFICE = 3,
  CUSTOMER = 4,
}

/** Anlage einer neuen Berechtigungs-Gruppe. */
export interface CreatePermissionGroupRequest {
  /** Eindeutiger Anzeigename. */
  name?: string;
  /** Optionale Beschreibung. */
  description?: string | null;
  /**
   * CN einer AD-Gruppe, aus der die Mitgliedschaften beim Login befüllt werden. Leer lassen für
   * eine rein manuell gepflegte Gruppe.
   *
   */
  ldapGroupCn?: string | null;
  /**
   * Rolle, die eine Mitgliedschaft in LdapGroupCn zusätzlich verleiht.
   * null = die Gruppe liefert nur Berechtigungen, keine Rolle.
   *
   */
  ldapRole?: EUserGroup | null;
}

/** Änderung von Name/Beschreibung und AD-Verknüpfung einer Gruppe. */
export interface UpdatePermissionGroupRequest {
  /** Neuer Anzeigename. */
  name?: string;
  /** Neue Beschreibung. */
  description?: string | null;
  /** Neue AD-Gruppen-Verknüpfung, oder null zum Entfernen. */
  ldapGroupCn?: string | null;
  /** Neue Rolle, oder null für „keine Rolle". */
  ldapRole?: EUserGroup | null;
}

/** Ersetzt die Berechtigungen einer Gruppe vollständig. */
export interface SetGrantsRequest {
  /** Die neue Menge an Permission-Schlüsseln. */
  permissions?: string[];
}

/** Fügt einen Benutzer einer Gruppe hinzu. */
export interface AddMemberRequest {
  /**
   * Die Benutzer-Id.
   * @format guid
   */
  userId?: string;
}

/** Die effektiven Berechtigungen eines Benutzers. */
export interface EffectivePermissionsDto {
  /**
   * Die Benutzer-Id.
   * @format guid
   */
  userId?: string;
  /** Die effektiven Permission-Schlüssel (inkl. Admin-Brücke). */
  permissions?: string[];
}

/**
 * Schlanke Variante ohne Snippet-Bodies — für Listen / Suchergebnisse.
 * Enthält nur Snippet-Anzahl; Snippet-Inhalt wird bei Bedarf über
 * GET /ProductExample/{id} nachgeladen.
 */
export interface ProductExampleSummaryDto {
  /** @format guid */
  id?: string;
  /** @format guid */
  fileTypeId?: string;
  fileTypeName?: string | null;
  title?: string;
  description?: string;
  /**
   * Art des Inhalts eines Produkt-Beispiels. Steuert, wie die UI den
   * Content-Body rendert (Markdown-Artikel vs.
   * klassisches Konfigurations-Beispiel mit Snippets).
   */
  contentType?: ProductExampleContentType;
  features?: string[];
  targetVersion?: string | null;
  /**
   * Lifecycle-Status eines Produkt-Beispiels. Beeinflusst, ob das Beispiel in
   * der internen Suche auftaucht (Approved und Customer).
   */
  status?: ProductExampleStatus;
  /** @format date-time */
  updatedAt?: string;
  /** @format int32 */
  snippetCount?: number;
  /** @format int32 */
  attachmentCount?: number;
}

/**
 * Art des Inhalts eines Produkt-Beispiels. Steuert, wie die UI den
 * Content-Body rendert (Markdown-Artikel vs.
 * klassisches Konfigurations-Beispiel mit Snippets).
 */
export enum ProductExampleContentType {
  Configuration = 0,
  Article = 1,
  HowTo = 2,
  Troubleshooting = 3,
}

/**
 * Lifecycle-Status eines Produkt-Beispiels. Beeinflusst, ob das Beispiel in
 * der internen Suche auftaucht (Approved und Customer).
 */
export enum ProductExampleStatus {
  Draft = 0,
  Approved = 1,
  Customer = 2,
  Deprecated = 3,
}

/** Volle Antwort-DTO eines Produkt-Beispiels inkl. aller Snippets mit Inhalt. */
export interface GetProductExampleData {
  /** @format guid */
  id?: string;
  /**
   * Produkt (FileType) zu dem das Beispiel gehört.
   * @format guid
   */
  fileTypeId?: string;
  /** Produkt-Name (snapshot beim Auslesen, nur lesend für UI). */
  fileTypeName?: string | null;
  title?: string;
  description?: string;
  /**
   * Art des Inhalts eines Produkt-Beispiels. Steuert, wie die UI den
   * Content-Body rendert (Markdown-Artikel vs.
   * klassisches Konfigurations-Beispiel mit Snippets).
   */
  contentType?: ProductExampleContentType;
  content?: string | null;
  features?: string[];
  targetVersion?: string | null;
  /**
   * Lifecycle-Status eines Produkt-Beispiels. Beeinflusst, ob das Beispiel in
   * der internen Suche auftaucht (Approved und Customer).
   */
  status?: ProductExampleStatus;
  notes?: string | null;
  snippets?: ExampleSnippetDto[];
  /**
   * Default-Locale dieses Artikels (typisch "de"). Bestimmt, was die UI
   * anzeigt, wenn die User-Locale keine Translation hat.
   */
  defaultLocale?: string;
  /**
   * Alle vorhandenen sprachabhängigen Inhalte (eine Row pro Locale,
   * inkl. der Default-Locale). Title/Description/Content oben spiegeln
   * die Default-Locale-Translation und bleiben für Backward-Compat befüllt.
   */
  translations?: ProductExampleTranslationDto[];
  /**
   * Angehängte Dateien, die der aktuelle User aufgrund seiner
   * EUserGroup sehen darf. Anhänge mit strengerem
   * RequiredUserGroup sind hier ausgefiltert.
   */
  attachments?: ProductExampleAttachmentDto[];
  /** „Siehe auch"-Verlinkungen zu anderen Artikeln — visibility-gefiltert. */
  relatedExamples?: RelatedExampleLinkDto[];
  /** @format date-time */
  createdAt?: string;
  /** @format date-time */
  updatedAt?: string;
  createdBy?: string | null;
  updatedBy?: string | null;
}

/**
 * DTO für einen einzelnen Snippet innerhalb eines Produkt-Beispiels.
 * Bei Create: Id darf leer bleiben (wird serverseitig vergeben).
 * Bei Update: Id mitsenden, damit die Identität über den Update
 * hinweg erhalten bleibt (sonst gelten Snippets als neu und bekommen neue IDs).
 */
export interface ExampleSnippetDto {
  /** @format guid */
  id?: string | null;
  /**
   * @minLength 1
   * @maxLength 200
   */
  title: string;
  /** @minLength 1 */
  description: string;
  /** Format des Inhalts (Xml/Json/Yaml/Ini/PlainText). Default Xml. */
  format?: SnippetFormat;
  /**
   * Roher Inhalt im jeweiligen Format.
   * @minLength 1
   */
  content: string;
  /**
   * Optionale sprachabhängige Beschreibungen für dieses Snippet. Bei
   * Create/Update werden zusätzliche Locales hier angegeben; die default-
   * Locale-Translation wird automatisch aus Title /
   * Description gespiegelt.
   */
  translations?: ExampleSnippetTranslationDto[];
}

/**
 * Format eines ExampleSnippet-Inhalts. Die Reihenfolge ist
 * UI-freundlich gewählt (häufige Formate zuerst). Persistiert als int —
 * bitte keine bestehenden Werte verschieben, neue Werte am Ende anhängen.
 */
export enum SnippetFormat {
  Xml = 0,
  Json = 1,
  Yaml = 2,
  Ini = 3,
  PlainText = 4,
}

/**
 * Sprachabhängige Beschreibung eines Snippets (Title + Description).
 * Snippet-Body bleibt sprachneutral und liegt in Content.
 */
export interface ExampleSnippetTranslationDto {
  /**
   * @minLength 1
   * @maxLength 10
   */
  locale: string;
  /**
   * @minLength 1
   * @maxLength 200
   */
  title: string;
  /** @minLength 1 */
  description: string;
}

/**
 * Sprachabhängiger Inhalt eines Produkt-Beispiels. Auf der GET-Seite enthält
 * die Liste eine Row pro existierender Locale; der Client wählt anhand seiner
 * UI-Locale aus oder fällt auf DefaultLocale
 * zurück.
 */
export interface ProductExampleTranslationDto {
  /**
   * ISO-639-1-Sprachcode ("de", "en", …).
   * @minLength 1
   * @maxLength 10
   */
  locale: string;
  /**
   * @minLength 1
   * @maxLength 200
   */
  title: string;
  /** @minLength 1 */
  description: string;
  /** Optionaler Markdown-Body für KB-Artikel in dieser Locale. */
  content?: string | null;
}

/**
 * Antwort-DTO eines Anhangs. Enthält eine vorbereitete Download-URL, die
 * per Login-Session abrufbar ist.
 */
export interface ProductExampleAttachmentDto {
  /** @format guid */
  id?: string;
  /** @format guid */
  productExampleId?: string;
  fileName?: string;
  contentType?: string;
  /** @format int64 */
  sizeBytes?: number;
  /**
   * User Group Enum
   *
   */
  requiredUserGroup?: EUserGroup;
  /** @format date-time */
  createdAt?: string;
  createdBy?: string | null;
  /**
   * Relative Download-URL (authentifiziert via Login-Session). Wird für
   * die Download-Liste am Ende des Artikels genutzt.
   */
  url?: string;
  /**
   * Fertiger Markdown-Snippet zum Einfügen in den Artikel-Body. Konvention:
   * ![](attachment:{id}). Der Frontend-Markdown-Renderer erkennt
   * das Schema, schaut die ID in der Attachment-Liste des Artikels nach
   * und rendert <img src="{Url}">.
   */
  markdownRef?: string;
}

/**
 * Ein verwandter Artikel im „Siehe auch"-Block. Nur Artikel, die der
 * aktuelle User sehen darf, werden hier geliefert (visibility-gefiltert
 * serverseitig).
 */
export interface RelatedExampleLinkDto {
  /** @format guid */
  id?: string;
  title?: string;
  fileTypeName?: string | null;
  /**
   * Lifecycle-Status eines Produkt-Beispiels. Beeinflusst, ob das Beispiel in
   * der internen Suche auftaucht (Approved und Customer).
   */
  status?: ProductExampleStatus;
  /**
   * Art des Inhalts eines Produkt-Beispiels. Steuert, wie die UI den
   * Content-Body rendert (Markdown-Artikel vs.
   * klassisches Konfigurations-Beispiel mit Snippets).
   */
  contentType?: ProductExampleContentType;
  /** @format int32 */
  sortOrder?: number;
}

/**
 * Request body for creating a new product example. The embedding is computed
 * asynchronously after save (typically searchable within ~1s).
 */
export interface CreateProductExampleModel {
  /**
   * Produkt (FileType), zu dem das Beispiel gehört. Pflicht — muss auf
   * einen existierenden FileType zeigen, sonst 400.
   * @format guid
   * @minLength 1
   */
  fileTypeId: string;
  /**
   * @minLength 1
   * @maxLength 200
   */
  title: string;
  /** @minLength 1 */
  description: string;
  /**
   * Art des Inhalts — Configuration (Default) für Snippet-Beispiele,
   * Article/HowTo/Troubleshooting für Wissensdatenbank-Einträge mit
   * Markdown-Body in Content.
   */
  contentType?: ProductExampleContentType;
  /**
   * Optionaler Markdown-Body für KB-Artikel. Wird in die semantische Suche
   * einbezogen, wenn gesetzt.
   */
  content?: string | null;
  features?: string[];
  /** @maxLength 50 */
  targetVersion?: string | null;
  /**
   * Lifecycle-Status eines Produkt-Beispiels. Beeinflusst, ob das Beispiel in
   * der internen Suche auftaucht (Approved und Customer).
   */
  status?: ProductExampleStatus;
  notes?: string | null;
  /**
   * Ein oder mehrere Snippets, die zu diesem Beispiel gehören. Mindestens
   * ein Snippet ist typisch, aber nicht zwingend.
   */
  snippets?: ExampleSnippetDto[];
  /**
   * Optionale zusätzliche Translations (en, fr, …). Default-Locale wird
   * aus den Legacy-Feldern gespiegelt; eine de-Translation hier wird
   * ignoriert.
   */
  translations?: ProductExampleTranslationDto[];
  /**
   * Default-Locale. Default "de".
   * @maxLength 10
   */
  defaultLocale?: string;
  /**
   * IDs anderer Produkt-Beispiele, die als „Siehe auch"-Block unten am
   * Artikel angezeigt werden. Reihenfolge im Array bestimmt die Sortierung.
   * Ungültige IDs führen zu 400. Self-Referenz (diese Beispiel-Id) ist
   * hier naturgemäß nicht erlaubt (Entity existiert beim Anlegen noch nicht).
   */
  relatedExampleIds?: string[];
}

/**
 * Full update of a product example. All fields required (PUT semantics —
 * pass the current values for fields you don't want to change).
 */
export interface UpdateProductExampleModel {
  /**
   * Produkt (FileType), zu dem das Beispiel gehört. Kann beim Update
   * auf einen anderen FileType zeigen — ein Umhängen löst Re-Embedding
   * aus, weil Produktname ins Embedding eingeht.
   * @format guid
   * @minLength 1
   */
  fileTypeId: string;
  /**
   * @minLength 1
   * @maxLength 200
   */
  title: string;
  /** @minLength 1 */
  description: string;
  /**
   * Art des Inhalts — Configuration (Default) für Snippet-Beispiele,
   * Article/HowTo/Troubleshooting für Wissensdatenbank-Einträge.
   * Wechsel zwischen Typen löst Re-Embedding aus.
   */
  contentType?: ProductExampleContentType;
  /**
   * Optionaler Markdown-Body. Wird in die semantische Suche einbezogen,
   * wenn gesetzt.
   */
  content?: string | null;
  features?: string[];
  /** @maxLength 50 */
  targetVersion?: string | null;
  /**
   * Lifecycle-Status eines Produkt-Beispiels. Beeinflusst, ob das Beispiel in
   * der internen Suche auftaucht (Approved und Customer).
   */
  status?: ProductExampleStatus;
  notes?: string | null;
  /**
   * Vollständige neue Snippet-Liste. Snippets mit bekannter Id
   * behalten ihre Identität (Download-Links bleiben stabil), Snippets
   * ohne Id werden als neu angelegt. Im Payload fehlende IDs gelten als
   * gelöscht.
   */
  snippets?: ExampleSnippetDto[];
  /**
   * Optionale Liste zusätzlicher Translations (en, fr, …). Default-Locale
   * (typisch "de") wird automatisch aus den Legacy-Feldern gespiegelt;
   * sendet der Client hier eine de-Translation mit, wird sie ignoriert
   * (nicht-default-Locales gewinnen, default-Locale = Legacy-Felder).
   * PUT-Semantik: nicht-default-Locales, die in dieser Liste fehlen, werden
   * gelöscht.
   */
  translations?: ProductExampleTranslationDto[];
  /**
   * Default-Locale dieses Artikels. Default "de"; nur ändern wenn der
   * Artikel primär in einer anderen Sprache gepflegt wird.
   * @maxLength 10
   */
  defaultLocale?: string;
  /**
   * Vollständige neue „Siehe auch"-Liste (PUT-Semantik: nicht enthaltene
   * bisherige Links werden entfernt). Reihenfolge bestimmt die Sortierung.
   * Self-Referenz wird mit 400 abgelehnt.
   */
  relatedExampleIds?: string[];
}

/**
 * Antwort auf POST /ProductExample/{id}/attachments/{attachmentId}/access-token.
 * Enthält ein kurzlebiges URL-Token (10 min TTL) und die fertige Download-URL,
 * die der Browser direkt in <img src>/<a href> stecken kann.
 */
export interface AttachmentAccessTokenResponse {
  /** Opakes Hex-Token (48 Zeichen). */
  token?: string;
  /**
   * Ablaufzeitpunkt (UTC). Danach liefert die URL 404.
   * @format date-time
   */
  expiresAt?: string;
  /**
   * Fertige relative Download-URL inkl. Token. Auth-frei abrufbar bis zum
   * Ablauf — das Token ist das Capability.
   */
  url?: string;
}

/** DTO for returning products */
export interface GetProductsData {
  /**
   * Id of Product
   * @format guid
   */
  id?: string;
  /** Public link to find Product */
  link?: string;
  /**
   * Individual name of Product
   * @example "Zentrale Bedieneinrichtung (ZBE)
   *             "
   */
  name?: string;
  /**
   * Description of Product
   * @example "Zentrale Bedieneinrichtung (ZBE) für die Feuerwehr
   *             "
   */
  description?: string;
}

/** Holds data related to a file. */
export interface FileDataResponse {
  /**
   * The unique identifier for the file, which is also used as the filename in storage.
   * @format guid
   * @example "3D290374-8689-4856-B5C4-35E0414F66E8"
   */
  id?: string;
  /**
   * The original name of the file before it was uploaded to the support system.
   * @example "AfVis-6.3.12(100)-Setup.exe"
   */
  fileName?: string;
  /** The version to which the file belongs. */
  version?: GetVersionDataCustomer | null;
  /** The product to which the file belongs. */
  product?: GetProductsData | null;
  /**
   * The file's extension.
   * @example ".exe"
   */
  extension?: string;
  /** The type of the file, used for filtering. */
  type?: GetFileTypeData;
  /**
   * The host system/platform for this file (Windows, Android, iOS, etc.)
   * @format guid
   */
  hostSystemId?: string | null;
  /** The host system/platform name. */
  hostSystemName?: string | null;
  /**
   * Indicates if the file is a debug version. Debug versions are only available for support purposes.
   * @example false
   */
  debugVersion?: boolean;
  /**
   * The file's MIME type, used for downloading the file from storage.
   * @example "application/pdf"
   */
  mimeType?: string;
}

export interface FileUploadHeader {
  /**
   * The major version number.
   * @format int32
   * @example 3
   */
  major?: number;
  /**
   * The minor version number.
   * @format int32
   * @example 1
   */
  minor?: number;
  /**
   * The patch version number.
   * @format int32
   * @example 0
   */
  patch?: number;
  /**
   * The unique identifier for the product.
   * @format guid
   * @example "3D290374-8689-4856-B5C4-35E0414F66E8"
   */
  productId?: string;
  /**
   * FileTypeId of FileType which belongs to this file
   * @format guid
   */
  fileTypeId?: string;
  /**
   * HostSystemId specifies which platform this file is for
   * @format guid
   */
  hostSystemId?: string | null;
  /** Filename of the file uploaded */
  fileName?: string;
  /** File which will be uploaded */
  contentType?: string;
}

/** Setzt den Freigabe-Status eines Angebots. */
export interface ReleaseOfferRequest {
  /** Neuer Freigabe-Status. */
  released?: boolean;
}

/**
 * Ein Eintrag der erweiterten Kalkulations-Übersicht: Projekt-Basisdaten plus Link- und
 * Angebots-Status. Preisangaben nur, wenn der Aufrufer Preise sehen darf.
 *
 */
export interface ProjectOverviewItem {
  /**
   * Projekt-Id.
   * @format guid
   */
  id?: string;
  /** Projektname. */
  name?: string;
  /** Kundenname (denormalisiert). */
  customerName?: string | null;
  /** Kundennummer/Referenz. */
  customerReference?: string | null;
  /**
   * Optionaler Support-Vertrag.
   * @format guid
   */
  supportContractId?: string | null;
  /**
   * Eigentümer (Ersteller).
   * @format guid
   */
  ownerUserId?: string | null;
  /** Ersteller-E-Mail. */
  createdBy?: string | null;
  /**
   * Erstellzeitpunkt (UTC).
   * @format date-time
   */
  createdAt?: string;
  /** Letzter Bearbeiter. */
  updatedBy?: string | null;
  /**
   * Letzte Änderung (UTC).
   * @format date-time
   */
  updatedAt?: string;
  /** Ob Kundennotizen (aus dem Konfigurator) hinterlegt sind. */
  hasCustomerNotes?: boolean;
  /**
   * Netto-Gesamt der letzten Kalkulation (nur bei Preis-Sichtbarkeit).
   * @format decimal
   */
  lastCalcTotalNet?: number | null;
  /**
   * Zeitpunkt der letzten Kalkulation (nur bei Preis-Sichtbarkeit).
   * @format date-time
   */
  lastCalcAt?: string | null;
  /** Interne Personen-/Gruppen-Freigaben. */
  shares?: ProjectShareSummary;
  /** Link-Status-Zusammenfassung. */
  links?: ShareLinkSummary;
  /** Angebots-Status-Zusammenfassung. */
  offers?: OfferSummary;
}

/** Zusammenfassung der internen Personen-/Gruppen-Freigaben eines Projekts. */
export interface ProjectShareSummary {
  /**
   * Anzahl Freigaben insgesamt.
   * @format int32
   */
  total?: number;
  /**
   * Davon an einzelne Personen.
   * @format int32
   */
  persons?: number;
  /**
   * Davon an Gruppen.
   * @format int32
   */
  groups?: number;
}

/** Zusammenfassung der Freigabe-Links eines Projekts. */
export interface ShareLinkSummary {
  /**
   * Anzahl Links insgesamt (= Summe der Status-Buckets).
   * @format int32
   */
  total?: number;
  /**
   * Angelegt, aber noch nicht versendet (Mailversand ausstehend).
   * @format int32
   */
  created?: number;
  /**
   * Versendet, aber noch nicht geöffnet.
   * @format int32
   */
  sent?: number;
  /**
   * Mindestens einmal geöffnet.
   * @format int32
   */
  opened?: number;
  /**
   * Widerrufen.
   * @format int32
   */
  revoked?: number;
  /**
   * Abgelaufen.
   * @format int32
   */
  expired?: number;
  /**
   * Zeitpunkt des letzten Öffnens über alle Links (UTC) oder null.
   * @format date-time
   */
  lastOpenedAt?: string | null;
}

/** Zusammenfassung der Angebots-PDFs eines Projekts. */
export interface OfferSummary {
  /**
   * Anzahl Angebote.
   * @format int32
   */
  total?: number;
  /**
   * Davon freigegeben.
   * @format int32
   */
  released?: number;
  /**
   * Davon mindestens einmal über einen Link heruntergeladen.
   * @format int32
   */
  downloaded?: number;
  /**
   * Davon vom Kunden angenommen („in Ordnung").
   * @format int32
   */
  approved?: number;
  /**
   * Davon vom Kunden als „nicht zufrieden" beantwortet.
   * @format int32
   */
  notSatisfied?: number;
  /**
   * Davon mit Rückruf-/Kontaktwunsch beantwortet.
   * @format int32
   */
  callbackRequested?: number;
  /**
   * Ca. geplanter Umsetzungsmonat (1–12) des zuletzt angenommenen Angebots oder null.
   * @format int32
   */
  plannedMonth?: number | null;
  /**
   * Ca. geplantes Umsetzungsjahr des zuletzt angenommenen Angebots oder null.
   * @format int32
   */
  plannedYear?: number | null;
  /**
   * Zeitpunkt der letzten Freigabe (UTC) oder null.
   * @format date-time
   */
  lastReleasedAt?: string | null;
}

/** Erteilt eine neue Projekt-Freigabe. */
export interface AddProjectShareRequest {
  /** Art des Prinzipals (Benutzer/Gruppe). */
  principalType?: PrincipalType;
  /**
   * Id des Benutzers bzw. der Gruppe.
   * @format guid
   */
  principalId?: string;
  /** Zugriffsstufe (Lesen/Bearbeiten); Standard Bearbeiten. */
  accessLevel?: ShareAccessLevel;
}

/**
 * Art des Prinzipals, an den eine ProjektFreigabe erteilt wird.
 *
 */
export enum PrincipalType {
  User = "User",
  Group = "Group",
}

/** Zugriffsstufe einer ProjektFreigabe. */
export enum ShareAccessLevel {
  Read = "Read",
  Edit = "Edit",
}

/** Öffnet einen Link mit dem zugeschickten Passwort. */
export interface OpenShareLinkRequest {
  /** Das Zugangs-Passwort aus der E-Mail. */
  password?: string;
}

/** Speichert Konfiguration (nur im Modus Bearbeiten) und/oder Kundennotizen + Stammdaten (immer). */
export interface SavePublicConfigRequest {
  /** Die neue Konfiguration; wird nur im Modus Edit übernommen. */
  project?: ProjectInput | null;
  /** Neue Kundennotizen (in beiden Modi speicherbar). */
  customerNotes?: string | null;
  /** Neue Kunden-Stammdaten (Adressen, Kontakt, Nummern); in beiden Modi speicherbar. */
  customerDetails?: CustomerDetails | null;
}

/**
 * Vom Kunden vervollständigbare Stammdaten eines Projekts (über den öffentlichen Konfigurator-Link):
 * Rechnungs-/Lieferadresse, Ansprechpartner, Telefon sowie interne und Beschaffungs-Nummern. Alle
 * Felder optional; der Kunde füllt sie nach und nach aus.
 */
export interface CustomerDetails {
  /** Rechnungsadresse. */
  billingAddress?: PostalAddress | null;
  /** Lieferadresse. */
  deliveryAddress?: PostalAddress | null;
  /** Ansprechpartner (Name). */
  contactPerson?: string | null;
  /** Telefonnummer für Rückfragen. */
  phone?: string | null;
  /** Interne Nummer des Kunden (z. B. Bestell-/Projektkennung). */
  internalNumber?: string | null;
  /**
   * Allgemeine Beschaffungsnummer (z. B. elektronische Leitweg-/Beschaffungs-ID der öffentlichen Hand);
   * bewusst allgemein gehalten.
   */
  procurementNumber?: string | null;
}

/** Eine Postanschrift (Rechnungs- oder Lieferadresse). Alle Felder optional. */
export interface PostalAddress {
  /** Firmen-/Empfängername. */
  name?: string | null;
  /** Straße und Hausnummer. */
  street?: string | null;
  /** Postleitzahl. */
  zipCode?: string | null;
  /** Ort. */
  city?: string | null;
  /** Land. */
  country?: string | null;
  /** Adresszusatz (z. B. Abteilung, c/o). */
  addition?: string | null;
}

/** Kundenantwort auf ein Angebot über den Link (mehrstufig). */
export interface RespondToOfferRequest {
  /** Art der Antwort (Für uns in Ordnung / Nicht zufrieden). */
  type?: OfferResponseType;
  /** Optionaler Name der antwortenden Person (Protokollierung). */
  name?: string | null;
  /** Optionale Freitext-Nachricht (z. B. Grund bei „nicht zufrieden"). */
  message?: string | null;
  /**
   * Ca. geplanter Umsetzungsmonat (1–12) bei Annahme; sonst null.
   * @format int32
   */
  plannedMonth?: number | null;
  /**
   * Ca. geplantes Umsetzungsjahr (vierstellig) bei Annahme; sonst null.
   * @format int32
   */
  plannedYear?: number | null;
}

/**
 * Antwort des Kunden auf ein freigegebenes Angebot (über den öffentlichen Link).
 *
 */
export enum OfferResponseType {
  Approved = "Approved",
  NotSatisfied = "NotSatisfied",
  CallbackRequested = "CallbackRequested",
}

/**
 * One result row from a semantic device search. Score is the cosine
 * similarity (1 = identical meaning, 0 = orthogonal). Higher = better.
 */
export interface DeviceSearchHit {
  /** @format guid */
  deviceId?: string;
  name?: string;
  customerDeviceId?: string | null;
  serviceBeschreibung?: string | null;
  supportCodeId?: string | null;
  /**
   * Rohe Cosine-Similarity (0–1). Technisch, für Debug/Power-User.
   * @format double
   */
  score?: number;
  /**
   * Auf 0–1 kalibriert über Embedding:StrongThreshold/GoodThreshold/WeakFloor. UI-Prozentwert.
   * @format double
   */
  normalizedScore?: number;
  /** Qualitative Bewertung für UI-Badges. */
  confidence?: SearchConfidence;
}

/**
 * Qualitative Bewertung eines semantischen Suchtreffers. Dient als einfache
 * UI-Kategorie (z.B. grüne/gelbe/graue Badges) ohne dass das Frontend
 * Schwellenwerte kennen muss.
 */
export enum SearchConfidence {
  Weak = 0,
  Good = 1,
  Strong = 2,
}

/**
 * Request body for semantic-search endpoints. The query is embedded server-side
 * (one Ollama call) and matched against the persisted vectors via cosine
 * distance.
 */
export interface SemanticSearchRequest {
  /**
   * Free-text query in natural language ("welche XML-Konfigurationen
   * haben Audio-Routing für zwei Sprecher?"). Required, non-empty.
   * @minLength 1
   */
  query: string;
  /**
   * Max number of hits to return. Defaults to 10. Capped at 100.
   * @format int32
   */
  limit?: number;
  /**
   * Qualitätsfilter. Nur Treffer mit mindestens dieser Confidence werden
   * zurückgegeben. Default:  —
   * Weak-Hits sind typischerweise Rauschen und bringen die UI mehr
   * durcheinander als sie helfen. Für Debug/Ops kann der Client explizit
   * "minConfidence": "Weak" setzen, um alles zu sehen.
   */
  minConfidence?: SearchConfidence | null;
  /**
   * Bevorzugte Locale ("de", "en", …). Treffer in dieser Locale werden
   * im Vektor-Pfad mit 1.1× geboostet, sodass same-language-Matches
   * gegenüber cross-lingual leicht im Vorteil sind. Null/leer → kein
   * Boost (Cross-Lingual greift wie gehabt). Aktuell nur für die
   * ProductExample-Suche relevant; Devices/Contracts sind einsprachig.
   */
  locale?: string | null;
}

/** One result row from a semantic SupportContract search. */
export interface ContractSearchHit {
  /** @format guid */
  contractId?: string;
  externalContractId?: string;
  title?: string;
  customerName?: string;
  comment?: string | null;
  /**
   * Rohe Cosine-Similarity (0–1). Technisch, für Debug/Power-User.
   * @format double
   */
  score?: number;
  /**
   * Auf 0–1 kalibriert. UI-Prozentwert.
   * @format double
   */
  normalizedScore?: number;
  /** Qualitative Bewertung für UI-Badges. */
  confidence?: SearchConfidence;
}

/**
 * Treffer-DTO einer semantischen Suche über Produkt-Beispiele. Snippet-Inhalte
 * werden bewusst NICHT zurückgegeben (oft mehrere KB) — separat über
 * GET /ProductExample/{id} laden.
 */
export interface ProductExampleSearchHit {
  /** @format guid */
  exampleId?: string;
  /**
   * Produkt (FileType) zu dem das Beispiel gehört.
   * @format guid
   */
  fileTypeId?: string;
  /** Produkt-Name (Snapshot — für Anzeige im UI). */
  fileTypeName?: string | null;
  title?: string;
  description?: string;
  features?: string[];
  targetVersion?: string | null;
  /**
   * Rohe Cosine-Similarity (0–1). Technisch, für Debug/Power-User.
   * @format double
   */
  score?: number;
  /**
   * Auf 0–1 kalibriert. UI-Prozentwert.
   * @format double
   */
  normalizedScore?: number;
  /** Qualitative Bewertung für UI-Badges. */
  confidence?: SearchConfidence;
}

/**
 * Wie SemanticSearchRequest, aber mit optionalem FileType-Filter
 * — beschränkt die Suche auf Beispiele eines bestimmten Produkts.
 */
export type ProductExampleSearchRequest = SemanticSearchRequest & {
  /**
   * Optional: nur Beispiele für dieses Produkt (FileType). Null = alle.
   * @format guid
   */
  fileTypeId?: string | null;
};

/**
 * Ein gemischter Treffer aus der vereinten Suche (Devices + ProductExamples).
 * Felder sind nullable, weil je nach Typ nicht alle befüllt sind — der
 * Konsument prüft Type und greift auf passende Felder zu.
 * Sortierung der Liste = absteigender Score.
 */
export interface UnifiedSearchHit {
  /**
   * Diskriminator für die vereinte Suche. Erweiterbar — zukünftige Entitäten
   * (z.B. SupportContracts) können hier ergänzt werden.
   */
  type?: UnifiedSearchHitType;
  /** @format guid */
  id?: string;
  /**
   * Geblendeter Vektor+Lex-Score. Wird für Cross-Type-Sortierung genutzt.
   * @format double
   */
  score?: number;
  /**
   * Auf 0–1 kalibriert. UI-Prozentwert.
   * @format double
   */
  normalizedScore?: number;
  /** Qualitative Bewertung für UI-Badges. */
  confidence?: SearchConfidence;
  /** Device.Name oder ProductExample.Title — immer gesetzt. */
  title?: string;
  /** Device.ServiceBeschreibung oder ProductExample.Description. */
  description?: string | null;
  /** Nur bei ProductExample befüllt. */
  features?: string[];
  /** Nur bei ProductExample befüllt. */
  targetVersion?: string | null;
  /**
   * Nur bei ProductExample befüllt — FK auf FileType (= Produkt).
   * @format guid
   */
  fileTypeId?: string | null;
  /** Nur bei ProductExample befüllt — Produkt-Name für UI. */
  fileTypeName?: string | null;
  /** Nur bei Device befüllt. */
  customerDeviceId?: string | null;
  /** Nur bei Device befüllt. */
  supportCodeId?: string | null;
}

/**
 * Diskriminator für die vereinte Suche. Erweiterbar — zukünftige Entitäten
 * (z.B. SupportContracts) können hier ergänzt werden.
 */
export enum UnifiedSearchHitType {
  Device = 0,
  ProductExample = 1,
}

/**
 * Request für die vereinte Suche. Optional kann auf einen Subset der
 * Treffer-Typen und/oder auf einen FileType (Produkt) eingeschränkt werden.
 */
export type UnifiedSearchRequest = SemanticSearchRequest & {
  /**
   * Welche Entitätstypen sollen durchsucht werden? Null oder leer = beide.
   * Erlaubte Werte (case-insensitive): "device", "product_example".
   */
  types?: string[] | null;
  /**
   * Optional: nur Beispiele für diesen FileType (= Produkt) liefern.
   * Null = alle. Wirkt nur auf den ProductExample-Zweig.
   * @format guid
   */
  fileTypeId?: string | null;
};

/**
 * Diagnostic info about the embedding pipeline. Used by the health endpoint
 * and by ops dashboards.
 */
export interface EmbeddingHealthDto {
  enabled?: boolean;
  ollamaReachable?: boolean;
  ollamaUrl?: string;
  model?: string;
  /** @format int32 */
  dimensions?: number;
  /**
   * Total Devices that should be searchable (have a ServiceBeschreibung).
   * @format int32
   */
  deviceCandidates?: number;
  /**
   * Devices currently embedded.
   * @format int32
   */
  devicesEmbedded?: number;
  /**
   * Total SupportContracts.
   * @format int32
   */
  contractCandidates?: number;
  /**
   * SupportContracts currently embedded.
   * @format int32
   */
  contractsEmbedded?: number;
  /**
   * Total ProductExamples (independent of status).
   * @format int32
   */
  productExampleCandidates?: number;
  /**
   * ProductExamples currently embedded.
   * @format int32
   */
  productExamplesEmbedded?: number;
}

/**
 * HTTP get type for generating password  data
 *
 */
export interface GetServiceData {
  /**
   * Support in given format.
   * Can be used to check if system has current support contract
   * ABC2-B7J1
   *
   */
  supportId?: string | null;
  /**
   * Generated password
   *
   */
  password?: string;
  /**
   * System software version
   *
   */
  softwareVersion?: string | null;
  /**
   * System timestamp
   *
   * @format int32
   */
  timestamp?: number | null;
  /**
   * System hardware version
   *
   */
  hardwareVersion?: string | null;
}

/**
 * Set of url parameters to find correct support contract and generate password
 *
 */
export interface ResolveServiceData {
  /**
   * Support ID
   *
   * @example "HQXBX-BU8PB"
   */
  si?: string | null;
  /**
   * Software Version
   *
   * @example "6.3.10"
   */
  sw?: string | null;
  /**
   * Hardware
   *
   * @example "-"
   */
  hw?: string | null;
  /**
   * Service Token
   *
   * @example "30cd-1907-26a4"
   */
  st?: string;
  /**
   * Remaining Time
   *
   * @format int32
   * @example 0
   */
  vf?: number | null;
  /**
   * Timestamp
   *
   * @format int32
   * @example 43200
   */
  ts?: number | null;
}

/**
 * FileType DTO for license selection in UI.
 *
 */
export interface FileTypeLicenseDto {
  /**
   * @format guid
   * @minLength 1
   */
  id: string;
  /** @minLength 1 */
  name: string;
}

/** Represents the response data for a license. */
export interface LicenseResponseDto {
  /** @format guid */
  id?: string;
  userName?: string;
  /** @format guid */
  userId?: string;
  description?: string;
  hostId?: string;
  supportContract?: string;
  supportCodeId?: string;
  /** @format guid */
  fileTypeId?: string;
  fileTypeName?: string | null;
  version?: number;
  tag?: string | null;
  tagName?: string | null;
  /** @format date-time */
  requestedAt?: string;
  /** @format date-time */
  licenseGeneratedAt?: string | null;
  licenseCode?: string | null;
  /** Optional callback URL to be called when the license is generated */
  callbackUrl?: string | null;
  /** Status of the license. */
  status?: LicenseStatus;
}

/** Represents the status of a license. */
export enum LicenseStatus {
  InCart = 0,
  Ordered = 1,
  LicenseGenerated = 2,
  Revoked = 3,
  Rejected = 4,
}

export interface RequestsLicenseDto {
  /**
   * Individual Description. Used for customers
   * @minLength 1
   */
  description: string;
  /**
   * Host ID for which the license is generated
   * @minLength 1
   */
  hostId: string;
  /**
   * Corresponding Support Contract
   * @minLength 1
   */
  supportCodeId: string;
  /**
   * If of the file type the license should be generated for
   * @format guid
   * @minLength 1
   */
  fileTypeId: string;
  /** Tag for which the generation is done */
  tag?: string | null;
  /** Optional callback URL to be called when the license is generated */
  callbackUrl?: string | null;
}

/**
 * Data transfer object for updating an existing license request.
 * Allows remapping a license to a different product/variant.
 */
export interface UpdateLicenseDto {
  /**
   * New file type ID (product) the license should be generated for
   * @format guid
   * @minLength 1
   */
  fileTypeId: string;
  /** New tag (variant) for which the generation is done */
  tag?: string | null;
  /** Optional: Update the description */
  description?: string | null;
}

/**
 * Sammelantwort über alle geprüften Bereiche.
 *
 */
export interface SettingsStatusDto {
  /**
   * Zeitpunkt der Prüfung (UTC). Kann älter als der Abruf sein, weil das Ergebnis kurz
   * zwischengespeichert wird — die Oberfläche zeigt den Zeitpunkt deshalb an.
   *
   * @format date-time
   */
  checkedAt?: string;
  /** Die Einzelergebnisse. */
  areas?: SettingsAreaStatusDto[];
}

/**
 * Zustand eines konfigurierbaren Teilbereichs der Verwaltung. Speist die Status-Kacheln der
 * Übersicht unter /admin/settings, damit man ohne Klick durch alle Unterseiten sieht,
 * wo etwas hakt.
 *
 */
export interface SettingsAreaStatusDto {
  /**
   * Stabile Kennung des Bereichs (z. B. ldap, geocoding, embedding).
   * Die Oberfläche ordnet damit Kachel und Unterseite einander zu — nicht übersetzen.
   *
   */
  key?: string;
  /** Ist der Bereich eingeschaltet? Entspricht dem jeweiligen Master-Schalter. */
  enabled?: boolean;
  /**
   * Liegen alle Pflichtangaben vor? Ein eingeschalteter, aber unvollständig konfigurierter
   * Bereich ist der häufigste Fehlerfall und wird deshalb getrennt vom Verbindungsfehler gemeldet.
   *
   */
  configured?: boolean;
  /**
   * Ergebnis der Erreichbarkeitsprüfung: true = erreichbar, false = Fehler,
   * null = nicht geprüft (weil abgeschaltet oder kein automatischer Test möglich).
   *
   */
  healthy?: boolean | null;
  /** Klartext-Begründung für die Anzeige — immer gesetzt. */
  detail?: string;
  /**
   * Dauer der Prüfung, sofern eine stattgefunden hat.
   * @format int64
   */
  elapsedMilliseconds?: number | null;
}

/**
 * Legt in einem Schritt ein neues (leeres) Projekt an, erstellt dazu einen Freigabe-Link und
 * mailt Link + Passwort an den Kunden. Für „Neue Einladung versenden".
 *
 */
export interface CreateSharedProjectRequest {
  /** E-Mail des Kunden (Empfänger von Link + Passwort). */
  customerEmail?: string;
  /** Ansehen oder Bearbeiten. */
  mode?: ShareLinkMode;
  /** Optionaler Projektname (sonst aus Kundenname/Standard abgeleitet). */
  projectName?: string | null;
  /** Optionaler Kundenname (denormalisiert für die Liste). */
  customerName?: string | null;
  /** Optionale Kundennummer/Referenz. */
  customerReference?: string | null;
  /**
   * Optionales Ablaufdatum (UTC).
   * @format date-time
   */
  expiresAt?: string | null;
}

/**
 * Modus eines ShareLink: legt fest, was der (nicht eingeloggte) Empfänger darf.
 * Kundennotizen sind in beiden Modi möglich.
 *
 */
export enum ShareLinkMode {
  View = "View",
  Edit = "Edit",
}

/** Erzeugt einen neuen Freigabe-Link und verschickt Link + Passwort automatisch per E-Mail. */
export interface CreateShareLinkRequest {
  /** Ansehen oder Bearbeiten. */
  mode?: ShareLinkMode;
  /** E-Mail des Kunden (Empfänger von Link + Passwort). */
  customerEmail?: string;
  /**
   * Optionales Ablaufdatum (UTC).
   * @format date-time
   */
  expiresAt?: string | null;
}

/** Ergebnis einer Transkription. */
export interface TranscriptionResult {
  /** Hat es geklappt? */
  ok?: boolean;
  /** Der erkannte Text. */
  text?: string | null;
  /** Klartext-Ursache bei Misserfolg. */
  error?: string | null;
  /**
   * Dauer — bei Sprache der interessante Wert.
   * @format int64
   */
  elapsedMilliseconds?: number;
}

/**
 * HTTP Return value for support code data
 *
 */
export interface GetQuickSupportData {
  /**
   * Support code id
   *
   */
  id?: string;
  /**
   * Support code id
   *
   */
  isValid?: boolean;
  /**
   * Name of the support code (can be used to describe the system)
   *
   */
  name?: string;
  /**
   * Contract number
   *
   */
  contractContractId?: string;
  /**
   * Contract title
   *
   */
  contractTitle?: string;
  contractExpire?: string;
  contractInfinite?: boolean;
}

/**
 * Bad request reponse objece
 *
 */
export interface NotFoundResponse {
  /**
   * HTML Status code
   *
   * @format int32
   * @example 404
   */
  statusCode?: number;
  /**
   * Self defined message (e.G. kein login möglich)
   *
   * @example "Der Nutzer wurde nicht gefunden"
   */
  message?: string;
}

/**
 * HTTP Post type for adding support code data
 *
 */
export interface AddSupportCodeData {
  /**
   * Support ID
   *
   */
  supportId?: string;
  /**
   * System name
   *
   */
  name?: string;
  /**
   * URL to Redirect to
   *
   */
  redirectUrl?: string;
}

/**
 * HTTP Return value for support contract data
 *
 */
export interface GetSupportContractData {
  id?: string;
  /**
   * Short title where Support Contract will belong to (e.G. ELW1 JUH BONN)
   *
   */
  title?: string;
  /**
   * Name of the customer where Support Contract belongs to (e.G. JUH BONN)
   *
   */
  customerName?: string;
  /**
   * Date and Time on which the Support Contract was created
   *
   * @format date-time
   */
  created?: string;
  /**
   * DateTime on which Support ID will expire.
   * Default expiration date: Now + 1 Year
   *
   * @format date
   */
  expire?: string;
  /**
   * Comment which can be added to support contract
   *
   */
  comment?: string;
  /**
   * Contract ID of Customer Relationship Management
   *
   */
  contractId?: string;
  /**
   * Customer ID of Customer Relationship Management
   *
   */
  customerId?: string;
  /**
   * Filter tags for the current support contract
   *
   */
  filterTags?: GetFilterTagData[];
  /**
   * Infinite contract
   *
   */
  infinite?: boolean;
  /**
   * Number of FilterTags for current contract
   * @format int32
   */
  filterTagsCount?: number;
  /** Get data of support contracts to display in UI */
  supportCodes?: GetQuickSupportData[];
  /**
   * Support contract status between 0 (expired) and 3 (long term)
   *
   *
   *         3At least 3 years
   *
   *
   *         2At least 60 days
   *
   *
   *         1Valid but less then 60 days
   *
   *
   *         0Expired
   *
   *
   *
   * @format int32
   */
  status?: number;
  /**
   * Persistierte Summe der Service-Einheiten über alle aktiven, nicht ausgeschlossenen
   * und nicht abgelaufenen Lizenzen der Devices dieses Support-Vertrags.
   * @format decimal
   */
  serviceEinheitenTotalSnapshot?: number;
  /**
   * Zeitpunkt der letzten Aktualisierung des Service-Einheiten-Snapshots.
   * @format date-time
   */
  serviceEinheitenTotalUpdatedAt?: string | null;
  /**
   * True, wenn der gespeicherte Snapshot gegenüber der aktuellen Rezeptur oder
   * Ausschluss-Konfiguration veraltet ist und eine Neuberechnung empfohlen wird.
   */
  serviceEinheitenSnapshotStale?: boolean;
}

/**
 * Summary statistics for support contracts.
 *
 */
export interface SupportContractSummaryDto {
  /**
   * Total number of accessible contracts.
   *
   * @format int32
   */
  totalContracts?: number;
  /**
   * Number of active contracts (including infinite).
   *
   * @format int32
   */
  activeContracts?: number;
  /**
   * Number of contracts expiring soon.
   *
   * @format int32
   */
  expiringSoonContracts?: number;
  /**
   * Number of expired contracts.
   *
   * @format int32
   */
  expiredContracts?: number;
  /**
   * Number of infinite contracts.
   *
   * @format int32
   */
  infiniteContracts?: number;
}

/**
 * HTTP Post to create new contact in contact system
 *
 */
export interface CreateContactData {
  /**
   * Support contact title
   *
   */
  title?: string;
  /**
   * Support contact content
   *
   */
  content?: string;
  /**
   * Support Contract ID where contact is belonging to
   *
   */
  contract?: string;
  /**
   * Support or new offer
   *
   */
  isSupport?: boolean;
  /**
   * Service ID of the corresponding system
   *
   */
  serviceId?: string;
  /**
   * Type of the contact. Default is 1 (Keine Angabe)
   * @format int32
   */
  contactType?: number;
}

/**
 * HTTP Post type for adding support contract data
 *
 */
export interface AddSupportContractData {
  /**
   * Short title where Support Contract will belong to (e.G. ELW1 JUH BONN)
   *
   */
  title?: string;
  /**
   * Name of the customer where Support Contract belongs to (e.G. JUH BONN)
   *
   */
  customerName?: string;
  /**
   * Date and Time on which the Support Contract was created
   *
   * @format date
   */
  expire?: string | null;
  /**
   * Comment which can be added to support contract
   *
   */
  comment?: string;
}

/**
 * HTTP GET return type for user
 *
 */
export interface GetUserData {
  /**
   * UUID of the user
   *
   * @format guid
   * @example "cda9cb75-6479-4d05-9560-343935a0800d"
   */
  id?: string;
  /**
   * E-Mail Address of the user
   *
   * @example "max.mustermann@musterstadt.de"
   */
  eMail?: string;
  /**
   * Full name of the user
   *
   * @example "Max Mustermann"
   */
  name?: string;
  /**
   * Saltuation including name of the user
   *
   * @example "Sehr geehrter Herr Max Mustermann,"
   */
  anrede?: string;
  /**
   * Usergroup with specified access rights
   *
   */
  userGroup?: EUserGroup;
  /**
   * Date Time when user was created
   *
   * @format date-time
   * @example "2023-05-17T10:57:30.129177"
   */
  created?: string;
  /**
   * Date time of the last login (e.G. see which users downloaded a file)
   *
   * @format date-time
   * @example "2023-05-17T10:57:30.129177"
   */
  lastLogin?: string | null;
  /**
   * DateTime when Welcome Mail was sent
   *
   * @format date-time
   * @example "2023-05-17T10:57:30.129177"
   */
  sentWelcomeMail?: string | null;
  /**
   * Shows is user is currently locked
   *
   * @example true
   */
  locked?: boolean;
  /**
   * Minimum version stage current user can see
   *
   * @example 3
   */
  minAllowedStage?: EVersionStage;
  /** @format guid */
  acceptedTermsId?: string | null;
  /**
   * LabelWin-Benutzername (Brücke für den Angebot-Export). Read-only über die API; gesetzt wird
   * er ausschließlich von Administratoren (und höher) über den dedizierten Endpoint.
   *
   * @example "treichert"
   */
  labelUser?: string | null;
}

/** Zusammengefasste Service-Einheiten-Info eines Support-Vertrags für performante Listen-Anzeige. */
export interface SupportContractServiceUnitsResponse {
  /**
   * Vertrags-ID
   * @format guid
   */
  contractId?: string;
  /** Externe Vertragsnummer */
  contractExternalId?: string;
  /** Vertragstitel */
  title?: string;
  /** Kundenname */
  customerName?: string;
  /**
   * Persistierte Gesamtsumme der Service-Einheiten
   * @format decimal
   */
  serviceEinheitenTotalSnapshot?: number;
  /**
   * Zeitpunkt der letzten Aktualisierung
   * @format date-time
   */
  serviceEinheitenTotalUpdatedAt?: string | null;
  /** True wenn Snapshot gegenüber aktueller Rezeptur veraltet ist */
  serviceEinheitenSnapshotStale?: boolean;
}

/** Preview-Response für die Neuberechnung der Service-Einheiten eines Support-Vertrags. */
export interface ContractReconciliationPreview {
  /**
   * Support-Vertrag ID
   * @format guid
   */
  contractId?: string;
  /**
   * Aktuell gespeicherter Gesamt-Snapshot des Vertrags
   * @format decimal
   */
  current?: number;
  /**
   * Neu berechneter Gesamtwert
   * @format decimal
   */
  recalculated?: number;
  /**
   * Differenz (Recalculated - Current)
   * @format decimal
   */
  delta?: number;
  /** Aufschlüsselung je Lizenz */
  licenses?: ReconciliationLicenseDiff[];
  /** Token zur Bestätigung der Änderung (10 min gültig) */
  token?: string;
  /**
   * Ablaufzeitpunkt des Tokens
   * @format date-time
   */
  expiresAt?: string;
}

/** Diff für eine einzelne Lizenz in der Contract-Reconcile-Preview. */
export interface ReconciliationLicenseDiff {
  /**
   * Lizenz-ID
   * @format guid
   */
  licenseId?: string;
  /**
   * Device-ID
   * @format guid
   */
  deviceId?: string;
  /** Device-Name */
  deviceName?: string;
  /** FileType-Name */
  fileTypeName?: string;
  /**
   * Gespeicherter Snapshot-Wert der Lizenz
   * @format decimal
   */
  current?: number;
  /**
   * Neu berechneter Wert dieser Lizenz. 0 wenn die Lizenz abgelaufen,
   * ausgeschlossen oder nicht aktiv ist — daraus ergibt sich dann ein negatives Delta.
   * @format decimal
   */
  recalculated?: number;
  /**
   * Differenz (Recalculated - Current)
   * @format decimal
   */
  delta?: number;
  /** True wenn die Lizenz aus der Berechnung ausgenommen ist */
  excluded?: boolean;
  /** True wenn die Lizenz abgelaufen ist */
  expired?: boolean;
  /** Status der Lizenz */
  status?: FileTypeLicenseStatus;
}

/** Antwort nach erfolgreicher Bestätigung (Confirm) einer Reconcile-Preview für einen Vertrag. */
export interface ContractReconciliationResult {
  /**
   * Vertrags-ID
   * @format guid
   */
  contractId?: string;
  /**
   * Neue, persistierte Gesamtsumme
   * @format decimal
   */
  serviceEinheitenTotalSnapshot?: number;
  /**
   * Zeitpunkt der Aktualisierung
   * @format date-time
   */
  updatedAt?: string;
  /**
   * Anzahl der mit aktualisierten Lizenzen
   * @format int32
   */
  licensesUpdated?: number;
}

/** Represents a data transfer object for fetching builds. */
export interface GetBuildsDto {
  /** Gets or sets the Id of the property. */
  id?: string;
  /** Gets or sets the name. */
  name?: string;
  /** Gets or sets the branch. */
  branch?: string;
  /** Gets or sets the URL property. */
  url?: string;
  /** Gets or sets the build type. */
  buildType?: string;
  /** Gets or sets the build type name. */
  buildTypeName?: string;
}

/** Represents a DTO (Data Transfer Object) for file download information. */
export interface FileDownloadDto {
  /** Represents the version key of a product. */
  versionKey?: VersionKey;
  /** Gets or sets the build ID of the BuildServer matching the version. */
  buildId?: string;
}

/** Das Ergebnis eines Generierungslaufs. */
export interface TemplateSuggestion {
  /** Hat das Modell eine verwertbare Vorlage geliefert? */
  success?: boolean;
  /** Die Vorlage als Bearbeitungsstand — noch nicht gespeichert. */
  template?: TemplateEdit | null;
  /** Klartext-Ursache bei Misserfolg. */
  error?: string | null;
  /** Was das Modell nicht zuordnen konnte; gehört vor die Augen des Bedieners. */
  notes?: string[];
}

/**
 * Der gewünschte Vollzustand einer Vorlage.
 *
 */
export interface TemplateEdit {
  /** Anzeigename. */
  title?: string;
  /** Wofür die Vorlage steht. */
  description?: string | null;
  /** Leitstelle, Feuerwache, Fahrzeug, JVA oder Industrie. */
  anlagenart?: string | null;
  /** Für welche Organisationen sie typisch ist. */
  kundentyp?: string[] | null;
  /** Woran sie im Gespräch zu erkennen ist. */
  stichworte?: string[] | null;
  /** Noch nicht fachlich bestätigt. */
  isDraft?: boolean;
  /** Was feststeht. */
  positions?: TemplatePositionEdit[] | null;
  /** Was üblich, aber nicht selbstverständlich ist. */
  optionalPositions?: TemplateOptionalPositionEdit[] | null;
  /** Was mengenmäßig feststeht, in der Auswahl aber nicht. */
  openPositions?: TemplateOpenPositionEdit[] | null;
}

/** Eine feststehende Position beim Bearbeiten einer Vorlage. */
export interface TemplatePositionEdit {
  /** Die Anforderung. */
  requirementId?: string;
  /**
   * Die typische Menge.
   * @format double
   */
  quantity?: number;
  /** Warum diese Menge typisch ist. */
  hint?: string | null;
}

/** Eine Position, die üblich ist, aber erfragt wird. */
export interface TemplateOptionalPositionEdit {
  /** Die Anforderung. */
  requirementId?: string;
  /**
   * Die typische Menge.
   * @format double
   */
  quantity?: number;
  /** Die Ja/Nein-Frage. */
  question?: string;
  /** Beim Übernehmen gleich mitgesetzt. */
  preselected?: boolean;
}

/** Eine Position, deren Menge feststeht und deren Auswahl offenbleibt. */
export interface TemplateOpenPositionEdit {
  /** Bereich, aus dem gewählt wird. */
  groupPath?: string;
  /**
   * Die typische Menge.
   * @format double
   */
  quantity?: number;
  /** Die Frage, die die Auswahl schließt. */
  question?: string;
}

/** Die Beschreibung oder Änderungsanweisung, aus der eine Vorlage entsteht. */
export interface TemplateSuggestionRequest {
  /**
   * Formloser Text — entweder die Beschreibung einer neuen Vorlage oder eine Änderung an der
   * bestehenden („GSM raus, dafür DECT rein").
   *
   */
  description?: string;
  /**
   * Der aktuelle Stand im Formular, falls geändert werden soll. Bewusst der Formularstand und
   * nicht die gespeicherte Fassung: sonst verlöre jede zweite Änderung die erste.
   *
   */
  current?: TemplateEdit | null;
}

/**
 * HTTP Return value for usage terms data
 *
 */
export interface GetTermsData {
  /**
   * Internal ID of the Terms (for technical purpose)
   *
   * @format guid
   */
  id?: string;
  /**
   * Public Version titpe
   *
   */
  versionTitle?: string;
  /**
   * Content of the Terms. Will be stored in Markdown text
   *
   */
  content?: string;
  /**
   * Date time when Terms where created.
   * Latest date is always the one which is checked by system.
   *
   * @format date-time
   */
  created?: string;
}

/**
 * HTTP POST value for usage terms data
 *
 */
export interface AddTermsData {
  /**
   * Title of the Term to be added (also used to version terms)
   *
   */
  versionTitle?: string;
  /**
   * Content of the Terms. Will be stored in Markdown text
   *
   */
  content?: string;
}

/** Represents user registration data. */
export interface RegisterUserData {
  /**
   * Gets or sets the customer name.
   * @minLength 1
   * @example "John Doe"
   */
  customer: string;
  /**
   * Gets or sets the email address.
   * @format email
   * @minLength 1
   * @example "john.doe@example.com"
   */
  email: string;
  /**
   * Gets or sets the gender of the user.
   * @minLength 1
   */
  sex: string;
  /**
   * Gets or sets the first name of the user.
   * @minLength 1
   * @example "John"
   */
  firstName: string;
  /**
   * Gets or sets the last name of the user.
   * @minLength 1
   * @example "Doe"
   */
  lastName: string;
  /**
   * Gets or sets the support contract ID (if applicable).
   * @example "12345-12345"
   */
  supportContractId?: string | null;
  /**
   * Gets or sets additional information provided by the user.
   * @example "Some additional information"
   */
  furtherInformation?: string | null;
  /**
   * Gets or sets a value indicating whether the user allows receiving extra emails.
   * @example true
   */
  allowExtraMail: boolean;
  /**
   * Gets or sets a value indicating whether the user allows saving data.
   * @example true
   */
  allowSaveData: boolean;
  /**
   * Gets or sets the ReCaptcha token for validation.
   * @minLength 1
   */
  reCaptchaToken: string;
}

/**
 * DTO der Übersichtsliste für offene/bestätigte Registrierungs-Follow-Ups.
 * Bewusst gleiche Felder wie das Entity, aber ohne audit-only IP, dafür mit
 * bereits aufgelöster AcknowledgedByEmail für die UI.
 *
 */
export interface RegistrationFollowUpDto {
  /** @format guid */
  id?: string;
  customer?: string;
  email?: string;
  sex?: string;
  firstName?: string;
  lastName?: string;
  supportContractId?: string | null;
  furtherInformation?: string | null;
  allowExtraMail?: boolean;
  allowSaveData?: boolean;
  /** @format date-time */
  createdAt?: string;
  /** @format date-time */
  acknowledgedAt?: string | null;
  acknowledgedByEmail?: string | null;
  /** @format date-time */
  reminderSentAt?: string | null;
}

/**
 * Return data for sign in process
 *
 */
export interface SignInUserData {
  /**
   * Current user id
   * @format guid
   */
  id?: string;
  /**
   * User E-Mail
   *
   */
  eMail?: string;
  /**
   * Username
   *
   */
  name?: string;
  /**
   * User Group
   *
   */
  userGroup?: EUserGroup;
  /**
   * Need change password after login
   *
   */
  needChangePassword?: boolean;
  /**
   * Authentication token. Empty when RequiresMfa is true —
   * in that case the client must finish the login via
   * POST /User/SignIn/Totp (or Passkey) using MfaToken.
   *
   */
  token?: string;
  /**
   * True when the user has a second factor enrolled and the password
   * step alone is not sufficient. Client must continue with TOTP
   * (or recovery code).
   *
   */
  requiresMfa?: boolean;
  /**
   * Short-lived intermediate token (5 min, claim purpose=mfa). Pass
   * back unchanged in the body of the second-step endpoint. Empty if
   * RequiresMfa is false.
   *
   */
  mfaToken?: string;
  /**
   * True if the user's role mandates MFA (DEVELOPMENT+) but no factor
   * is enrolled yet. The client receives a normal token but should
   * redirect the user to the MFA enrollment flow — the server
   * restricts access to non-enrollment endpoints with HTTP 403
   * ("mfa_setup_required") until at least one factor is active.
   *
   */
  mfaSetupRequired?: boolean;
}

/**
 * Body for POST /User/SignIn/Totp — completes a 2-step login.
 *
 */
export interface SignInTotpRequest {
  /**
   * The intermediate mfaToken received from /User/SignIn.
   * @minLength 1
   */
  mfaToken: string;
  /**
   * The 6-digit TOTP code or a recovery code.
   * @minLength 1
   */
  code: string;
}

/**
 * Wrapper for begin-style endpoints that return both a session id and
 * the options blob the browser needs to drive WebAuthn.
 *
 */
export interface WebAuthnOptionsDto {
  /** Server-side session id; pass back on the matching complete call. */
  sessionId?: string;
  /**
   * The Fido2 options object (CredentialCreateOptions or AssertionOptions).
   * Serialized as plain JSON for the browser to feed into WebAuthn.
   *
   */
  options?: any;
}

/**
 * Body for POST /User/SignIn/Passkey/Begin — passwordless login start.
 *
 */
export interface SignInPasskeyBeginRequest {
  /**
   * Optional username hint. If supplied, the AssertionOptions only
   * allow that user's credentials (better UX for non-discoverable
   * credentials). If omitted, all credentials are allowed (resident
   * passkey / "Sign in with passkey" button).
   *
   */
  username?: string | null;
}

/**
 * Body for POST /User/SignIn/Passkey/Complete — passwordless login finish.
 *
 */
export interface SignInPasskeyCompleteRequest {
  /**
   * The session id returned by /User/SignIn/Passkey/Begin.
   * @minLength 1
   */
  sessionId: string;
  /**
   * The AuthenticatorAssertionRawResponse from navigator.credentials.get().
   * Forwarded to Fido2NetLib for verification.
   *
   */
  response: AuthenticatorAssertionRawResponse;
}

export interface AuthenticatorAssertionRawResponse {
  /** @minLength 1 */
  id: string;
  /**
   * @format byte
   * @minLength 1
   */
  rawId: string;
  response?: AssertionResponse | null;
  type: PublicKeyCredentialType;
  /** @deprecated */
  extensions?: AuthenticationExtensionsClientOutputs | null;
  clientExtensionResults: AuthenticationExtensionsClientOutputs;
}

export interface AssertionResponse {
  /** @format byte */
  authenticatorData?: string;
  /** @format byte */
  signature?: string;
  /** @format byte */
  clientDataJSON?: string;
  /** @format byte */
  userHandle?: string | null;
}

export enum PublicKeyCredentialType {
  PublicKey = 0,
  Invalid = 1,
}

export interface AuthenticationExtensionsClientOutputs {
  "example.extension.bool"?: boolean | null;
  appid?: boolean;
  exts?: string[] | null;
  uvm?: number[][] | null;
  credProps?: CredentialPropertiesOutput | null;
  prf?: AuthenticationExtensionsPRFOutputs | null;
  largeBlob?: AuthenticationExtensionsLargeBlobOutputs | null;
  credProtect?: CredentialProtectionPolicy | null;
}

export interface CredentialPropertiesOutput {
  rk?: boolean;
  authenticatorDisplayName?: string | null;
}

export interface AuthenticationExtensionsPRFOutputs {
  enabled?: boolean;
  results?: AuthenticationExtensionsPRFValues | null;
}

export interface AuthenticationExtensionsPRFValues {
  /** @format byte */
  first?: string;
  /** @format byte */
  second?: string | null;
}

export interface AuthenticationExtensionsLargeBlobOutputs {
  supported?: boolean;
  /** @format byte */
  blob?: string | null;
  written?: boolean;
}

export enum CredentialProtectionPolicy {
  UserVerificationOptional = 1,
  UserVerificationOptionalWithCredentialIdList = 2,
  UserVerificationRequired = 3,
}

/**
 * Snapshot of a user's MFA enrollment for the management UI.
 *
 */
export interface MfaStatusDto {
  /** True once a TOTP secret has been confirmed with a valid code. */
  totpEnabled?: boolean;
  /**
   * Timestamp the TOTP factor was activated.
   * @format date-time
   */
  totpEnabledAt?: string | null;
  /**
   * Number of unused recovery codes remaining.
   * @format int32
   */
  remainingRecoveryCodes?: number;
  /**
   * Registered passkey count.
   * @format int32
   */
  passkeyCount?: number;
  /** List of registered passkeys for management. */
  passkeys?: PasskeyDto[];
  /**
   * True if the user's role requires MFA (DEVELOPMENT+) but no factor
   * is currently enrolled — UI should redirect to setup.
   *
   */
  mfaSetupRequired?: boolean;
  /**
   * True if the user's role requires MFA — even if currently enrolled.
   * Useful for explaining to the user why disable is blocked.
   *
   */
  mfaRequiredByRole?: boolean;
}

/**
 * Public view of a registered passkey (no key material).
 *
 */
export interface PasskeyDto {
  /**
   * Surrogate id; use for DELETE.
   * @format guid
   */
  id?: string;
  /** User-supplied label. */
  nickname?: string | null;
  /**
   * AAGUID — model identifier of the authenticator.
   * @format guid
   */
  aaguid?: string;
  /** True if the credential is synced to a cloud provider. */
  backupEligible?: boolean;
  /** True if the credential is currently backed up. */
  backupState?: boolean;
  /** True if registration required user verification. */
  userVerified?: boolean;
  /**
   * Creation timestamp.
   * @format date-time
   */
  createdAt?: string;
  /**
   * Last successful authentication timestamp.
   * @format date-time
   */
  lastUsedAt?: string | null;
}

/**
 * Result of a TOTP setup-begin call. Returned once; the client must show
 * either the QR (otpauth URI) or the manual key, then post back the
 * 6-digit code to /Mfa/Totp/Enable to finish enrollment.
 *
 */
export interface TotpSetupDto {
  /** Base32-encoded shared secret. Show as fallback if the QR can't be scanned. */
  secret?: string;
  /** otpauth:// URI for QR encoding. */
  otpAuthUri?: string;
  /** Issuer label embedded in the URI (matches the app config). */
  issuer?: string;
  /** Account label (the user's email) embedded in the URI. */
  account?: string;
}

/**
 * Result of enabling TOTP. The recovery codes are returned exactly once
 * and cannot be retrieved again — clients must instruct the user to
 * store them.
 *
 */
export interface EnableTotpResultDto {
  /** 10 plaintext recovery codes — show once, never again. */
  recoveryCodes?: string[];
}

/**
 * Body for POST /Mfa/Totp/Enable. The server verifies the code against
 * the secret returned by /Mfa/Totp/Setup; only on a valid code is the
 * factor activated and recovery codes generated.
 *
 */
export interface EnableTotpRequest {
  /**
   * The 6-digit TOTP code from the authenticator app.
   * @minLength 1
   */
  code: string;
  /**
   * The base32 secret returned from /Mfa/Totp/Setup.
   * @minLength 1
   */
  secret: string;
}

/**
 * Body for disabling TOTP. Requires either the current TOTP code or one
 * of the unused recovery codes — never just a session JWT, so a stolen
 * session can't silently strip the second factor.
 *
 */
export interface DisableTotpRequest {
  /**
   * Current 6-digit code, or one of the recovery codes.
   * @minLength 1
   */
  code: string;
}

/**
 * Body for the passkey registration complete step.
 *
 */
export interface RegisterPasskeyCompleteRequest {
  /**
   * Session id from begin.
   * @minLength 1
   */
  sessionId: string;
  /** The AuthenticatorAttestationRawResponse from navigator.credentials.create(). */
  response: AuthenticatorAttestationRawResponse;
  /** Optional nickname; persisted with the credential. */
  nickname?: string | null;
}

export interface AuthenticatorAttestationRawResponse {
  /** @minLength 1 */
  id: string;
  /**
   * @format byte
   * @minLength 1
   */
  rawId: string;
  type: PublicKeyCredentialType;
  response: AttestationResponse;
  /** @deprecated */
  extensions?: AuthenticationExtensionsClientOutputs | null;
  clientExtensionResults: AuthenticationExtensionsClientOutputs;
}

export interface AttestationResponse {
  /** @format byte */
  attestationObject?: string | null;
  /** @format byte */
  clientDataJSON?: string | null;
  transports: AuthenticatorTransport[];
}

export enum AuthenticatorTransport {
  Usb = 0,
  Nfc = 1,
  Ble = 2,
  SmartCard = 3,
  Hybrid = 4,
  Internal = 5,
}

/**
 * HTTP POST type to add new user
 *
 */
export interface AddUserData {
  /**
   * E-Mail (used for login)
   *
   */
  eMail?: string;
  /**
   * Full name of the user
   *
   */
  name?: string;
  /**
   * Salutation including the name
   *
   */
  anrede?: string;
  /**
   * User group with access rights
   *
   */
  userGroup?: EUserGroup;
  /**
   * Minimum version stage current user can see
   *
   */
  minAllowedStage?: EVersionStage;
  /**
   * First password (temp password)
   *
   */
  password?: string;
  /**
   * Repeated first password (temp password) to ensure password is correct
   *
   */
  passwordRepeat?: string;
}

/**
 * HTTP POST type to edit existing user
 *
 */
export interface EditUserData {
  /**
   * New full name of the user
   *
   */
  name?: string | null;
  /**
   * New salutation including name
   *
   */
  anrede?: string | null;
  /**
   * New UserGroup
   *
   */
  userGroup?: EUserGroup | null;
  /**
   * Minimum version stage current user can see
   *
   */
  minAllowedStage?: EVersionStage | null;
  /**
   * optional new password
   *
   */
  password?: string | null;
  /**
   * optional new password repeat
   *
   */
  passwordRepeat?: string | null;
}

/**
 * Request body for setting a user's LabelWin user (the offer-export bridge).
 *
 */
export interface SetLabelUserData {
  /**
   * The LabelWin username, or null/empty to clear the mapping.
   *
   * @example "treichert"
   */
  labelUser?: string | null;
}

/**
 * HTTP POST to change own user
 *
 */
export interface ChangePasswordData {
  /**
   * Current used password (can be temp password or current password)
   *
   */
  currentPassword?: string;
  /**
   * New user password
   *
   */
  newPassword?: string;
  /**
   * New repeated password
   *
   */
  newPasswordRepeat?: string;
}

export interface GetSupportUserData {
  /**
   * UUID of the user
   *
   * @format guid
   * @example "cda9cb75-6479-4d05-9560-343935a0800d"
   */
  id?: string;
  /**
   * E-Mail Address of the user
   *
   * @example "max.mustermann@musterstadt.de"
   */
  eMail?: string;
  /**
   * Full name of the user
   *
   * @example "Max Mustermann"
   */
  name?: string;
  /**
   * Saltuation including name of the user
   *
   * @example "Sehr geehrter Herr Max Mustermann,"
   */
  anrede?: string;
  /**
   * Usergroup with specified access rights
   *
   */
  userGroup?: EUserGroup;
  /**
   * Date Time when user was created
   *
   * @format date-time
   * @example "2023-05-17T10:57:30.129177"
   */
  created?: string;
  /**
   * Date time of the last login (e.G. see which users downloaded a file)
   *
   * @format date-time
   * @example "2023-05-17T10:57:30.129177"
   */
  lastLogin?: string | null;
  /**
   * Shows is user is currently locked
   *
   * @example true
   */
  locked?: boolean;
  /**
   * Minimum version stage current user can see
   *
   * @example 3
   */
  minAllowedStage?: EVersionStage;
  /** List all support contracts of the user */
  supportContracts?: GetSupportContractData[];
  /** List all filter tags of the user */
  filterTags?: GetFilterTagData[];
  /** Get terms user accepted */
  acceptedTerms?: GetTermsData | null;
}

/**
 * HTTP POST Data to add new version
 *
 */
export interface AddVersionData {
  /** VersionKey to find specific version */
  versionKey?: VersionKey;
  /**
   * Set version stage for the current version
   *
   * @example "EVersionStage.RELEASE_CANDIDATE"
   */
  stage?: EVersionStage;
  /**
   * Short version description (name of the version)
   *
   */
  description?: string;
  /**
   * Summary of all changes as VersionChanges object.
   * Can be used for public displaying of the version
   *
   */
  changes?: VersionChanges;
  /**
   * Description for critical updates. If empty current version is NOT a critical version.
   *
   */
  criticalUpdate?: string | null;
  /**
   * Internal information (only for office, development, ...)
   *
   */
  internalInformation?: string;
  /**
   * Date when version was / will be approved
   * @format date
   */
  approved?: string | null;
  /** Header of version */
  header?: string | null;
  /** Footer of version */
  footer?: string | null;
}

/**
 * Lightweight version node used for hierarchical listing endpoints. Does not include
 * the file list — files have to be requested separately per version.
 *
 */
export interface VersionTreeNodeDto {
  /** @format int32 */
  major?: number;
  /** @format int32 */
  minor?: number;
  /** @format int32 */
  patch?: number;
  versionId?: string;
  subtitle?: string;
  /**
   * Version Stage
   *
   */
  stage?: EVersionStage;
  /** @format date */
  approved?: string | null;
  /** @format date-time */
  createdAt?: string;
  header?: string | null;
  footer?: string | null;
  description?: string;
  criticalUpdate?: string | null;
  /** @format date */
  revokedAt?: string | null;
  revokedReason?: string | null;
  downloadBlocked?: boolean;
  downloadBlockedReason?: string | null;
  /**
   * Version changes structure for storage as JSON in Databaseö
   *
   */
  changes?: VersionChanges;
  /**
   * Internal information. Only populated for OFFICE / DEVELOPMENT consumers.
   *
   */
  internalInformation?: string | null;
  productId?: string;
  childVersions?: VersionTreeNodeDto[];
}

/**
 * Request body for revoking a version. The version stays visible to customers but is
 * annotated with the reason text.
 *
 */
export interface RevokeVersionRequest {
  /**
   * Identifies the version to revoke.
   *
   */
  versionKey?: VersionKey;
  /**
   * Optional reason text shown to customers. Empty / whitespace is treated as null.
   *
   */
  reason?: string | null;
}

/**
 * Request body for blocking or unblocking the download of a single version.
 *
 */
export interface SetDownloadBlockedRequest {
  /**
   * Identifies the version.
   *
   */
  versionKey?: VersionKey;
  /**
   * When true the download is blocked. When false the block is cleared.
   *
   */
  blocked?: boolean;
  /**
   * Optional reason text shown to customers when blocked. Ignored when
   * Blocked is false.
   *
   */
  reason?: string | null;
}

/** Data required to check file download permissions before actual download. */
export interface GetFileCheckDownload {
  /**
   * Determines if the file can be downloaded.
   * @example false
   */
  canDownload?: boolean;
  /**
   * Message to be communicated to the user regarding the download.
   * @example "You have exceeded your download limit."
   */
  message?: string;
  /**
   * The maximum allowed major version for download.
   * @format int32
   * @example 1
   */
  maxMajorVersion?: number;
  /**
   * The maximum allowed minor version for download.
   * @format int32
   * @example 0
   */
  maxMinorVersion?: number;
  /**
   * The maximum allowed patch version for download.
   * @format int32
   * @example 0
   */
  maxPatchVersion?: number;
}

/** Represents a YouTrack issue with basic information. */
export interface YouTrackIssueDTO {
  /** Gets or sets the issue ID as displayed in YouTrack (e.g., "SP-123"). */
  idReadable?: string;
  /** Gets or sets the issue summary/title. */
  summary?: string;
  /** Gets or sets the current status of the issue. */
  status?: string | null;
  /** Gets or sets the Support ID associated with this ticket. */
  supportId?: string | null;
  /** Gets or sets the current version (Aktuelle Version) of the software. */
  currentVersion?: string | null;
  /** Gets or sets the maintenance contract number (Wartungsvertrag Nummer). */
  maintenanceContractNumber?: string | null;
  /**
   * Gets or sets the creation timestamp (Unix timestamp in milliseconds).
   * @format int64
   */
  created?: number | null;
  /**
   * Gets or sets the last update timestamp (Unix timestamp in milliseconds).
   * @format int64
   */
  updated?: number | null;
}

/**
 * Statistics summary for YouTrack tickets.
 *
 */
export interface YouTrackStatisticsDto {
  /**
   * Total number of tickets in the query set.
   *
   * @format int32
   */
  totalTickets?: number;
  /**
   * Number of open tickets.
   *
   * @format int32
   */
  openTickets?: number;
  /**
   * Number of closed tickets.
   *
   * @format int32
   */
  closedTickets?: number;
  /**
   * Total number of open Helpdesk tickets (only available for DEVELOPMENT users).
   *
   * @format int32
   */
  totalOpenHelpdeskTickets?: number | null;
  /**
   * Average response time in hours (based on public agent comments).
   *
   * @format double
   */
  averageResponseTimeHours?: number | null;
  /**
   * Number of tickets used for response time calculation.
   *
   * @format int32
   */
  responseTimeSampleSize?: number;
  /**
   * Grouped tickets by status.
   *
   */
  ticketsByStatus?: YouTrackStatusCountDto[];
  /**
   * List of open tickets.
   *
   */
  openTicketsList?: YouTrackIssueDTO[];
}

/**
 * Status grouping for tickets.
 *
 */
export interface YouTrackStatusCountDto {
  /**
   * Status name.
   *
   */
  status?: string;
  /**
   * Count for the status.
   *
   * @format int32
   */
  count?: number;
}

/** Represents detailed information about a YouTrack issue including description and comments. */
export type YouTrackIssueDetailDTO = YouTrackIssueDTO & {
  /** Gets or sets the issue description. */
  description?: string | null;
  /** Gets or sets the reporter/creator of the issue. */
  reporter?: YouTrackAuthorDTO | null;
  /** Gets or sets the list of public comments on the issue. */
  comments?: YouTrackCommentDTO[];
};

export interface YouTrackAuthorDTO {
  login?: string;
  displayName?: string;
}

export interface YouTrackCommentDTO {
  text?: string;
  author?: YouTrackAuthorDTO;
  /** @format int64 */
  created?: number;
  isDeleted?: boolean;
  /** Indicates the type of author: Mine (0), Other (1), or Agent (2). */
  authorType?: CommentAuthorType;
}

/** Defines the type of comment author. */
export enum CommentAuthorType {
  Mine = 0,
  Other = 1,
  Agent = 2,
}

/**
 * Request model for creating a new comment on a YouTrack issue.
 * The comment will be created on behalf of the currently authenticated user.
 */
export interface CreateCommentRequest {
  /** The text content of the comment. */
  text?: string;
  /**
   * Whether the comment should be publicly visible.
   * If true, everyone can see the comment. If false, only project team members can see it.
   */
  isPublic?: boolean;
}

/** Anfrage an den Kalkulations-Endpunkt. */
export interface CalculateRequest {
  /** Die Mengen-Eingaben je Anforderung. */
  inputs?: RequirementInput[];
  /** Optionaler Katalog-/Modulfilter (z.B. "fw"). */
  moduleFilter?: string;
  /**
   * Optionale Preisliste (Artikelnummer → Listenpreis). Übersteuert die Katalogpreise – die
   * Schnittstelle für die live aus LabelWin gepflegten Preise (M2). Ist sie leer/null, gelten
   * die Katalog-Fallback-Preise (vkf1 + lohn_netto).
   */
  priceOverrides?: Record<string, number>;
}

/**
 * Eine Eingabezeile des Anwenders zu genau einer Anforderung – das Gegenstück zu
 * einer Zeile der von ZBEOffice erzeugten Anforderungs-XLS (Spalten id, menge, ZBV,
 * Konfiguration, Bereich). Dies ist die Eingabe der Kalkulation.
 */
export interface RequirementInput {
  /** Die xml:id der Anforderung (z.B. "R.CPU.5"). */
  id?: string;
  /**
   * Vom Anwender gewählte Anzahl. 0 = nicht ausgewählt.
   * @format double
   */
  menge?: number;
  /**
   * Optionales Zusatz-Bestell-Verhalten im Format nameOfSet|flags.
   * Flags: S = Satz aufteilen (split), O = optionale Position.
   */
  zbv?: string;
  /** Optionaler Konfigurationsname (selten genutzt). */
  konfiguration?: string;
  /** Standort/Area (Vorgabe "A", in ZBEOffice frei wählbar). */
  bereich?: string;
}

/**
 * Anfrage an den instanzbasierten Kalkulations-Endpunkt. Project ist zugleich das
 * per JSON gespeicherte/geladene Projekt.
 */
export interface ProjectCalculateRequest {
  /**
   * Eingabe eines kompletten Angebots/Projekts: Projektname + Instanzliste + Standorte. Zugleich das
   * JSON-Austauschformat (Ersatz für die alte Excel-/.creq-Ablage); wird so gespeichert/geladen.
   */
  project?: ProjectInput;
  moduleFilter?: string;
  priceOverrides?: Record<string, number>;
}

/**
 * Anfrage an den LabelWin-Export. Kalkuliert das Project und schreibt die
 * Positionen über den Connector in die Stapel-/Zwischenablage-MDB des Benutzers
 * User. Der Connector löst aus dem Benutzernamen den MDB-Pfad auf und mappt
 * die Positionen auf das Access-Schema – der Kalkulator reicht nur durch.
 */
export interface LabelWinExportRequest {
  /** Das instanzbasierte Projekt (wie bei ProjectCalculateRequest). */
  project?: ProjectInput;
  /**
   * LabelWin-Benutzername, dessen Stapel-MDB beschrieben wird. Solange der Kalkulator noch kein
   * Benutzerkonzept kennt, gilt der Platzhalter PlaceholderUser
   * ("treichert") – später durch den echten angemeldeten Benutzer zu ersetzen.
   */
  user?: string;
  /** Optionaler Katalog-/Modulfilter. */
  moduleFilter?: string;
  /** Optionale Preisüberschreibungen (haben Vorrang vor Connector-Live-Preisen). */
  priceOverrides?: Record<string, number>;
}

/**
 * Anfrage an den Leistungsmerkmale-/LV-Endpunkt. Kalkuliert das Project und
 * rendert dessen Leistungsbeschreibung.
 */
export interface LeistungenRequest {
  /** Das instanzbasierte Projekt (wie bei ProjectCalculateRequest). */
  project?: ProjectInput;
  /** Optionaler Katalog-/Modulfilter. */
  moduleFilter?: string;
  /** Domänen-Whitelist (UK/Fu/TI/…) zum Ein-/Ausblenden von Merkmalsgruppen. Leer/null = alle. */
  domains?: string[] | null;
  /** Optionale Preisüberschreibungen (Artikelnummer → Listenpreis). */
  priceOverrides?: Record<string, number>;
}

/** Editierbare Felder eines Katalog-Artikels (nur gesetzte Felder werden geändert). */
export interface ArticleEdit {
  beschreibung?: string | null;
  /** @format decimal */
  vkf1?: number | null;
  /** @format decimal */
  netto1?: number | null;
  /** @format decimal */
  lohnNetto?: number | null;
  /** @format decimal */
  lohnMinuten?: number | null;
  articleGroup?: string | null;
  nullpreisOk?: boolean | null;
  lvOff?: boolean | null;
  dirOff?: boolean | null;
  staffel?: PriceTier[] | null;
}

/**
 * Eine Bande einer progressiven Mengenstaffel eines Katalog-Artikels (<preisstaffel>).
 * Die Einheiten von der vorigen Grenze bis UpTo werden mit UnitPrice
 * berechnet (graduierter Grenzpreis), die darüber liegenden mit der nächsten Bande – so steigen die
 * Gesamtkosten stets monoton. Siehe docs/engine-spec.md §10.
 */
export interface PriceTier {
  /**
   * Obere Mengengrenze (inklusive, kumuliert ab 1). null = offene oberste Stufe.
   * @format decimal
   */
  upTo?: number | null;
  /**
   * Stückpreis der Einheiten dieser Bande (vkf1 + lohn_netto).
   * @format decimal
   */
  unitPrice?: number;
}

/**
 * Neuer Katalog-Artikel. GroupTitle wählt die Ziel-<artikelgruppe>
 * über deren erstes <beschreibung>; ist er leer/unbekannt, wird die letzte Gruppe genommen.
 * Achtung: ArticleGroup (a_gruppe) ist das Preisband, NICHT die artikelgruppe.
 */
export interface ArticleCreate {
  articleNumber?: string;
  groupTitle?: string;
  articleGroup?: string;
  typ?: string;
  catalogs?: string;
  beschreibung?: string | null;
  /** @format decimal */
  vkf1?: number;
  /** @format decimal */
  netto1?: number;
  /** @format decimal */
  lohnNetto?: number;
  /** @format decimal */
  lohnMinuten?: number;
}

/** Gewünschter Vollzustand einer Anforderung (PUT) – das Element wird komplett neu gerendert. */
export interface RequirementEdit {
  articleGroup?: string;
  titel?: string;
  details?: string | null;
  eingabe?: string | null;
  implicit?: boolean;
  /** Lizenz-Kennung des Software-Moduls (Attribut license_flag) oder null. */
  licenseFlag?: string | null;
  /** Eingabeart-Override der Anforderung (Attribut eingabe_typ); null = Gruppen-Default. */
  eingabeTyp?: InputKind | null;
  /** Standort-Typen, für die die Anforderung wählbar ist (Attribut verfuegbar_fuer, Whitelist); leer = alle. */
  availableFor?: StandortTyp[];
  parameters?: ParameterDto[];
  articleRefs?: ArtikelRefDto[];
  resourceRefs?: RessourceRefDto[];
  optionGroups?: OptionGroupDto[];
  /** Gesprächsfrage in Kundensprache (<frage>) oder null. */
  frage?: string | null;
  /** Kundensprache-Begriffe, kommagetrennt (<stichworte>) oder null. */
  stichworte?: string | null;
  frageKiGeneriert?: boolean;
  stichworteKiGeneriert?: boolean;
}

/**
 * Eingabeart einer Anforderung (aus dem eingabe_typ-Attribut bzw. dem
 * <eingabe>-Element). Steuert das UI-Element im Eingabeformular.
 */
export enum InputKind {
  Spin = "Spin",
  Checkbox = "Checkbox",
  Radio = "Radio",
}

/** Ein <parameter> (key/value, optional type). */
export interface ParameterDto {
  key?: string;
  value?: string;
  type?: string | null;
}

/** Ein <artikel_ref> – genau eines von ANr/GId ist gesetzt. */
export interface ArtikelRefDto {
  aNr?: string | null;
  gId?: string | null;
}

/** Ein <ressource_ref> mit optional inneren <artikel_ref>. */
export interface RessourceRefDto {
  name?: string;
  /** @format int32 */
  anzahl?: number;
  /** @format int32 */
  per?: number | null;
  articleRefs?: ArtikelRefDto[];
}

/** Eine Optionsgruppe (<optionen>-Block) – Typ/Titel/mandatory gelten für alle ihre Optionen. */
export interface OptionGroupDto {
  /** Überschrift der Gruppe (<optionen title>) oder null. */
  title?: string | null;
  /** Eingabe-Widget der Gruppe (Checkbox/Radio/Spin). */
  eingabeTyp?: InputKind;
  /** Gegenseitiger Ausschluss der Optionen? (Radio immer; Spin via exklusiv="1"). Ersetzt das alte r_gruppe. */
  exclusive?: boolean;
  /** Muss (bei exklusiven Gruppen) eine Option gewählt sein? (<optionen mandatory="1">). */
  mandatory?: boolean;
  /** Die Optionen dieser Gruppe. */
  options?: OptionDto[];
}

/** Ein <option> innerhalb einer Gruppe. Das Eingabe-Widget kommt von der Gruppe. */
export interface OptionDto {
  /** Verweis auf die xml:id der Options-Anforderung. */
  anforderungId?: string;
  /**
   * Vorgabemenge der Option (Attribut anzahl).
   * @format int32
   */
  anzahl?: number | null;
  /** Beim Hinzufügen direkt aktiv (Attribut default="1"). */
  default?: boolean;
  /** Im Angebotstext gedruckt? false = ausgeblendet (Attribut im_angebot="0"). */
  imAngebot?: boolean;
  /** Ersetzt den Eltern-Anforderungstext im Angebot komplett (Attribut ersetzt_beschreibung="1"). */
  ersetztBeschreibung?: boolean;
}

/** Neue Anforderung (POST): Id + Ziel-Category + Inhalt. */
export interface RequirementCreate {
  id?: string;
  category?: string;
  /** Gewünschter Vollzustand einer Anforderung (PUT) – das Element wird komplett neu gerendert. */
  body?: RequirementEdit;
}

/**
 * Eine komplette Leistungsmerkmal-Datei: die Wurzel-<lmg>, die erhaltene Stylesheet-Referenz
 * (<?xml-stylesheet href="…"?>) sowie etwaige Dokument-Kommentare vor und nach der Wurzel
 * (z. B. der „Hinweis: Historie …"-Block am Dateiende).
 */
export interface LmgDocument {
  /** href der xml-stylesheet-PI (meist "lm.css") oder null. */
  stylesheetHref?: string | null;
  /** Kommentare zwischen Stylesheet/Wurzel-Anfang (Dokumentebene), in Reihenfolge. */
  leadingComments?: string[];
  /** Der Wurzelknoten (immer eine Gruppe). */
  root?: LmNodeDto;
  /** Kommentare nach </lmg> (Dokumentebene), in Reihenfolge. */
  trailingComments?: string[];
}

/**
 * Ein roher Knoten einer lm-Datei: 1:1-Abbild eines <lmg>, <lm> oder eines
 * XML-Kommentars. Alle Felder werden unverändert gelesen und geschrieben, damit Laden → Speichern
 * verlustfrei ist (abgesehen von der Format-Normalisierung wie bei Katalog/Anforderungen).
 */
export interface LmNodeDto {
  /** Gruppe, Merkmal oder Kommentar. */
  kind?: LmNodeKind;
  /** Bei Comment: der rohe Kommentartext (ohne <!--/-->); sonst null. */
  comment?: string | null;
  /** Optionale Kennung (xml:id); im Bestand nicht eindeutig. */
  xmlId?: string | null;
  /** Domänen-Filter (@domaene), erbt an Kinder. */
  domaene?: string | null;
  /** Roher Wert von @optional ("1" = Zusatz, "2" = optional+bedingt); kein bool, da "2" real vorkommt. */
  optional?: string | null;
  /** Roher Wert von @abhaengig ("1" = von der Domäne abhängig); vom Generator noch nicht ausgewertet. */
  abhaengig?: string | null;
  /** Bedingte Aufnahme (@condition, z. B. "intercom"); vom Generator (v1) noch nicht ausgewertet. */
  condition?: string | null;
  /** Standard-Titel. */
  titel?: string | null;
  /** Titel-Variante für die Leistungsangabe (Mode LM). */
  titelLm?: string | null;
  /** Titel-Variante für die LV-„muss"-Form (Mode REQ). */
  titelReq?: string | null;
  /** Standard-Beschreibung. */
  doc?: string | null;
  /** Beschreibungs-Variante für die Leistungsangabe (Mode LM). */
  docLm?: string | null;
  /** Beschreibungs-Variante für die LV-„muss"-Form (Mode REQ). */
  docReq?: string | null;
  /** Geschwister-Strom: bei Gruppen verschachtelte Gruppen/Merkmale + Kommentare in Dokumentreihenfolge; bei Merkmalen nur Kommentare; bei Kommentaren leer. */
  children?: LmNodeDto[];
}

/** Art eines LmNodeDto: Gruppe (<lmg>), Merkmal (<lm>) oder XML-Kommentar. */
export enum LmNodeKind {
  Group = "Group",
  Feature = "Feature",
  Comment = "Comment",
}

/** Leichtgewichtiger Listeneintrag (ohne den vollständigen Eingabestand) für die Projektübersicht. */
export interface ProjectListItem {
  /** @format guid */
  id?: string;
  name?: string;
  customerName?: string | null;
  /** @format guid */
  supportContractId?: string | null;
  lastCalculation?: ProjectCalculationSummary | null;
  updatedBy?: string | null;
  /** @format date-time */
  updatedAt?: string;
}

/**
 * Zwischengespeicherte Kurzfassung der zuletzt durchgeführten Kalkulation eines Projekts.
 * Wird beim Speichern vom Client mitgegeben (er hat das Kalkulationsergebnis bereits) und dient
 * der schnellen Listenansicht ("letzte Kalkulation"), ohne neu rechnen zu müssen.
 */
export interface ProjectCalculationSummary {
  /**
   * Netto-Gesamtsumme der letzten Kalkulation.
   * @format decimal
   */
  totalNet?: number;
  /**
   * Anzahl der Positionen im Ergebnis.
   * @format int32
   */
  positionCount?: number;
  /**
   * Zeitpunkt der Kalkulation (UTC).
   * @format date-time
   */
  calculatedAt?: string;
}

/**
 * Ein gespeichertes Projekt inklusive Metadaten (Bearbeiter, Zeitstempel) und dem vollständigen
 * Kalkulator-Eingabestand.
 */
export interface StoredProject {
  /** @format guid */
  id?: string;
  name?: string;
  /**
   * Eingabe eines kompletten Angebots/Projekts: Projektname + Instanzliste + Standorte. Zugleich das
   * JSON-Austauschformat (Ersatz für die alte Excel-/.creq-Ablage); wird so gespeichert/geladen.
   */
  project?: ProjectInput;
  customerReference?: string | null;
  customerName?: string | null;
  /** @format guid */
  supportContractId?: string | null;
  lastCalculation?: ProjectCalculationSummary | null;
  createdBy?: string | null;
  /** @format date-time */
  createdAt?: string;
  updatedBy?: string | null;
  /** @format date-time */
  updatedAt?: string;
  /** Notizen, die der Kunde über den Freigabe-Link geschrieben hat. */
  customerNotes?: string | null;
  customerDetails?: CustomerDetails | null;
  /**
   * Notizen, die der Bearbeiter geschrieben hat (Telefonnotizen, Merkposten). Erscheinen nie
   * im Angebot und werden nie an eine Link-Session ausgeliefert — siehe
   * InternalNotes.
   */
  internalNotes?: string | null;
}

/**
 * Speicheranfrage für ein Projekt. Id ist null beim Neuanlegen und gesetzt
 * beim Aktualisieren eines bestehenden Projekts.
 */
export interface SaveProjectRequest {
  /**
   * Bestehende Projekt-Id (Update) oder null (Neuanlage).
   * @format guid
   */
  id?: string | null;
  /** Anzeigename des Projekts. */
  name?: string;
  /** Der vollständige Kalkulator-Eingabestand (Austauschformat). */
  project?: ProjectInput;
  /** Optionale Kundennummer (Freitext). */
  customerReference?: string | null;
  /** Optionaler Kundenname (Freitext / denormalisiert). */
  customerName?: string | null;
  /**
   * Optionaler Verweis auf einen Support-Vertrag (Host-spezifische Id).
   * @format guid
   */
  supportContractId?: string | null;
  /** Optionale Kurzfassung der zuletzt durchgeführten Kalkulation. */
  lastCalculation?: ProjectCalculationSummary | null;
  /**
   * Interne Notizen des Bearbeiters — Gesprächsmitschrift, Telefonnotizen, Merkposten
   * („ruft Donnerstag zurück", „Budget angeblich 80k"). Bewusst hier und nicht im
   * ProjectInput: der wird vom FragmentRenderer ins Angebot gerendert und beim
   * JSON-Export mitgegeben. Interne Notizen dürfen weder im Angebot erscheinen noch beim Export
   * mitreisen — die Trennung ist deshalb strukturell und nicht bloß eine Regel.
   * Nicht zu verwechseln mit CustomerNotes: die schreibt der Kunde.
   */
  internalNotes?: string | null;
}

import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse, HeadersDefaults, ResponseType } from "axios";

export type QueryParamsType = Record<string | number, any>;

export interface FullRequestParams extends Omit<AxiosRequestConfig, "data" | "params" | "url" | "responseType"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType;
  /** request body */
  body?: unknown;
}

export type RequestParams = Omit<FullRequestParams, "body" | "method" | "query" | "path">;

export interface ApiConfig<SecurityDataType = unknown> extends Omit<AxiosRequestConfig, "data" | "cancelToken"> {
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void;
  secure?: boolean;
  format?: ResponseType;
}

export enum ContentType {
  Json = "application/json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance;
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private secure?: boolean;
  private format?: ResponseType;

  constructor({ securityWorker, secure, format, ...axiosConfig }: ApiConfig<SecurityDataType> = {}) {
    this.instance = axios.create({ ...axiosConfig, baseURL: axiosConfig.baseURL || "http://localhost:5297" });
    this.secure = secure;
    this.format = format;
    this.securityWorker = securityWorker;
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected mergeRequestParams(params1: AxiosRequestConfig, params2?: AxiosRequestConfig): AxiosRequestConfig {
    const method = params1.method || (params2 && params2.method);

    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((method && this.instance.defaults.headers[method.toLowerCase() as keyof HeadersDefaults]) || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected stringifyFormItem(formItem: unknown) {
    if (typeof formItem === "object" && formItem !== null) {
      return JSON.stringify(formItem);
    } else {
      return `${formItem}`;
    }
  }

  protected createFormData(input: Record<string, unknown>): FormData {
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key];
      const propertyContent: any[] = property instanceof Array ? property : [property];

      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File;
        formData.append(key, isFileType ? formItem : this.stringifyFormItem(formItem));
      }

      return formData;
    }, new FormData());
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<AxiosResponse<T>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const responseFormat = format || this.format || undefined;

    if (type === ContentType.FormData && body && body !== null && typeof body === "object") {
      body = this.createFormData(body as Record<string, unknown>);
    }

    if (type === ContentType.Text && body && body !== null && typeof body !== "string") {
      body = JSON.stringify(body);
    }

    return this.instance.request({
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type && type !== ContentType.FormData ? { "Content-Type": type } : {}),
      },
      params: query,
      responseType: responseFormat,
      data: body,
      url: path,
    });
  };
}

/**
 * @title Support Server
 * @version 99.99.99.9
 * @baseUrl http://localhost:5297
 *
 * Reichert Support Server
 */
export class Api<SecurityDataType extends unknown> extends HttpClient<SecurityDataType> {
  wellKnown = {
    /**
     * No description
     *
     * @name GetWellKnownOauthProtectedResource
     * @request GET:/.well-known/oauth-protected-resource
     * @secure
     */
    getWellKnownOauthProtectedResource: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/.well-known/oauth-protected-resource`,
        method: "GET",
        secure: true,
        ...params,
      }),
  };
  aiDraft = {
    /**
     * No description
     *
     * @tags AiDraft
     * @name AiDraftCreate
     * @summary Legt einen Entwurf an.
     * @request POST:/AiDraft
     * @secure
     */
    aiDraftCreate: (data: CreateAiDraftRequest, params: RequestParams = {}) =>
      this.request<AiDraftDto, any>({
        path: `/AiDraft`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AiDraft
     * @name AiDraftList
     * @summary Die eigenen Entwürfe, neueste zuerst.
     * @request GET:/AiDraft
     * @secure
     */
    aiDraftList: (params: RequestParams = {}) =>
      this.request<AiDraftDto[], any>({
        path: `/AiDraft`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AiDraft
     * @name AiDraftTurn
     * @summary Schickt einen Gesprächszug und liefert die Antwort des Assistenten.
     * @request POST:/AiDraft/{id}/turn
     * @secure
     */
    aiDraftTurn: (id: string, data: AiDraftTurnRequest, params: RequestParams = {}) =>
      this.request<AiDraftTurnDto, any>({
        path: `/AiDraft/${id}/turn`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AiDraft
     * @name AiDraftGet
     * @summary Der aktuelle Stand eines Entwurfs, inklusive Dialogverlauf für die Anzeige.
     * @request GET:/AiDraft/{id}
     * @secure
     */
    aiDraftGet: (id: string, params: RequestParams = {}) =>
      this.request<AiDraftDetailDto, any>({
        path: `/AiDraft/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AiDraft
     * @name AiDraftDiscard
     * @summary Verwirft einen Entwurf.
     * @request DELETE:/AiDraft/{id}
     * @secure
     */
    aiDraftDiscard: (id: string, params: RequestParams = {}) =>
      this.request<File, any>({
        path: `/AiDraft/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
 * @description Der Server schreibt nicht selbst in ein Projekt. Die Oberfläche lädt das Ergebnis in die normale Kalkulator-Eingabe, wo der Bediener es prüft und wie gewohnt speichert — damit bleibt der letzte Schritt beim Menschen, und der Assistent hat weiterhin kein Werkzeug, das etwas festschreibt. Beendet den Dialog nicht. Übernehmen ist ein Abgleich des aktuellen Stands und beliebig oft wiederholbar — im Telefonat wird zwischendurch übernommen und danach weitergesprochen. Beendet wird ein Entwurf nur über Verwerfen.
 *
 * @tags AiDraft
 * @name AiDraftApply
 * @summary Übernimmt den Entwurf: liefert den erarbeiteten ProjectInput zurück und schließt
den Dialog ab.
 * @request POST:/AiDraft/{id}/apply
 * @secure
 */
    aiDraftApply: (id: string, params: RequestParams = {}) =>
      this.request<AiDraftApplyDto, any>({
        path: `/AiDraft/${id}/apply`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Kostet den Vertriebler einen Klick und hält ihn nicht auf; die Arbeit passiert danach im Stammdaten-Editor. Ohne diesen Rückkanal veraltet der Assistent ab Tag eins.
     *
     * @tags AiDraft
     * @name AiDraftReportFeedback
     * @summary Meldet, dass der Katalog an dieser Stelle nicht getragen hat.
     * @request POST:/AiDraft/{id}/feedback
     * @secure
     */
    aiDraftReportFeedback: (id: string, data: ReportAiFeedbackRequest, params: RequestParams = {}) =>
      this.request<AiFeedbackDto, any>({
        path: `/AiDraft/${id}/feedback`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  aiSettings = {
    /**
     * No description
     *
     * @tags AiSettings
     * @name AiSettingsGetSettings
     * @summary Die aktuellen Einstellungen — ohne Schlüssel, nur mit dem Hinweis, ob einer gesetzt ist.
     * @request GET:/AiSettings/Settings
     * @secure
     */
    aiSettingsGetSettings: (params: RequestParams = {}) =>
      this.request<AiSettingsDto, any>({
        path: `/AiSettings/Settings`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Für die beiden Schlüssel gilt: null lässt den gespeicherten Wert unverändert, "" löscht ihn. Die Oberfläche schickt Geheimnisse deshalb nur, wenn sie geändert wurden.
     *
     * @tags AiSettings
     * @name AiSettingsSaveSettings
     * @summary Speichert die Einstellungen.
     * @request PUT:/AiSettings/Settings
     * @secure
     */
    aiSettingsSaveSettings: (data: UpdateAiSettingsRequest, params: RequestParams = {}) =>
      this.request<AiSettingsDto, any>({
        path: `/AiSettings/Settings`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Bewusst ein echter Aufruf statt eines Pings: nur so zeigt sich, ob Schlüssel, Modellname und Zeitlimit zusammenpassen. Und bewusst mit Zeitmessung — ein Assistent, der im laufenden Telefonat souffliert, ist bei 20 Sekunden Antwortzeit technisch in Ordnung und fachlich unbrauchbar. Antwortet auch im Fehlerfall mit HTTP 200; die Ursache steht in Message.
     *
     * @tags AiSettings
     * @name AiSettingsTestConnection
     * @summary Prüft die Anbindung mit einem echten, sehr kurzen Modellaufruf und misst die Antwortzeit.
     * @request POST:/AiSettings/TestConnection
     * @secure
     */
    aiSettingsTestConnection: (
      query?: {
        /**
         * Das schnelle Modell testen statt des großen. Beide Pfade sind im Betrieb relevant, also
         * müssen beide prüfbar sein.
         *
         * @default false
         */
        fast?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<AiTestResultDto, any>({
        path: `/AiSettings/TestConnection`,
        method: "POST",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Kehrt sofort zurück; das Erzeugen läuft im Hintergrunddienst. Bei 85 offenen Anforderungen dauert das einige Minuten — deshalb liefert die Antwort die Anzahl, und GET QuestionBacklog den Fortschritt.
     *
     * @tags AiSettings
     * @name AiSettingsGenerateMissingQuestions
     * @summary Stellt alle Anforderungen ohne Gesprächsfrage oder ohne Stichworte in die Warteschlange.
     * @request POST:/AiSettings/GenerateMissingQuestions
     * @secure
     */
    aiSettingsGenerateMissingQuestions: (
      query?: {
        /**
         * Optionaler Bereichsfilter (Gruppentitel aus anforderungen.xml, z. B. „Funk").
         * Damit lässt sich mit einem Bereich anfangen, statt einen Nachmittag zu blocken.
         *
         */
        category?: string | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<QuestionBacklogDto, any>({
        path: `/AiSettings/GenerateMissingQuestions`,
        method: "POST",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AiSettings
     * @name AiSettingsQuestionBacklog
     * @summary Fortschritt des Nachfüllens — wie viele Anforderungen warten noch?
     * @request GET:/AiSettings/QuestionBacklog
     * @secure
     */
    aiSettingsQuestionBacklog: (
      query?: {
        /** Optionaler Bereichsfilter für die Lückenzählung. */
        category?: string | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<QuestionBacklogDto, any>({
        path: `/AiSettings/QuestionBacklog`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Ohne diese Sichtbarkeit merkt niemand, wenn etwas aus dem Ruder läuft — bis die Rechnung kommt.
     *
     * @tags AiSettings
     * @name AiSettingsUsage
     * @summary Verbrauch des laufenden Monats samt Budgetstand.
     * @request GET:/AiSettings/Usage
     * @secure
     */
    aiSettingsUsage: (params: RequestParams = {}) =>
      this.request<AiUsageDto, any>({
        path: `/AiSettings/Usage`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AiSettings
     * @name AiSettingsFeedback
     * @summary Die Rückmeldungen aus Gesprächen — die Arbeitsliste der Katalogpflege.
     * @request GET:/AiSettings/Feedback
     * @secure
     */
    aiSettingsFeedback: (
      query?: {
        /**
         * Auch erledigte anzeigen.
         * @default false
         */
        includeResolved?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<AiFeedbackDto[], any>({
        path: `/AiSettings/Feedback`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AiSettings
     * @name AiSettingsResolveFeedback
     * @summary Hakt eine Rückmeldung ab, nachdem der Katalog ergänzt wurde.
     * @request POST:/AiSettings/Feedback/{id}/resolve
     * @secure
     */
    aiSettingsResolveFeedback: (id: string, params: RequestParams = {}) =>
      this.request<File, any>({
        path: `/AiSettings/Feedback/${id}/resolve`,
        method: "POST",
        secure: true,
        ...params,
      }),
  };
  alive = {
    /**
     * No description
     *
     * @tags Alive
     * @name AliveGet
     * @summary Health check endpoint that returns the current date and server version.
     * @request GET:/Alive
     * @secure
     */
    aliveGet: (params: RequestParams = {}) =>
      this.request<AliveResponse, any>({
        path: `/Alive`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  apiKeys = {
    /**
 * No description
 *
 * @tags ApiKeys
 * @name ApiKeysCreate
 * @summary Creates a new API key for the currently authenticated user.
The plaintext key is returned exactly once in the response — it cannot be retrieved later.
 * @request POST:/api-keys
 * @secure
 */
    apiKeysCreate: (data: CreateApiKeyRequest, params: RequestParams = {}) =>
      this.request<CreateApiKeyResponse, any>({
        path: `/api-keys`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ApiKeys
     * @name ApiKeysList
     * @summary Lists all API keys owned by the currently authenticated user.
     * @request GET:/api-keys
     * @secure
     */
    apiKeysList: (params: RequestParams = {}) =>
      this.request<ApiKeyDto[], any>({
        path: `/api-keys`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
 * No description
 *
 * @tags ApiKeys
 * @name ApiKeysRevoke
 * @summary Revokes an API key owned by the currently authenticated user.
Revoked keys can no longer be used to authenticate and cannot be reactivated.
 * @request DELETE:/api-keys/{id}
 * @secure
 */
    apiKeysRevoke: (id: string, params: RequestParams = {}) =>
      this.request<File, any>({
        path: `/api-keys/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),
  };
  appStore = {
    /**
     * No description
     *
     * @tags AppStore
     * @name AppStoreGetFileTypes
     * @summary Get list of all file types with latest file per host system.
     * @request GET:/AppStore/Apps
     * @secure
     */
    appStoreGetFileTypes: (
      query?: {
        /**
         * DEPRECATED: Filter by FileTypeClass (use documentationFilter instead)
         * @default "UNDEFINED"
         */
        variant?: FileTypeClass;
        /** Filter by specific HostSystem IDs */
        system?: string[] | null;
        /**
         * Filter for documentation HostSystems. Default: All
         * @default "All"
         */
        documentationFilter?: DocumentationFilter;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetFileTypeLatestHostSystemFileData[], any>({
        path: `/AppStore/Apps`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AppStore
     * @name AppStoreGetFileTypesPublic
     * @summary Get list of public file types.
     * @request GET:/AppStore/Apps/Public
     * @secure
     */
    appStoreGetFileTypesPublic: (
      query?: {
        /**
         * DEPRECATED: Filter by FileTypeClass (use documentationFilter instead)
         * @default "UNDEFINED"
         */
        variant?: FileTypeClass;
        /**
         * Filter for documentation HostSystems. Default: All
         * @default "All"
         */
        documentationFilter?: DocumentationFilter;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetFileTypeData[], any>({
        path: `/AppStore/Apps/Public`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AppStore
     * @name AppStoreGetFileType
     * @summary Get file type details.
     * @request GET:/AppStore/Apps/{id}
     * @secure
     */
    appStoreGetFileType: (id: string, params: RequestParams = {}) =>
      this.request<GetFileTypeData, any>({
        path: `/AppStore/Apps/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AppStore
     * @name AppStoreGetFileTypePublic
     * @summary Get public file type details.
     * @request GET:/AppStore/Apps/Public/{id}
     * @secure
     */
    appStoreGetFileTypePublic: (id: string, params: RequestParams = {}) =>
      this.request<GetFileTypeData, any>({
        path: `/AppStore/Apps/Public/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AppStore
     * @name AppStoreGetFileTypeVersions
     * @summary Get versions that contain files for a file type.
     * @request GET:/AppStore/Apps/{fileTypeId}/Versions
     * @secure
     */
    appStoreGetFileTypeVersions: (
      fileTypeId: string,
      query?: {
        /**
         * Filter for documentation HostSystems. Default: All
         * @default "All"
         */
        documentationFilter?: DocumentationFilter;
        /**
         * Maximum number of versions to return. Default: 3
         * @format int32
         * @default 3
         */
        maxVersions?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetVersionFileData[], any>({
        path: `/AppStore/Apps/${fileTypeId}/Versions`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AppStore
     * @name AppStoreGetFile
     * @summary Download a file by id.
     * @request GET:/AppStore/Downloads/{id}
     * @secure
     */
    appStoreGetFile: (id: string, params: RequestParams = {}) =>
      this.request<File, any>({
        path: `/AppStore/Downloads/${id}`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags AppStore
     * @name AppStoreGetScreenshots
     * @summary Get screenshots for a file type.
     * @request GET:/AppStore/Apps/{fileTypeId}/Screenshots
     * @secure
     */
    appStoreGetScreenshots: (fileTypeId: string, params: RequestParams = {}) =>
      this.request<ImageDto[], any>({
        path: `/AppStore/Apps/${fileTypeId}/Screenshots`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AppStore
     * @name AppStoreGetLogo
     * @summary Get logo for a file type.
     * @request GET:/AppStore/Apps/{fileTypeId}/Logo
     * @secure
     */
    appStoreGetLogo: (fileTypeId: string, params: RequestParams = {}) =>
      this.request<ImageDto, any>({
        path: `/AppStore/Apps/${fileTypeId}/Logo`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AppStore
     * @name AppStoreGetImageDataRaw
     * @summary Get image data by id.
     * @request GET:/AppStore/Images/{imageId}
     * @secure
     */
    appStoreGetImageDataRaw: (imageId: string, params: RequestParams = {}) =>
      this.request<File, any>({
        path: `/AppStore/Images/${imageId}`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags AppStore
     * @name AppStoreRegisterDevice
     * @summary Register a device for the AppStore.
     * @request POST:/AppStore/Devices/Register
     * @secure
     */
    appStoreRegisterDevice: (data: RegisterDeviceModel, params: RequestParams = {}) =>
      this.request<File, any>({
        path: `/AppStore/Devices/Register`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags AppStore
     * @name AppStoreGetAppStoreFileTypeId
     * @summary Get the FileType ID for the AppStore APK.
     * @request GET:/AppStore/FileTypeId
     * @secure
     */
    appStoreGetAppStoreFileTypeId: (params: RequestParams = {}) =>
      this.request<AppStoreConfigDto, AppStoreConfigDto>({
        path: `/AppStore/FileTypeId`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AppStore
     * @name AppStoreSetAppStoreFileTypeId
     * @summary Set the FileType ID for the AppStore APK (Admin only).
     * @request POST:/AppStore/FileTypeId
     * @secure
     */
    appStoreSetAppStoreFileTypeId: (data: string, params: RequestParams = {}) =>
      this.request<AppStoreConfigDto, any>({
        path: `/AppStore/FileTypeId`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
 * No description
 *
 * @tags AppStore
 * @name AppStoreGetAppStoreInfo
 * @summary Get AppStore APK information (Anonymous access).
Returns version info if available.
 * @request GET:/AppStore/Info
 * @secure
 */
    appStoreGetAppStoreInfo: (params: RequestParams = {}) =>
      this.request<AppStoreInfoDto, AppStoreInfoDto>({
        path: `/AppStore/Info`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AppStore
     * @name AppStoreDownloadAppStore
     * @summary Download the latest AppStore APK (Anonymous access).
     * @request GET:/AppStore/Download
     * @secure
     */
    appStoreDownloadAppStore: (params: RequestParams = {}) =>
      this.request<File, string>({
        path: `/AppStore/Download`,
        method: "GET",
        secure: true,
        ...params,
      }),
  };
  auditLog = {
    /**
     * No description
     *
     * @tags AuditLog
     * @name AuditLogGetAuditEntries
     * @summary Returns audit entries, optionally filtered by reference type and reference id.
     * @request GET:/AuditLog
     * @secure
     */
    auditLogGetAuditEntries: (
      query?: {
        /** Optional logical reference type (for example Device or License). */
        referenceType?: string | null;
        /** Optional reference id to match. */
        referenceId?: string | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<AuditLogEntry[], any>({
        path: `/AuditLog`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
 * No description
 *
 * @tags AuditLog
 * @name AuditLogSearchAuditEntries
 * @summary Searches audit entries with paging and a free-text filter that matches
case-insensitively against User, ReferenceType, ReferenceId, Function,
Message and Details. All filter fields are optional.
 * @request GET:/AuditLog/search
 * @secure
 */
    auditLogSearchAuditEntries: (
      query?: {
        /** Free-text substring matched across all text fields. */
        contains?: string | null;
        /** Exact match on logical reference type. */
        referenceType?: string | null;
        /** Exact match on reference identifier. */
        referenceId?: string | null;
        /** Case-insensitive exact match on user identifier. */
        user?: string | null;
        /**
         * Only entries on or after this UTC timestamp.
         * @format date-time
         */
        since?: string | null;
        /**
         * Only entries on or before this UTC timestamp.
         * @format date-time
         */
        until?: string | null;
        /**
         * Zero-based paging offset.
         * @format int32
         * @default 0
         */
        skip?: number;
        /**
         * Maximum number of rows (default 50, max 500).
         * @format int32
         * @default 50
         */
        limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<AuditLogSearchResult, any>({
        path: `/AuditLog/search`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  calculator = {
    /**
     * No description
     *
     * @tags CalculatorGit
     * @name CalculatorGitGetStatus
     * @summary Liefert den aktuellen Git-Status des Bereichs.
     * @request GET:/Calculator/git/{area}/status
     * @secure
     */
    calculatorGitGetStatus: (area: CalculatorGitArea, params: RequestParams = {}) =>
      this.request<any, ProblemDetails>({
        path: `/Calculator/git/${area}/status`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags CalculatorGit
     * @name CalculatorGitGetLog
     * @summary Liefert die jüngsten Commits des Bereichs.
     * @request GET:/Calculator/git/{area}/log
     * @secure
     */
    calculatorGitGetLog: (
      area: CalculatorGitArea,
      query?: {
        /**
         * Maximale Anzahl Commits (1–500, Standard 50).
         * @format int32
         * @default 50
         */
        max?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<any, ProblemDetails>({
        path: `/Calculator/git/${area}/log`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
 * No description
 *
 * @tags CalculatorGit
 * @name CalculatorGitGetIncoming
 * @summary Liefert die eingehenden Commits (Pull-Vorschau): was der Remote nach dem letzten Fetch
hat und lokal noch fehlt. Sinnvoll nach POST {area}/fetch, um vor dem Pull zu prüfen.
 * @request GET:/Calculator/git/{area}/incoming
 * @secure
 */
    calculatorGitGetIncoming: (
      area: CalculatorGitArea,
      query?: {
        /**
         * Maximale Anzahl Commits (1–500, Standard 100).
         * @format int32
         * @default 100
         */
        max?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<any, ProblemDetails>({
        path: `/Calculator/git/${area}/incoming`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
 * No description
 *
 * @tags CalculatorGit
 * @name CalculatorGitGetOutgoing
 * @summary Liefert die ausgehenden Commits (Push-Vorschau): lokale Commits, die der Remote noch
nicht hat.
 * @request GET:/Calculator/git/{area}/outgoing
 * @secure
 */
    calculatorGitGetOutgoing: (
      area: CalculatorGitArea,
      query?: {
        /**
         * Maximale Anzahl Commits (1–500, Standard 100).
         * @format int32
         * @default 100
         */
        max?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<any, ProblemDetails>({
        path: `/Calculator/git/${area}/outgoing`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
 * No description
 *
 * @tags CalculatorGit
 * @name CalculatorGitGetWorkingDiff
 * @summary Liefert den Diff der nicht committeten Änderungen (Arbeitsverzeichnis gegen HEAD) — was vor
einem Commit geändert wurde, als Unified-Diff pro Datei.
 * @request GET:/Calculator/git/{area}/diff
 * @secure
 */
    calculatorGitGetWorkingDiff: (
      area: CalculatorGitArea,
      query?: {
        /** Optionaler Filter auf einen einzelnen repository-relativen Pfad. */
        path?: string | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<any, ProblemDetails>({
        path: `/Calculator/git/${area}/diff`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags CalculatorGit
     * @name CalculatorGitGetCommitDiff
     * @summary Liefert den Diff eines Commits gegen seinen Eltern-Commit (z. B. zur Review eingehender Commits).
     * @request GET:/Calculator/git/{area}/diff/commit/{sha}
     * @secure
     */
    calculatorGitGetCommitDiff: (area: CalculatorGitArea, sha: string, params: RequestParams = {}) =>
      this.request<any, ProblemDetails>({
        path: `/Calculator/git/${area}/diff/commit/${sha}`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
 * No description
 *
 * @tags CalculatorGit
 * @name CalculatorGitGetConflict
 * @summary Liefert die drei Versionen (Basis/Ours/Theirs) einer konfliktbehafteten Datei für eine
3-Wege-Ansicht, damit der Konflikt vor der Auflösung beurteilt werden kann.
 * @request GET:/Calculator/git/{area}/conflict
 * @secure
 */
    calculatorGitGetConflict: (
      area: CalculatorGitArea,
      query?: {
        /** Repository-relativer Pfad der konfliktbehafteten Datei. */
        path?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<any, ProblemDetails>({
        path: `/Calculator/git/${area}/conflict`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags CalculatorGit
     * @name CalculatorGitCommit
     * @summary Staged alle Änderungen des Bereichs und erstellt einen Commit (Autor = angemeldeter Nutzer).
     * @request POST:/Calculator/git/{area}/commit
     * @secure
     */
    calculatorGitCommit: (area: CalculatorGitArea, data: GitCommitRequest, params: RequestParams = {}) =>
      this.request<void, ProblemDetails>({
        path: `/Calculator/git/${area}/commit`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags CalculatorGit
     * @name CalculatorGitFetch
     * @summary Lädt Änderungen vom Remote, ohne sie zu integrieren.
     * @request POST:/Calculator/git/{area}/fetch
     * @secure
     */
    calculatorGitFetch: (area: CalculatorGitArea, data: GitRemoteCredentialsRequest, params: RequestParams = {}) =>
      this.request<any, ProblemDetails>({
        path: `/Calculator/git/${area}/fetch`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags CalculatorGit
     * @name CalculatorGitPull
     * @summary Führt einen Pull aus (fetch + merge des Upstreams in den aktuellen Branch).
     * @request POST:/Calculator/git/{area}/pull
     * @secure
     */
    calculatorGitPull: (area: CalculatorGitArea, data: GitRemoteCredentialsRequest, params: RequestParams = {}) =>
      this.request<any, ProblemDetails>({
        path: `/Calculator/git/${area}/pull`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags CalculatorGit
     * @name CalculatorGitPush
     * @summary Schiebt den aktuellen Branch des Bereichs zum Upstream-Remote.
     * @request POST:/Calculator/git/{area}/push
     * @secure
     */
    calculatorGitPush: (area: CalculatorGitArea, data: GitRemoteCredentialsRequest, params: RequestParams = {}) =>
      this.request<any, ProblemDetails>({
        path: `/Calculator/git/${area}/push`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
 * No description
 *
 * @tags CalculatorGit
 * @name CalculatorGitResolve
 * @summary Löst einen einzelnen Merge-Konflikt auf (lokale oder eingehende Version) und liefert
den aktualisierten Status zurück.
 * @request POST:/Calculator/git/{area}/resolve
 * @secure
 */
    calculatorGitResolve: (area: CalculatorGitArea, data: GitResolveConflictRequest, params: RequestParams = {}) =>
      this.request<any, ProblemDetails>({
        path: `/Calculator/git/${area}/resolve`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags CalculatorGit
     * @name CalculatorGitAbortMerge
     * @summary Bricht einen laufenden Merge ab (hard reset auf HEAD) und liefert den Status zurück.
     * @request POST:/Calculator/git/{area}/abort-merge
     * @secure
     */
    calculatorGitAbortMerge: (area: CalculatorGitArea, params: RequestParams = {}) =>
      this.request<any, ProblemDetails>({
        path: `/Calculator/git/${area}/abort-merge`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
 * No description
 *
 * @tags CalculatorGit
 * @name CalculatorGitRevert
 * @summary Verwirft alle offenen Änderungen des Bereichs und stellt den Stand des letzten Commits
(HEAD) wieder her: getrackte Dateien werden zurückgesetzt, neu angelegte Dateien entfernt.
Liest anschließend die Kalkulator-Stammdaten neu ein, damit der Speicher-Cache nicht
veraltet, und liefert den aktualisierten Status zurück. Die Commit-Historie bleibt unverändert.
 * @request POST:/Calculator/git/{area}/revert
 * @secure
 */
    calculatorGitRevert: (area: CalculatorGitArea, params: RequestParams = {}) =>
      this.request<any, ProblemDetails>({
        path: `/Calculator/git/${area}/revert`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ProjectOffer
     * @name ProjectOfferList
     * @summary Listet die (sichtbaren) Angebots-PDFs des Projekts.
     * @request GET:/Calculator/projects/{projectId}/offers
     * @secure
     */
    projectOfferList: (projectId: string, params: RequestParams = {}) =>
      this.request<any, ProblemDetails>({
        path: `/Calculator/projects/${projectId}/offers`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ProjectOffer
     * @name ProjectOfferUpload
     * @summary Lädt ein Angebots-PDF hoch (multipart/form-data, Feld file).
     * @request POST:/Calculator/projects/{projectId}/offers
     * @secure
     */
    projectOfferUpload: (
      projectId: string,
      data: {
        /** @format binary */
        file?: File | null;
        offerNumber?: string | null;
        /** @format decimal */
        totalSum?: number | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<any, ProblemDetails>({
        path: `/Calculator/projects/${projectId}/offers`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.FormData,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ProjectOffer
     * @name ProjectOfferSetReleased
     * @summary Setzt den Freigabe-Status eines Angebots.
     * @request PUT:/Calculator/projects/{projectId}/offers/{offerId}/release
     * @secure
     */
    projectOfferSetReleased: (
      projectId: string,
      offerId: string,
      data: ReleaseOfferRequest,
      params: RequestParams = {},
    ) =>
      this.request<any, ProblemDetails>({
        path: `/Calculator/projects/${projectId}/offers/${offerId}/release`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ProjectOffer
     * @name ProjectOfferDownload
     * @summary Lädt ein Angebots-PDF herunter.
     * @request GET:/Calculator/projects/{projectId}/offers/{offerId}/download
     * @secure
     */
    projectOfferDownload: (projectId: string, offerId: string, params: RequestParams = {}) =>
      this.request<any, ProblemDetails>({
        path: `/Calculator/projects/${projectId}/offers/${offerId}/download`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ProjectOffer
     * @name ProjectOfferDelete
     * @summary Löscht ein Angebots-PDF.
     * @request DELETE:/Calculator/projects/{projectId}/offers/{offerId}
     * @secure
     */
    projectOfferDelete: (projectId: string, offerId: string, params: RequestParams = {}) =>
      this.request<void, ProblemDetails>({
        path: `/Calculator/projects/${projectId}/offers/${offerId}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ProjectOverview
     * @name ProjectOverviewGetOverview
     * @summary Liefert die erweiterte Übersicht der sichtbaren Projekte, neueste zuerst.
     * @request GET:/Calculator/projects/overview
     * @secure
     */
    projectOverviewGetOverview: (params: RequestParams = {}) =>
      this.request<ProjectOverviewItem[], any>({
        path: `/Calculator/projects/overview`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ProjectSharing
     * @name ProjectSharingList
     * @summary Listet die Freigaben des Projekts.
     * @request GET:/Calculator/projects/{projectId}/shares
     * @secure
     */
    projectSharingList: (projectId: string, params: RequestParams = {}) =>
      this.request<any, ProblemDetails>({
        path: `/Calculator/projects/${projectId}/shares`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ProjectSharing
     * @name ProjectSharingAdd
     * @summary Erteilt eine Freigabe an einen Benutzer oder eine Gruppe.
     * @request POST:/Calculator/projects/{projectId}/shares
     * @secure
     */
    projectSharingAdd: (projectId: string, data: AddProjectShareRequest, params: RequestParams = {}) =>
      this.request<any, ProblemDetails>({
        path: `/Calculator/projects/${projectId}/shares`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
 * No description
 *
 * @tags ProjectSharing
 * @name ProjectSharingSharing
 * @summary Gesamte „Teilen"-Sicht: interne Personen-/Gruppen-Freigaben UND öffentliche Kunden-Links
in einem Aufruf.
 * @request GET:/Calculator/projects/{projectId}/sharing
 * @secure
 */
    projectSharingSharing: (projectId: string, params: RequestParams = {}) =>
      this.request<any, ProblemDetails>({
        path: `/Calculator/projects/${projectId}/sharing`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ProjectSharing
     * @name ProjectSharingRemove
     * @summary Entzieht eine Freigabe.
     * @request DELETE:/Calculator/projects/{projectId}/shares/{shareId}
     * @secure
     */
    projectSharingRemove: (projectId: string, shareId: string, params: RequestParams = {}) =>
      this.request<void, ProblemDetails>({
        path: `/Calculator/projects/${projectId}/shares/${shareId}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags SharedProject
     * @name SharedProjectCreateShared
     * @summary Legt ein neues freigegebenes Projekt an und verschickt die Einladung.
     * @request POST:/Calculator/projects/shared
     * @secure
     */
    sharedProjectCreateShared: (data: CreateSharedProjectRequest, params: RequestParams = {}) =>
      this.request<any, ProblemDetails>({
        path: `/Calculator/projects/shared`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ShareLink
     * @name ShareLinkList
     * @summary Listet die Freigabe-Links des Projekts.
     * @request GET:/Calculator/projects/{projectId}/links
     * @secure
     */
    shareLinkList: (projectId: string, params: RequestParams = {}) =>
      this.request<any, ProblemDetails>({
        path: `/Calculator/projects/${projectId}/links`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ShareLink
     * @name ShareLinkCreate
     * @summary Erstellt einen Freigabe-Link und mailt Link + Passwort automatisch an den Kunden.
     * @request POST:/Calculator/projects/{projectId}/links
     * @secure
     */
    shareLinkCreate: (projectId: string, data: CreateShareLinkRequest, params: RequestParams = {}) =>
      this.request<any, ProblemDetails>({
        path: `/Calculator/projects/${projectId}/links`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ShareLink
     * @name ShareLinkRevoke
     * @summary Widerruft einen Freigabe-Link.
     * @request DELETE:/Calculator/projects/{projectId}/links/{linkId}
     * @secure
     */
    shareLinkRevoke: (projectId: string, linkId: string, params: RequestParams = {}) =>
      this.request<void, ProblemDetails>({
        path: `/Calculator/projects/${projectId}/links/${linkId}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Calculator
     * @name CalculatorHealth
     * @summary Einfacher Lebenszeichen-Endpunkt.
     * @request GET:/Calculator/health
     * @secure
     */
    calculatorHealth: (params: RequestParams = {}) =>
      this.request<File, any>({
        path: `/Calculator/health`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * @description Bewusst ohne Stammdaten-Berechtigung: Vorlagen auszuwählen ist Alltagsarbeit im Vertrieb, sie zu pflegen nicht. Wer rechnen darf, darf auch aus einer Vorlage starten.
     *
     * @tags Calculator
     * @name CalculatorListTemplates
     * @summary Liefert die Beispielkonfigurationen für die Auswahl im Kalkulator.
     * @request GET:/Calculator/templates
     * @secure
     */
    calculatorListTemplates: (params: RequestParams = {}) =>
      this.request<File, any>({
        path: `/Calculator/templates`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Calculator
     * @name CalculatorGetRequirements
     * @summary Liefert den Anforderungs-Eingabebaum für das Formular.
     * @request GET:/Calculator/requirements
     * @secure
     */
    calculatorGetRequirements: (params: RequestParams = {}) =>
      this.request<File, any>({
        path: `/Calculator/requirements`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Calculator
     * @name CalculatorListRubrics
     * @summary Liefert die Rubriken (a_gruppe-Codes mit Klartext) – einzige Quelle für Kalkulator und Editor.
     * @request GET:/Calculator/rubrics
     * @secure
     */
    calculatorListRubrics: (params: RequestParams = {}) =>
      this.request<File, any>({
        path: `/Calculator/rubrics`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
 * No description
 *
 * @tags Calculator
 * @name CalculatorCalculate
 * @summary Kalkuliert ein Angebot aus den (flachen) Mengen-Eingaben und liefert Positionen, Summen und
Fragmente.
 * @request POST:/Calculator/calculate
 * @secure
 */
    calculatorCalculate: (data: CalculateRequest, params: RequestParams = {}) =>
      this.request<File, any>({
        path: `/Calculator/calculate`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
 * No description
 *
 * @tags Calculator
 * @name CalculatorCalculateProject
 * @summary Kalkuliert ein instanzbasiertes Projekt (Klonen + Optionen) und liefert Positionen, Summen und
Fragmente.
 * @request POST:/Calculator/project/calculate
 * @secure
 */
    calculatorCalculateProject: (data: ProjectCalculateRequest, params: RequestParams = {}) =>
      this.request<File, any>({
        path: `/Calculator/project/calculate`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
 * No description
 *
 * @tags Calculator
 * @name CalculatorCalculateStoredProject
 * @summary Kalkuliert ein GESPEICHERTES Projekt (read-only) anhand seiner Id und liefert Positionen/Summen.
Der Zugriff wird ausschließlich über den Projektspeicher (IProjectStore) erzwungen:
wer das Projekt sehen darf (Eigentümer, „alle sehen" oder Freigabe), darf es auch lesen —
ohne calculator.operate. Preise werden nach dem Preisrecht des Aufrufers redigiert.
So können Personen, denen eine Kalkulation freigegeben wurde, diese lesen, auch ohne Bedien-Recht.
 * @request GET:/Calculator/project/{id}/calculate
 * @secure
 */
    calculatorCalculateStoredProject: (id: string, params: RequestParams = {}) =>
      this.request<File, any>({
        path: `/Calculator/project/${id}/calculate`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Calculator
     * @name CalculatorLabelWinStatus
     * @summary Status der LabelWin-Anbindung (für die Sichtbarkeit der UI-Trigger).
     * @request GET:/Calculator/labelwin/status
     * @secure
     */
    calculatorLabelWinStatus: (params: RequestParams = {}) =>
      this.request<File, any>({
        path: `/Calculator/labelwin/status`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
 * No description
 *
 * @tags Calculator
 * @name CalculatorLabelWinSync
 * @summary Manueller Preis-Sync: verwirft den Cache und lädt die Preisliste frisch vom Connector.
Liefert die Anzahl geladener Preise; bei deaktiviertem Connector Enabled=false.
 * @request POST:/Calculator/labelwin/sync
 * @secure
 */
    calculatorLabelWinSync: (params: RequestParams = {}) =>
      this.request<File, any>({
        path: `/Calculator/labelwin/sync`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
 * No description
 *
 * @tags Calculator
 * @name CalculatorLabelWinExport
 * @summary Kalkuliert ein Projekt und schreibt es über den LabelWin-Connector in die Stapel-/Zwischen-
ablage-MDB des Benutzers. Reicht die Positionen unverändert durch (kein MDB-Wissen im Kalkulator).
 * @request POST:/Calculator/labelwin/export
 * @secure
 */
    calculatorLabelWinExport: (data: LabelWinExportRequest, params: RequestParams = {}) =>
      this.request<File, any>({
        path: `/Calculator/labelwin/export`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Calculator
     * @name CalculatorGenerateLeistungen
     * @summary Erzeugt die Leistungsbeschreibung (Leistungsangabe + LV-muss) zu einem kalkulierten Projekt.
     * @request POST:/Calculator/project/leistungen
     * @secure
     */
    calculatorGenerateLeistungen: (data: LeistungenRequest, params: RequestParams = {}) =>
      this.request<File, any>({
        path: `/Calculator/project/leistungen`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Calculator
     * @name CalculatorValidate
     * @summary Prüft die referenzielle Integrität der Stammdaten (Artikel-/Options-/Parameter-Referenzen).
     * @request GET:/Calculator/validate
     * @secure
     */
    calculatorValidate: (params: RequestParams = {}) =>
      this.request<File, any>({
        path: `/Calculator/validate`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Calculator
     * @name CalculatorListArticles
     * @summary Liefert alle Katalog-Artikel in editierbarer Form.
     * @request GET:/Calculator/edit/catalog
     * @secure
     */
    calculatorListArticles: (params: RequestParams = {}) =>
      this.request<File, any>({
        path: `/Calculator/edit/catalog`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Calculator
     * @name CalculatorListArticleGroups
     * @summary Liefert die Titel der Artikelgruppen (für die Gruppen-Auswahl beim Anlegen).
     * @request GET:/Calculator/edit/catalog/groups
     * @secure
     */
    calculatorListArticleGroups: (params: RequestParams = {}) =>
      this.request<File, any>({
        path: `/Calculator/edit/catalog/groups`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
 * No description
 *
 * @tags Calculator
 * @name CalculatorGetArticleImages
 * @summary Liefert alle Bilder eines Artikels (Metadaten + Bild-URL). Quelle ist die images.xml
des Basis-Ordners (basis_nr), sodass abgeleitete Artikel die Bilder ihrer Basis erben.
 * @request GET:/Calculator/article/{aNr}/images
 * @secure
 */
    calculatorGetArticleImages: (aNr: string, params: RequestParams = {}) =>
      this.request<File, any>({
        path: `/Calculator/article/${aNr}/images`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
 * No description
 *
 * @tags Calculator
 * @name CalculatorGetArticleImage
 * @summary Liefert die Metadaten eines einzelnen Bildes (Titel/Beschreibung/Hauptbild). imgref
ist der Dateiname (siehe name aus der Bilderliste).
 * @request GET:/Calculator/article/{aNr}/images/{imgref}
 * @secure
 */
    calculatorGetArticleImage: (aNr: string, imgref: string, params: RequestParams = {}) =>
      this.request<File, any>({
        path: `/Calculator/article/${aNr}/images/${imgref}`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
 * No description
 *
 * @tags Calculator
 * @name CalculatorGetArticleImageFile
 * @summary Liefert die Bilddatei selbst. imgref identifiziert ein in der images.xml
registriertes Bild (Dateiname); nur registrierte Bilder sind abrufbar. Die Auflösung erfolgt
gegen den Basis-Ordner und ist gegen Verlassen via .. abgesichert.
 * @request GET:/Calculator/article/{aNr}/images/{imgref}/image
 * @secure
 */
    calculatorGetArticleImageFile: (aNr: string, imgref: string, params: RequestParams = {}) =>
      this.request<File, any>({
        path: `/Calculator/article/${aNr}/images/${imgref}/image`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Calculator
     * @name CalculatorUpdateArticle
     * @summary Ändert Preise/Beschreibung eines Katalog-Artikels (formaterhaltend) und lädt neu.
     * @request PUT:/Calculator/edit/article/{aNr}
     * @secure
     */
    calculatorUpdateArticle: (aNr: string, data: ArticleEdit, params: RequestParams = {}) =>
      this.request<File, any>({
        path: `/Calculator/edit/article/${aNr}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Calculator
     * @name CalculatorDeleteArticle
     * @summary Löscht einen Artikel, sofern er nicht von Anforderungen referenziert wird (sonst 409).
     * @request DELETE:/Calculator/edit/article/{aNr}
     * @secure
     */
    calculatorDeleteArticle: (aNr: string, params: RequestParams = {}) =>
      this.request<File, any>({
        path: `/Calculator/edit/article/${aNr}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Calculator
     * @name CalculatorCreateArticle
     * @summary Legt einen neuen Katalog-Artikel formaterhaltend an (a_nr eindeutig).
     * @request POST:/Calculator/edit/article
     * @secure
     */
    calculatorCreateArticle: (data: ArticleCreate, params: RequestParams = {}) =>
      this.request<File, any>({
        path: `/Calculator/edit/article`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Calculator
     * @name CalculatorListRequirements
     * @summary Liefert alle Anforderungen in roher, editierbarer Form (bedingungen/parameter/optionen).
     * @request GET:/Calculator/edit/requirements
     * @secure
     */
    calculatorListRequirements: (params: RequestParams = {}) =>
      this.request<File, any>({
        path: `/Calculator/edit/requirements`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * @description Getrennt von der Anforderungsliste, weil es eine andere Frage beantwortet. Die Liste sagt, was es gibt; der Aufbau sagt, worauf es steht — ohne Server keine Funkanschaltung, für Telefonie genügt eine virtuelle Maschine. Dieses Wissen steckte bisher nur in Köpfen.
     *
     * @tags Calculator
     * @name CalculatorGetStructure
     * @summary Liefert den Aufbau des Katalogs: Unterbauten und was die Bereiche voraussetzen.
     * @request GET:/Calculator/edit/structure
     * @secure
     */
    calculatorGetStructure: (params: RequestParams = {}) =>
      this.request<File, any>({
        path: `/Calculator/edit/structure`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Calculator
     * @name CalculatorSaveTemplate
     * @summary Legt eine Vorlage an oder ersetzt sie vollständig.
     * @request PUT:/Calculator/edit/template/{id}
     * @secure
     */
    calculatorSaveTemplate: (id: string, data: TemplateEdit, params: RequestParams = {}) =>
      this.request<File, any>({
        path: `/Calculator/edit/template/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Calculator
     * @name CalculatorDeleteTemplate
     * @summary Entfernt eine Vorlage.
     * @request DELETE:/Calculator/edit/template/{id}
     * @secure
     */
    calculatorDeleteTemplate: (id: string, params: RequestParams = {}) =>
      this.request<File, any>({
        path: `/Calculator/edit/template/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Calculator
     * @name CalculatorUpdateRequirement
     * @summary Ersetzt eine Anforderung durch den gewünschten Vollzustand (Element wird neu gerendert).
     * @request PUT:/Calculator/edit/requirement/{id}
     * @secure
     */
    calculatorUpdateRequirement: (id: string, data: RequirementEdit, params: RequestParams = {}) =>
      this.request<File, any>({
        path: `/Calculator/edit/requirement/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Calculator
     * @name CalculatorDeleteRequirement
     * @summary Löscht eine Anforderung, sofern sie nicht als Option referenziert wird (sonst 409).
     * @request DELETE:/Calculator/edit/requirement/{id}
     * @secure
     */
    calculatorDeleteRequirement: (id: string, params: RequestParams = {}) =>
      this.request<File, any>({
        path: `/Calculator/edit/requirement/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Calculator
     * @name CalculatorCreateRequirement
     * @summary Legt eine neue Anforderung in der gewählten Kategorie an (xml:id eindeutig).
     * @request POST:/Calculator/edit/requirement
     * @secure
     */
    calculatorCreateRequirement: (data: RequirementCreate, params: RequestParams = {}) =>
      this.request<File, any>({
        path: `/Calculator/edit/requirement`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Calculator
     * @name CalculatorListLmFiles
     * @summary Listet die lm-Dateien eines Artikel-Ordners (Dateiname + Kurz-Referenz).
     * @request GET:/Calculator/edit/lm/{dir}
     * @secure
     */
    calculatorListLmFiles: (dir: string, params: RequestParams = {}) =>
      this.request<File, any>({
        path: `/Calculator/edit/lm/${dir}`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Calculator
     * @name CalculatorReadLmFile
     * @summary Lädt eine lm-Datei verlustfrei als bearbeitbaren Baum (JSON).
     * @request GET:/Calculator/edit/lm/{dir}/{file}
     * @secure
     */
    calculatorReadLmFile: (dir: string, file: string, params: RequestParams = {}) =>
      this.request<File, any>({
        path: `/Calculator/edit/lm/${dir}/${file}`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Calculator
     * @name CalculatorWriteLmFile
     * @summary Schreibt den gewünschten Vollzustand einer bestehenden lm-Datei zurück und lädt neu.
     * @request PUT:/Calculator/edit/lm/{dir}/{file}
     * @secure
     */
    calculatorWriteLmFile: (dir: string, file: string, data: LmgDocument, params: RequestParams = {}) =>
      this.request<File, any>({
        path: `/Calculator/edit/lm/${dir}/${file}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Calculator
     * @name CalculatorCreateLmFile
     * @summary Legt eine neue lm-Datei an (leere Gruppe, sofern kein Inhalt übergeben wird).
     * @request POST:/Calculator/edit/lm/{dir}/{file}
     * @secure
     */
    calculatorCreateLmFile: (dir: string, file: string, data: LmgDocument, params: RequestParams = {}) =>
      this.request<File, any>({
        path: `/Calculator/edit/lm/${dir}/${file}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Calculator
     * @name CalculatorReload
     * @summary Lädt die Stammdaten-XML neu.
     * @request POST:/Calculator/reload
     * @secure
     */
    calculatorReload: (params: RequestParams = {}) =>
      this.request<File, any>({
        path: `/Calculator/reload`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Projects
     * @name ProjectsList
     * @summary Listet die für den Aufrufer sichtbaren Projekte (ohne Eingabestand).
     * @request GET:/Calculator/projects
     * @secure
     */
    projectsList: (params: RequestParams = {}) =>
      this.request<ProjectListItem[], any>({
        path: `/Calculator/projects`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Projects
     * @name ProjectsCreate
     * @summary Legt ein neues Projekt an.
     * @request POST:/Calculator/projects
     * @secure
     */
    projectsCreate: (data: SaveProjectRequest, params: RequestParams = {}) =>
      this.request<StoredProject, any>({
        path: `/Calculator/projects`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Projects
     * @name ProjectsGet
     * @summary Lädt ein Projekt inklusive vollständigem Eingabestand.
     * @request GET:/Calculator/projects/{id}
     * @secure
     */
    projectsGet: (id: string, params: RequestParams = {}) =>
      this.request<StoredProject, any>({
        path: `/Calculator/projects/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Projects
     * @name ProjectsUpdate
     * @summary Aktualisiert ein bestehendes Projekt (Id aus der Route).
     * @request PUT:/Calculator/projects/{id}
     * @secure
     */
    projectsUpdate: (id: string, data: SaveProjectRequest, params: RequestParams = {}) =>
      this.request<StoredProject, any>({
        path: `/Calculator/projects/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Projects
     * @name ProjectsDelete
     * @summary Löscht ein Projekt.
     * @request DELETE:/Calculator/projects/{id}
     * @secure
     */
    projectsDelete: (id: string, params: RequestParams = {}) =>
      this.request<File, any>({
        path: `/Calculator/projects/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),
  };
  calendar = {
    /**
     * @description Antwortet immer mit HTTP 200. Die Oberfläche entscheidet damit, ob sie den Kalender anzeigt, ohne dafür erst in ein 403 oder 503 zu laufen.
     *
     * @tags Calendar
     * @name CalendarGetMyAccess
     * @summary Ob der angemeldete Benutzer den Kalender benutzen kann — und wenn nicht, warum.
     * @request GET:/Calendar/Me/Access
     * @secure
     */
    calendarGetMyAccess: (params: RequestParams = {}) =>
      this.request<CalendarAccessDto, any>({
        path: `/Calendar/Me/Access`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Calendar
     * @name CalendarGetMyEmployee
     * @summary Der Labelwin-Mitarbeiter, der zum angemeldeten Benutzer gehört.
     * @request GET:/Calendar/Me/Employee
     * @secure
     */
    calendarGetMyEmployee: (params: RequestParams = {}) =>
      this.request<CalendarEmployeeDto, ProblemDetails | void>({
        path: `/Calendar/Me/Employee`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Calendar
     * @name CalendarGetMyCalendar
     * @summary Der eigene Kalender in einem Zeitfenster.
     * @request GET:/Calendar/Me
     * @secure
     */
    calendarGetMyCalendar: (
      query?: {
        /**
         * Erster Tag (einschließlich), Format yyyy-MM-dd. Ohne Angabe heute.
         *
         * @format date
         */
        von?: string | null;
        /**
         * Letzter Tag (einschließlich). Ohne Angabe von plus der eingestellten Vorgabespanne
         * (Standard 30 Tage). Höchstens 366 Tage pro Anfrage.
         *
         * @format date
         */
        bis?: string | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<CalendarViewDto, ProblemDetails | void>({
        path: `/Calendar/Me`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
 * @description Antwortet immer mit HTTP 200 — auch wenn die Microsoft-365-Anbindung abgeschaltet oder unvollständig ist, kein Benutzerprinzipalname am Konto hängt oder Graph nicht antwortet. Die Begründung steht in message, available sagt der Oberfläche, ob sie die Quelle anbieten soll. Bewusst ein eigener Endpunkt statt Teil von GET /Calendar/Me: fällt LabelConnect aus, sollen die Outlook-Termine trotzdem kommen — und umgekehrt.
 *
 * @tags Calendar
 * @name CalendarGetMyOutlookCalendar
 * @summary Die Outlook-Termine des angemeldeten Benutzers in einem Zeitfenster.
 * @request GET:/Calendar/Me/Outlook
 * @secure
 */
    calendarGetMyOutlookCalendar: (
      query?: {
        /**
         * Erster Tag (einschließlich), Format yyyy-MM-dd. Ohne Angabe heute.
         *
         * @format date
         */
        von?: string | null;
        /**
         * Letzter Tag (einschließlich). Ohne Angabe die eingestellte Vorgabespanne.
         *
         * @format date
         */
        bis?: string | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<OutlookCalendarViewDto, ProblemDetails>({
        path: `/Calendar/Me/Outlook`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
 * @description Nur für Administratoren. Jeder Zugriff wird protokolliert — in den Kalender eines Kollegen zu sehen muss nachvollziehbar bleiben. user ist die E-Mail-Adresse; gesucht wird über beide Mail-Domains des Hauses und den LabelBenutzer.
 *
 * @tags Calendar
 * @name CalendarGetCalendarForUser
 * @summary Der Labelwin-Kalender einer anderen Person.
 * @request GET:/Calendar/User
 * @secure
 */
    calendarGetCalendarForUser: (
      query: {
        /** E-Mail-Adresse oder LabelBenutzer der Person. */
        user: string;
        /**
         * Erster Tag (einschließlich). Ohne Angabe heute.
         * @format date
         */
        von?: string | null;
        /**
         * Letzter Tag (einschließlich). Ohne Angabe die Vorgabespanne.
         * @format date
         */
        bis?: string | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<CalendarViewDto, ProblemDetails | void>({
        path: `/Calendar/User`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
 * @description Nur für Administratoren, jeder Zugriff wird protokolliert. Antwortet auch hier immer mit HTTP 200 und begründet sich selbst. Welche Postfächer der Server lesen darf, entscheidet die Zugriffsrichtlinie in Exchange Online.
 *
 * @tags Calendar
 * @name CalendarGetOutlookCalendarForUser
 * @summary Der Outlook-Kalender eines anderen Postfachs.
 * @request GET:/Calendar/User/Outlook
 * @secure
 */
    calendarGetOutlookCalendarForUser: (
      query: {
        /** E-Mail-Adresse bzw. UPN des Postfachs. */
        user: string;
        /**
         * Erster Tag (einschließlich). Ohne Angabe heute.
         * @format date
         */
        von?: string | null;
        /**
         * Letzter Tag (einschließlich). Ohne Angabe die Vorgabespanne.
         * @format date
         */
        bis?: string | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<OutlookCalendarViewDto, ProblemDetails>({
        path: `/Calendar/User/Outlook`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
 * @description Nur für Administratoren — es sind mehrere fremde Kalender auf einmal. Der Zugriff wird als ein Eintrag protokolliert, der alle abgefragten Personen nennt. Die Personen werden server-seitig parallel gelesen.
 *
 * @tags Calendar
 * @name CalendarGetPlanner
 * @summary Der Planer: die Belegung mehrerer Personen über demselben Zeitfenster.
 * @request GET:/Calendar/Planner
 * @secure
 */
    calendarGetPlanner: (
      query: {
        /** E-Mail-Adressen der Personen, mit Komma getrennt, in Anzeigereihenfolge. */
        users: string;
        /**
         * Erster Tag (einschließlich). Ohne Angabe heute.
         * @format date
         */
        von?: string | null;
        /**
         * Letzter Tag (einschließlich). Ohne Angabe die Vorgabespanne.
         * @format date
         */
        bis?: string | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<PlannerViewDto, ProblemDetails>({
        path: `/Calendar/Planner`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Calendar
     * @name CalendarGetEntry
     * @summary Ein einzelner Eintrag aus dem eigenen Kalender.
     * @request GET:/Calendar/Entry/{entryId}
     * @secure
     */
    calendarGetEntry: (entryId: number, params: RequestParams = {}) =>
      this.request<CalendarEntryDto, ProblemDetails | void>({
        path: `/Calendar/Entry/${entryId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Calendar
     * @name CalendarMoveEntry
     * @summary Verschiebt einen eigenen freien Kalendereintrag.
     * @request PATCH:/Calendar/Entry/{entryId}
     * @secure
     */
    calendarMoveEntry: (entryId: number, data: MoveCalendarEntryRequest, params: RequestParams = {}) =>
      this.request<CalendarEntryDto, ProblemDetails | void>({
        path: `/Calendar/Entry/${entryId}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Löscht Tagessatz und Kopfsatz gemeinsam — das übernimmt LabelConnect.
     *
     * @tags Calendar
     * @name CalendarDeleteEntry
     * @summary Löscht einen eigenen freien Kalendereintrag.
     * @request DELETE:/Calendar/Entry/{entryId}
     * @secure
     */
    calendarDeleteEntry: (entryId: number, params: RequestParams = {}) =>
      this.request<void, ProblemDetails | void>({
        path: `/Calendar/Entry/${entryId}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * @description Die Personalnummer stammt immer aus dem angemeldeten Konto und lässt sich nicht übergeben. Nur freie Kalendereinträge (belegart 100) entstehen so — Aufträge und Abwesenheiten verwaltet Labelwin.
     *
     * @tags Calendar
     * @name CalendarCreateEntry
     * @summary Legt einen freien Kalendereintrag im eigenen Kalender an.
     * @request POST:/Calendar/Entry
     * @secure
     */
    calendarCreateEntry: (data: CreateCalendarEntryRequest, params: RequestParams = {}) =>
      this.request<CalendarEntryDto, ProblemDetails | void>({
        path: `/Calendar/Entry`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  dashboard = {
    /**
     * No description
     *
     * @tags Dashboard
     * @name DashboardGetStatistics
     * @summary Retrieves dashboard statistics and recent versions.
     * @request GET:/Dashboard/statistics
     * @secure
     */
    dashboardGetStatistics: (
      query?: {
        /**
         * Number of days used for recent versions.
         * @format int32
         * @default 30
         */
        days?: number;
        /**
         * Maximum number of recent versions returned.
         * @format int32
         * @default 5
         */
        limit?: number;
        /**
         * Window in days for expiring contracts.
         * @format int32
         * @default 30
         */
        expiringSoonDays?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<DashboardStatisticsDto, any>({
        path: `/Dashboard/statistics`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  device = {
    /**
     * No description
     *
     * @tags Device
     * @name DeviceRegisterDevice
     * @request POST:/Device/Register
     * @secure
     */
    deviceRegisterDevice: (data: RegisterDeviceModel, params: RequestParams = {}) =>
      this.request<DeviceQueryModel, any>({
        path: `/Device/Register`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Device
     * @name DeviceSetDeviceStatus
     * @request POST:/Device/SetDeviceStatus
     * @secure
     */
    deviceSetDeviceStatus: (data: SetDeviceStatusModel, params: RequestParams = {}) =>
      this.request<File, any>({
        path: `/Device/SetDeviceStatus`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Device
     * @name DeviceCreateDevice
     * @request POST:/Device
     * @secure
     */
    deviceCreateDevice: (data: CreateDeviceModel, params: RequestParams = {}) =>
      this.request<any, void>({
        path: `/Device`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Device
     * @name DeviceGetDevices
     * @request GET:/Device
     * @secure
     */
    deviceGetDevices: (
      query?: {
        supportCodeId?: string | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<DeviceQueryModel[], any>({
        path: `/Device`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Device
     * @name DeviceGetDeletedDevices
     * @request GET:/Device/deleted
     * @secure
     */
    deviceGetDeletedDevices: (
      query?: {
        supportCodeId?: string | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<DeviceQueryModel[], any>({
        path: `/Device/deleted`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Device
     * @name DeviceGetDevice
     * @request GET:/Device/{deviceId}
     * @secure
     */
    deviceGetDevice: (deviceId: string, params: RequestParams = {}) =>
      this.request<any, ProblemDetails>({
        path: `/Device/${deviceId}`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Device
     * @name DeviceDeleteDevice
     * @summary Löscht ein Device endgültig aus der Datenbank. Nur möglich wenn Status = Deleted.
     * @request DELETE:/Device/{deviceId}
     * @secure
     */
    deviceDeleteDevice: (deviceId: string, params: RequestParams = {}) =>
      this.request<void, ProblemDetails>({
        path: `/Device/${deviceId}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Device
     * @name DeviceUnlockRegistration
     * @request POST:/Device/{deviceId}/UnlockRegistration
     * @secure
     */
    deviceUnlockRegistration: (deviceId: string, params: RequestParams = {}) =>
      this.request<File, any>({
        path: `/Device/${deviceId}/UnlockRegistration`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Device
     * @name DeviceAssignSupportCode
     * @request POST:/Device/{deviceId}/AssignSupportCode
     * @secure
     */
    deviceAssignSupportCode: (deviceId: string, data: AssignSupportCodeModel, params: RequestParams = {}) =>
      this.request<DeviceQueryModel, any>({
        path: `/Device/${deviceId}/AssignSupportCode`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
 * No description
 *
 * @tags Device
 * @name DeviceSetServiceBeschreibung
 * @summary Setzt oder löscht die interne Service-Beschreibung eines Devices.
Diese Beschreibung dient als primäre Eingabe für die semantische
Suche (Vorbereitung für MCP-Anbindung). Re-Embedding läuft im
Hintergrund — neue Texte sind typisch nach 1 s findbar.
 * @request PUT:/Device/{deviceId}/ServiceBeschreibung
 * @secure
 */
    deviceSetServiceBeschreibung: (deviceId: string, data: SetServiceBeschreibungModel, params: RequestParams = {}) =>
      this.request<DeviceQueryModel, ProblemDetails>({
        path: `/Device/${deviceId}/ServiceBeschreibung`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Device
     * @name DeviceRenameDevice
     * @summary Benennt eine Anlage (Device) um.
     * @request PUT:/Device/{deviceId}/Name
     * @secure
     */
    deviceRenameDevice: (deviceId: string, data: RenameDeviceModel, params: RequestParams = {}) =>
      this.request<DeviceQueryModel, ProblemDetails>({
        path: `/Device/${deviceId}/Name`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
 * No description
 *
 * @tags Device
 * @name DeviceSetDeviceLocation
 * @summary Setzt den Standort einer Anlage. Kommen keine Koordinaten mit, wird die
Adresse serverseitig über Nominatim geocodiert.
 * @request PUT:/Device/{deviceId}/Location
 * @secure
 */
    deviceSetDeviceLocation: (deviceId: string, data: SetDeviceLocationModel, params: RequestParams = {}) =>
      this.request<DeviceQueryModel, ProblemDetails | void>({
        path: `/Device/${deviceId}/Location`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Device
     * @name DeviceClearDeviceLocation
     * @summary Entfernt den Standort einer Anlage inklusive Koordinaten.
     * @request DELETE:/Device/{deviceId}/Location
     * @secure
     */
    deviceClearDeviceLocation: (deviceId: string, params: RequestParams = {}) =>
      this.request<DeviceQueryModel, ProblemDetails>({
        path: `/Device/${deviceId}/Location`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Device
     * @name DeviceUpdateDeviceHostSystem
     * @request POST:/Device/{deviceId}/UpdateHostSystem
     * @secure
     */
    deviceUpdateDeviceHostSystem: (deviceId: string, data: UpdateDeviceHostSystemModel, params: RequestParams = {}) =>
      this.request<DeviceQueryModel, any>({
        path: `/Device/${deviceId}/UpdateHostSystem`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
 * No description
 *
 * @tags Device
 * @name DeviceAssignHostId
 * @summary Weist einem bestellten Pending-Gerät einmalig eine Hardware-ID (HostID) zu.
Nur möglich, solange das Gerät Pending ist und noch keine HostID hat.
Nach Zuweisung kann nur Admin/DEV per ReleaseHostId zurücksetzen.
 * @request POST:/Device/{deviceId}/AssignHostId
 * @secure
 */
    deviceAssignHostId: (deviceId: string, data: AssignHostIdModel, params: RequestParams = {}) =>
      this.request<DeviceQueryModel, ProblemDetails>({
        path: `/Device/${deviceId}/AssignHostId`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Device
     * @name DeviceReleaseHostId
     * @summary Löst die Host-ID-Bindung eines Devices (DEV only) und setzt das Device auf Pending.
     * @request POST:/Device/{deviceId}/ReleaseHostId
     * @secure
     */
    deviceReleaseHostId: (deviceId: string, data: ReleaseHostIdModel, params: RequestParams = {}) =>
      this.request<DeviceQueryModel, any>({
        path: `/Device/${deviceId}/ReleaseHostId`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Device
     * @name DeviceUploadLicenseXml
     * @request POST:/Device/{deviceId}/UploadLicenseXml
     * @secure
     */
    deviceUploadLicenseXml: (
      deviceId: string,
      data: {
        ContentType?: string | null;
        ContentDisposition?: string | null;
        Headers?: any[] | null;
        /** @format int64 */
        Length?: number;
        Name?: string | null;
        FileName?: string | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<any, BadRequestResponse>({
        path: `/Device/${deviceId}/UploadLicenseXml`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.FormData,
        ...params,
      }),

    /**
 * No description
 *
 * @tags Device
 * @name DeviceUploadLicenseXmlByHostId
 * @summary Lädt eine IOE XML für ein Device hoch - identifiziert über die HostId aus der XML
oder ersatzweise über (SupportCodeId, CustomerDeviceId). Fehlt die HostId in der XML,
wird das Device ohne HostId angelegt und kann später über die Kundenreferenz
aufgefunden werden.
 * @request POST:/Device/UploadLicenseXmlByHostId
 * @secure
 */
    deviceUploadLicenseXmlByHostId: (
      data: {
        ContentType?: string | null;
        ContentDisposition?: string | null;
        Headers?: any[] | null;
        /** @format int64 */
        Length?: number;
        Name?: string | null;
        FileName?: string | null;
      },
      query?: {
        /** Optionale SupportCode ID - wenn angegeben wird automatisch ein neues Gerät angelegt falls keins gefunden wird */
        supportCodeId?: string | null;
        /** Optionale kundenseitige Geräte-Referenz. Pflicht, wenn die XML keine HostId enthält. */
        customerDeviceId?: string | null;
        /**
         * Optionale Standort-Adresse der Anlage. Wird auf das angelegte bzw. gefundene Device
         * übernommen und überschreibt einen bestehenden Standort. Leer lassen, um den Standort
         * nicht anzufassen.
         */
        locationAddress?: string | null;
        /**
         * Optionaler Breitengrad des ausgewählten Treffers. Nur zusammen mit locationLongitude gültig; ohne beides geocodiert der Server selbst.
         * @format double
         */
        locationLatitude?: number | null;
        /**
         * Optionaler Längengrad des ausgewählten Treffers.
         * @format double
         */
        locationLongitude?: number | null;
        /** Optionale normalisierte Adresse des ausgewählten Treffers. */
        locationDisplayName?: string | null;
        /** Optionale Postleitzahl des ausgewählten Treffers. */
        locationPostalCode?: string | null;
        /** Optionaler Ort des ausgewählten Treffers. */
        locationCity?: string | null;
        /** Optionaler ISO-Ländercode des ausgewählten Treffers. */
        locationCountryCode?: string | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<any, BadRequestResponse | void>({
        path: `/Device/UploadLicenseXmlByHostId`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.FormData,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Device
     * @name DeviceHasIoeServerConfigXml
     * @summary Prüft, ob für ein Device eine IOE Server Config XML vorhanden ist
     * @request GET:/Device/{deviceId}/HasIoeServerConfigXml
     * @secure
     */
    deviceHasIoeServerConfigXml: (deviceId: string, params: RequestParams = {}) =>
      this.request<boolean, ProblemDetails>({
        path: `/Device/${deviceId}/HasIoeServerConfigXml`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Device
     * @name DeviceDownloadIoeServerConfigXml
     * @summary Lädt die IOE Server Config XML für ein Device herunter
     * @request GET:/Device/{deviceId}/DownloadIoeServerConfigXml
     * @secure
     */
    deviceDownloadIoeServerConfigXml: (deviceId: string, params: RequestParams = {}) =>
      this.request<void, ProblemDetails>({
        path: `/Device/${deviceId}/DownloadIoeServerConfigXml`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Device
     * @name DeviceCloneDevice
     * @summary Klont ein Device mit allen Lizenzen auf eine neue Host-ID. Nur für Admins.
     * @request POST:/Device/{deviceId}/clone
     * @secure
     */
    deviceCloneDevice: (deviceId: string, data: CloneDeviceModel, params: RequestParams = {}) =>
      this.request<DeviceQueryModel, ProblemDetails>({
        path: `/Device/${deviceId}/clone`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  api = {
    /**
     * No description
     *
     * @tags FileSharing
     * @name FileSharingUploadFile
     * @summary Uploads a file for a specific support contract
     * @request POST:/api/FileSharing/upload
     * @secure
     */
    fileSharingUploadFile: (
      data: {
        /** @format binary */
        File?: File | null;
        CustomTitle?: string | null;
        /** @format guid */
        SupportContractId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<SharedFileDto, any>({
        path: `/api/FileSharing/upload`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags FileSharing
     * @name FileSharingDownloadFile
     * @summary Downloads a file by its ID
     * @request GET:/api/FileSharing/download/{fileId}
     * @secure
     */
    fileSharingDownloadFile: (fileId: string, params: RequestParams = {}) =>
      this.request<File, any>({
        path: `/api/FileSharing/download/${fileId}`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags FileSharing
     * @name FileSharingListFiles
     * @summary Lists all files available for a specific support contract
     * @request GET:/api/FileSharing/{supportId}
     * @secure
     */
    fileSharingListFiles: (supportId: string, params: RequestParams = {}) =>
      this.request<SharedFileDto[], any>({
        path: `/api/FileSharing/${supportId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
 * No description
 *
 * @tags FileSharing
 * @name FileSharingUploadConfigFile
 * @summary Uploads a configuration file (XML/JSON only)
Only accessible by users with ACCESS_RIGHT permissions
Maximum file size: 1MB
 * @request POST:/api/FileSharing/config
 * @secure
 */
    fileSharingUploadConfigFile: (
      data: {
        /** @format binary */
        File?: File | null;
        CustomTitle?: string | null;
        /** @format guid */
        SupportContractId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<SharedFileDto, any>({
        path: `/api/FileSharing/config`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
 * No description
 *
 * @tags FileSharing
 * @name FileSharingUpdateFile
 * @summary Updates the content of an existing file
Only updates the file content and modified timestamp
 * @request PUT:/api/FileSharing/{fileId}
 * @secure
 */
    fileSharingUpdateFile: (
      fileId: string,
      data: {
        /** @format binary */
        file?: File | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<SharedFileDto, any>({
        path: `/api/FileSharing/${fileId}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
 * No description
 *
 * @tags FileSharing
 * @name FileSharingDeleteFile
 * @summary Deletes a file by its ID
OFFICE users can delete any file, other users can only delete their own files
 * @request DELETE:/api/FileSharing/{fileId}
 * @secure
 */
    fileSharingDeleteFile: (fileId: string, params: RequestParams = {}) =>
      this.request<File, any>({
        path: `/api/FileSharing/${fileId}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags FileSharing
     * @name FileSharingListAllFiles
     * @summary Lists all files in the system (OFFICE only)
     * @request GET:/api/FileSharing/all
     * @secure
     */
    fileSharingListAllFiles: (params: RequestParams = {}) =>
      this.request<SharedFileDto[], any>({
        path: `/api/FileSharing/all`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags HostId
     * @name HostIdCheckHostId
     * @summary Analysiert eine Host-ID und gibt deren Metadaten zurück
     * @request GET:/api/HostId/check/{hostId}
     * @secure
     */
    hostIdCheckHostId: (hostId: string, params: RequestParams = {}) =>
      this.request<HostIdResponse, ProblemDetails | void>({
        path: `/api/HostId/check/${hostId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags HostId
     * @name HostIdGetVersion
     * @summary Gibt die Version der nativen Bibliothek zurück
     * @request GET:/api/HostId/version
     * @secure
     */
    hostIdGetVersion: (params: RequestParams = {}) =>
      this.request<HostIdVersionResponse, any>({
        path: `/api/HostId/version`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags License
     * @name LicenseGenerateLicense
     * @summary Erstellt eine neue Lizenzdatei
     * @request POST:/api/License/generate
     * @secure
     */
    licenseGenerateLicense: (data: LicenseData, params: RequestParams = {}) =>
      this.request<LicenseFileResponse, any>({
        path: `/api/License/generate`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags License
     * @name LicenseValidateLicense
     * @summary Validiert eine Lizenzdatei und gibt die Inhalte auch bei ungültiger Signatur zurück
     * @request POST:/api/License/validate
     * @secure
     */
    licenseValidateLicense: (data: ValidateLicenseRequest, params: RequestParams = {}) =>
      this.request<LicenseInspectionResponse, ProblemDetails>({
        path: `/api/License/validate`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags License
     * @name LicenseGenerateLicenseFile
     * @summary Generiert eine Lizenzdatei und gibt sie als Download zurück
     * @request POST:/api/License/generate/download
     * @secure
     */
    licenseGenerateLicenseFile: (data: LicenseData, params: RequestParams = {}) =>
      this.request<File, any>({
        path: `/api/License/generate/download`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags License
     * @name LicenseGetLicenseOptions
     * @summary Gibt alle verfügbaren Lizenz-Optionen zurück
     * @request GET:/api/License/options
     * @secure
     */
    licenseGetLicenseOptions: (
      query?: {
        /**
         * Nur aktive Optionen zurückgeben
         * @default true
         */
        activeOnly?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<LicenseOptionDto[], any>({
        path: `/api/License/options`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags License
     * @name LicenseCreateLicenseOption
     * @summary Erstellt eine neue Lizenz-Option
     * @request POST:/api/License/options
     * @secure
     */
    licenseCreateLicenseOption: (data: CreateLicenseOptionRequest, params: RequestParams = {}) =>
      this.request<LicenseOptionDto, any>({
        path: `/api/License/options`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags License
     * @name LicenseGetLicenseOption
     * @summary Gibt eine spezifische Lizenz-Option zurück
     * @request GET:/api/License/options/{id}
     * @secure
     */
    licenseGetLicenseOption: (id: string, params: RequestParams = {}) =>
      this.request<LicenseOptionDto, ProblemDetails>({
        path: `/api/License/options/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags License
     * @name LicenseUpdateLicenseOption
     * @summary Aktualisiert eine Lizenz-Option
     * @request PUT:/api/License/options/{id}
     * @secure
     */
    licenseUpdateLicenseOption: (id: string, data: CreateLicenseOptionRequest, params: RequestParams = {}) =>
      this.request<LicenseOptionDto, ProblemDetails>({
        path: `/api/License/options/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags License
     * @name LicenseDeleteLicenseOption
     * @summary Löscht eine Lizenz-Option komplett (inkl. aller Verknüpfungen zu FileTypes)
     * @request DELETE:/api/License/options/{id}
     * @secure
     */
    licenseDeleteLicenseOption: (id: string, params: RequestParams = {}) =>
      this.request<void, ProblemDetails>({
        path: `/api/License/options/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags License
     * @name LicenseGetLicenseOptionUsages
     * @summary Gibt alle FileTypes zurück, die diese Lizenz-Option verwenden
     * @request GET:/api/License/options/{id}/usages
     * @secure
     */
    licenseGetLicenseOptionUsages: (id: string, params: RequestParams = {}) =>
      this.request<LicenseOptionUsageResponse, ProblemDetails>({
        path: `/api/License/options/${id}/usages`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags License
     * @name LicenseGetFileTypeLicenseOptions
     * @summary Gibt alle Lizenz-Optionen für einen FileType zurück
     * @request GET:/api/License/filetypes/{fileTypeId}/options
     * @secure
     */
    licenseGetFileTypeLicenseOptions: (fileTypeId: string, params: RequestParams = {}) =>
      this.request<FileTypeLicenseOptionResponse[], any>({
        path: `/api/License/filetypes/${fileTypeId}/options`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags License
     * @name LicenseAddLicenseOptionToFileType
     * @summary Verknüpft eine Lizenz-Option mit einem FileType
     * @request POST:/api/License/filetypes/{fileTypeId}/options
     * @secure
     */
    licenseAddLicenseOptionToFileType: (
      fileTypeId: string,
      data: AddLicenseOptionToFileTypeRequest,
      params: RequestParams = {},
    ) =>
      this.request<FileTypeLicenseOptionResponse, any>({
        path: `/api/License/filetypes/${fileTypeId}/options`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
 * No description
 *
 * @tags License
 * @name LicenseRemoveLicenseOptionFromFileType
 * @summary Entfernt die Verknüpfung zwischen FileType und Lizenz-Option
Wenn die Option nach dem Entfernen nicht mehr von anderen FileTypes verwendet wird, wird sie automatisch gelöscht
 * @request DELETE:/api/License/options/link/{id}
 * @secure
 */
    licenseRemoveLicenseOptionFromFileType: (id: string, params: RequestParams = {}) =>
      this.request<void, ProblemDetails>({
        path: `/api/License/options/link/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags License
     * @name LicenseUpdateFileTypeLicenseOption
     * @summary Aktualisiert eine Lizenz-Option für einen FileType (z.B. Default-Wert, IsRequired)
     * @request PUT:/api/License/options/link/{id}
     * @secure
     */
    licenseUpdateFileTypeLicenseOption: (
      id: string,
      data: UpdateFileTypeLicenseOptionRequest,
      params: RequestParams = {},
    ) =>
      this.request<FileTypeLicenseOptionResponse, ProblemDetails>({
        path: `/api/License/options/link/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags License
     * @name LicenseCreateDeviceLicense
     * @summary Erstellt eine neue Lizenz für ein Device
     * @request POST:/api/License/devices/{deviceId}/licenses
     * @secure
     */
    licenseCreateDeviceLicense: (deviceId: string, data: CreateFileTypeLicenseRequest, params: RequestParams = {}) =>
      this.request<FileTypeLicenseResponse, any>({
        path: `/api/License/devices/${deviceId}/licenses`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags License
     * @name LicenseGetDeviceLicenses
     * @summary Gibt alle Lizenzen eines Devices zurück
     * @request GET:/api/License/devices/{deviceId}/licenses
     * @secure
     */
    licenseGetDeviceLicenses: (deviceId: string, params: RequestParams = {}) =>
      this.request<FileTypeLicenseResponse[], ProblemDetails>({
        path: `/api/License/devices/${deviceId}/licenses`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags License
     * @name LicenseRequestDeviceLicense
     * @summary Fragt eine neue Lizenz für ein Device an (für Kunden)
     * @request POST:/api/License/devices/{deviceId}/license-requests
     * @secure
     */
    licenseRequestDeviceLicense: (deviceId: string, data: CreateFileTypeLicenseRequest, params: RequestParams = {}) =>
      this.request<FileTypeLicenseResponse, ProblemDetails>({
        path: `/api/License/devices/${deviceId}/license-requests`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags License
     * @name LicenseCreateDraftLicense
     * @summary Erstellt eine Lizenz als Entwurf (Draft) für einen Kunden
     * @request POST:/api/License/devices/{deviceId}/licenses/draft
     * @secure
     */
    licenseCreateDraftLicense: (deviceId: string, data: CreateFileTypeLicenseRequest, params: RequestParams = {}) =>
      this.request<FileTypeLicenseResponse, ProblemDetails>({
        path: `/api/License/devices/${deviceId}/licenses/draft`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags License
     * @name LicenseSubmitDraftLicense
     * @summary Überführt eine Draft-Lizenz in den Requested-Status (Bestellung)
     * @request POST:/api/License/devices/{deviceId}/licenses/{licenseId}/submit
     * @secure
     */
    licenseSubmitDraftLicense: (deviceId: string, licenseId: string, params: RequestParams = {}) =>
      this.request<FileTypeLicenseResponse[], ProblemDetails>({
        path: `/api/License/devices/${deviceId}/licenses/${licenseId}/submit`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags License
     * @name LicenseSubmitAllDraftLicenses
     * @summary Überführt alle Draft-Lizenzen eines Devices in den Requested-Status (Bestellung)
     * @request POST:/api/License/devices/{deviceId}/licenses/submitAll
     * @secure
     */
    licenseSubmitAllDraftLicenses: (deviceId: string, params: RequestParams = {}) =>
      this.request<FileTypeLicenseResponse[], ProblemDetails>({
        path: `/api/License/devices/${deviceId}/licenses/submitAll`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags License
     * @name LicenseGetDeviceLicenseCollection
     * @summary Gibt die Lizenzsammlung (Gesamtlizenz) eines Devices zurück
     * @request GET:/api/License/devices/{deviceId}/license-collection
     * @secure
     */
    licenseGetDeviceLicenseCollection: (deviceId: string, params: RequestParams = {}) =>
      this.request<DeviceLicenseCollectionResponse, ProblemDetails>({
        path: `/api/License/devices/${deviceId}/license-collection`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags License
     * @name LicenseGetDeviceLicense
     * @summary Gibt eine spezifische Lizenz eines Devices zurück
     * @request GET:/api/License/devices/{deviceId}/licenses/{licenseId}
     * @secure
     */
    licenseGetDeviceLicense: (deviceId: string, licenseId: string, params: RequestParams = {}) =>
      this.request<FileTypeLicenseResponse, ProblemDetails>({
        path: `/api/License/devices/${deviceId}/licenses/${licenseId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags License
     * @name LicenseDeleteDeviceLicense
     * @summary Löscht eine widerrufene Lizenz eines Devices dauerhaft
     * @request DELETE:/api/License/devices/{deviceId}/licenses/{licenseId}
     * @secure
     */
    licenseDeleteDeviceLicense: (deviceId: string, licenseId: string, params: RequestParams = {}) =>
      this.request<void, ProblemDetails>({
        path: `/api/License/devices/${deviceId}/licenses/${licenseId}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags License
     * @name LicenseSearchLicenses
     * @summary Sucht Lizenzen nach verschiedenen Kriterien
     * @request GET:/api/License/licenses
     * @secure
     */
    licenseSearchLicenses: (
      query?: {
        /**
         * Optionaler FileType Filter
         * @format guid
         */
        fileTypeId?: string | null;
        /**
         * Optionaler Device Filter
         * @format guid
         */
        deviceId?: string | null;
        /** Optionaler Status Filter */
        status?: FileTypeLicenseStatus | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<FileTypeLicenseResponse[], any>({
        path: `/api/License/licenses`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags License
     * @name LicenseGetRequestedLicenses
     * @summary Gibt alle aktuell angefragten Lizenzen zurück (Status: Requested)
     * @request GET:/api/License/licenses/requested
     * @secure
     */
    licenseGetRequestedLicenses: (params: RequestParams = {}) =>
      this.request<FileTypeLicenseResponse[], any>({
        path: `/api/License/licenses/requested`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags License
     * @name LicenseRevokeDeviceLicense
     * @summary Widerruft eine Lizenz eines Devices
     * @request POST:/api/License/devices/{deviceId}/licenses/{licenseId}/revoke
     * @secure
     */
    licenseRevokeDeviceLicense: (deviceId: string, licenseId: string, params: RequestParams = {}) =>
      this.request<void, ProblemDetails>({
        path: `/api/License/devices/${deviceId}/licenses/${licenseId}/revoke`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags License
     * @name LicenseApproveDeviceLicense
     * @summary Genehmigt eine angefragte Lizenz (Requested → Approved)
     * @request POST:/api/License/licenses/{licenseId}/approve
     * @secure
     */
    licenseApproveDeviceLicense: (licenseId: string, params: RequestParams = {}) =>
      this.request<FileTypeLicenseResponse, ProblemDetails>({
        path: `/api/License/licenses/${licenseId}/approve`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags License
     * @name LicenseRejectDeviceLicense
     * @summary Lehnt eine angefragte Lizenz ab (Requested → Draft)
     * @request POST:/api/License/licenses/{licenseId}/reject
     * @secure
     */
    licenseRejectDeviceLicense: (licenseId: string, data: RejectLicenseRequest, params: RequestParams = {}) =>
      this.request<void, ProblemDetails>({
        path: `/api/License/licenses/${licenseId}/reject`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags License
     * @name LicenseDownloadDeviceLicenseCollection
     * @summary Lädt die gesammelte Lizenzdatei für ein Device herunter
     * @request GET:/api/License/devices/{deviceId}/download
     * @secure
     */
    licenseDownloadDeviceLicenseCollection: (deviceId: string, params: RequestParams = {}) =>
      this.request<void, ProblemDetails>({
        path: `/api/License/devices/${deviceId}/download`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags License
     * @name LicenseGetLicensePublicKey
     * @summary Gibt den Public Key zur Signaturprüfung zurück
     * @request GET:/api/License/public-key
     * @secure
     */
    licenseGetLicensePublicKey: (params: RequestParams = {}) =>
      this.request<string, any>({
        path: `/api/License/public-key`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
 * No description
 *
 * @tags License
 * @name LicenseRecalculateLicenseServiceUnits
 * @summary Berechnet die Service-Einheiten einer einzelnen Lizenz neu und liefert eine Preview mit Token.
Die Änderung wird erst durch den Confirm-Endpoint persistiert (Token 10 Min gültig).
 * @request POST:/api/License/licenses/{licenseId}/service-units/recalculate
 * @secure
 */
    licenseRecalculateLicenseServiceUnits: (licenseId: string, params: RequestParams = {}) =>
      this.request<LicenseReconciliationPreview, ProblemDetails>({
        path: `/api/License/licenses/${licenseId}/service-units/recalculate`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags License
     * @name LicenseConfirmLicenseServiceUnits
     * @summary Bestätigt eine Service-Unit-Preview mit Token und persistiert die Werte.
     * @request POST:/api/License/licenses/{licenseId}/service-units/confirm
     * @secure
     */
    licenseConfirmLicenseServiceUnits: (
      licenseId: string,
      data: ConfirmReconciliationRequest,
      params: RequestParams = {},
    ) =>
      this.request<LicenseReconciliationResult, ProblemDetails>({
        path: `/api/License/licenses/${licenseId}/service-units/confirm`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
 * No description
 *
 * @tags License
 * @name LicenseSetLicenseExcludeFromCalculation
 * @summary Setzt oder entfernt den Ausschluss-Flag einer Lizenz (nur OFFICE).
Ausgenommene Lizenzen werden nicht in die Service-Einheiten-Summe des Vertrags aufgenommen.
 * @request PATCH:/api/License/licenses/{licenseId}/exclude-from-calculation
 * @secure
 */
    licenseSetLicenseExcludeFromCalculation: (
      licenseId: string,
      data: SetLicenseExcludeRequest,
      params: RequestParams = {},
    ) =>
      this.request<FileTypeLicenseResponse, ProblemDetails>({
        path: `/api/License/licenses/${licenseId}/exclude-from-calculation`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
 * No description
 *
 * @tags License
 * @name LicenseRecalculateAllServiceUnits
 * @summary Admin-Endpoint: Rechnet alle Lizenz-Snapshots und alle Vertrags-Gesamtsummen neu
(ohne Token) und überschreibt bestehende Werte. Nutzt man nach größeren Rezept-Änderungen
oder zur Initialisierung.
 * @request POST:/api/License/service-units/recalculate-all
 * @secure
 */
    licenseRecalculateAllServiceUnits: (params: RequestParams = {}) =>
      this.request<AdminRecalculateResult, any>({
        path: `/api/License/service-units/recalculate-all`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  fileType = {
    /**
     * No description
     *
     * @tags FileType
     * @name FileTypeGetHostSystems
     * @summary Get list of all valid host systems
     * @request GET:/FileType/HostSystems
     * @secure
     */
    fileTypeGetHostSystems: (params: RequestParams = {}) =>
      this.request<GetHostSystemData[], any>({
        path: `/FileType/HostSystems`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description This method performs a ```DELETE``` request to the host systems database. The host system ID is passed as a parameter. The host system is deleted from the database if it exists. If the host system doesn't exist, an error message is returned.
     *
     * @tags FileType
     * @name FileTypeDeleteHostSystem
     * @summary Asynchronously deletes a host system with a specific ID.
     * @request DELETE:/FileType/HostSystem/{id}
     * @secure
     */
    fileTypeDeleteHostSystem: (id: string, params: RequestParams = {}) =>
      this.request<File, any>({
        path: `/FileType/HostSystem/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * @description This method performs an asynchronous update operation on the host system and returns an ActionResult of GetHostSystemData. It accepts a string 'id' representing the unique identifier of the host system and an 'AddHostSystemData' object.
     *
     * @tags FileType
     * @name FileTypeUpdateHostSystem
     * @summary Updates an existing host system.
     * @request PUT:/FileType/HostSystem/{id}
     * @secure
     */
    fileTypeUpdateHostSystem: (id: string, data: AddHostSystemData, params: RequestParams = {}) =>
      this.request<GetHostSystemData, any>({
        path: `/FileType/HostSystem/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Post operation is asynchronous and the result of the request returns an ActionResult`1 where TResult is GetHostSystemData.
     *
     * @tags FileType
     * @name FileTypeAddHostSystem
     * @summary Adds a new host system asynchronous.
     * @request POST:/FileType/HostSystem
     * @secure
     */
    fileTypeAddHostSystem: (data: AddHostSystemData, params: RequestParams = {}) =>
      this.request<GetHostSystemData, any>({
        path: `/FileType/HostSystem`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags FileType
     * @name FileTypeGetFileTypes
     * @summary An HTTP GET endpoint that retrieves a list of file types.
     * @request GET:/FileType/FileType
     * @secure
     */
    fileTypeGetFileTypes: (
      query?: {
        /**
         * DEPRECATED: Filter by FileTypeClass (use documentationFilter instead)
         * @default "UNDEFINED"
         */
        variant?: FileTypeClass;
        /** Filter by specific HostSystem IDs */
        system?: string[] | null;
        /**
         * Filter for documentation HostSystems. Default: All
         * @default "All"
         */
        documentationFilter?: DocumentationFilter;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetFileTypeData[], any>({
        path: `/FileType/FileType`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description This method specifically targets the addition of a new file type into the system. Use this method carefully to avoid duplications or invalid data in the system.
     *
     * @tags FileType
     * @name FileTypeAddFileType
     * @summary This method allows to add a file type.
     * @request POST:/FileType/FileType
     * @secure
     */
    fileTypeAddFileType: (data: AddFileTypeData, params: RequestParams = {}) =>
      this.request<GetFileTypeData, any>({
        path: `/FileType/FileType`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags FileType
     * @name FileTypeGetFileTypesPublic
     * @summary An HTTP GET endpoint that retrieves a list of file types.
     * @request GET:/FileType/FileType/Public
     * @secure
     */
    fileTypeGetFileTypesPublic: (
      query?: {
        /**
         * DEPRECATED: Filter by FileTypeClass (use documentationFilter instead)
         * @default "UNDEFINED"
         */
        variant?: FileTypeClass;
        /**
         * Filter for documentation HostSystems. Default: All
         * @default "All"
         */
        documentationFilter?: DocumentationFilter;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetFileTypeData[], any>({
        path: `/FileType/FileType/Public`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags FileType
     * @name FileTypeGetFileTypePublic
     * @summary An HTTP GET endpoint that retrieves a list of file types.
     * @request GET:/FileType/FileType/Public/{id}
     * @secure
     */
    fileTypeGetFileTypePublic: (id: string, params: RequestParams = {}) =>
      this.request<GetFileTypeData, any>({
        path: `/FileType/FileType/Public/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags FileType
     * @name FileTypeGetFileType
     * @summary An HTTP GET endpoint that retrieves a list of file types.
     * @request GET:/FileType/FileType/{id}
     * @secure
     */
    fileTypeGetFileType: (id: string, params: RequestParams = {}) =>
      this.request<GetFileTypeData, any>({
        path: `/FileType/FileType/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description This is an asynchronous operation that deletes a specific file type based on the provided ID.
     *
     * @tags FileType
     * @name FileTypeDeleteFileType
     * @summary Deletes a specific file type.
     * @request DELETE:/FileType/FileType/{id}
     * @secure
     */
    fileTypeDeleteFileType: (id: string, params: RequestParams = {}) =>
      this.request<File, any>({
        path: `/FileType/FileType/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * @description This method will edit existing file type data in the system.
     *
     * @tags FileType
     * @name FileTypeEditFileType
     * @summary Edits the file type data.
     * @request PUT:/FileType/FileType/{id}
     * @secure
     */
    fileTypeEditFileType: (id: string, data: AddFileTypeData, params: RequestParams = {}) =>
      this.request<GetFileTypeData, any>({
        path: `/FileType/FileType/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags FileType
     * @name FileTypeGetFileTypeVersions
     * @summary Get versions that contain files for a file type.
     * @request GET:/FileType/FileType/{fileTypeId}/Versions
     * @secure
     */
    fileTypeGetFileTypeVersions: (
      fileTypeId: string,
      query?: {
        /**
         * Filter for documentation HostSystems. Default: All
         * @default "All"
         */
        documentationFilter?: DocumentationFilter;
        /**
         * Maximum number of versions to return. Default: 3
         * @format int32
         * @default 3
         */
        maxVersions?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetVersionFileData[], any>({
        path: `/FileType/FileType/${fileTypeId}/Versions`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description This method requires the caller to be authorized with the "ADMIN" user group.
     *
     * @tags FileType
     * @name FileTypeUpdateFileTypes
     * @summary Updates the file types for a specific file.
     * @request POST:/FileType/FileType/{fileTypeId}/HostSystem/{hostSystemId}/MatchingFiles
     * @secure
     */
    fileTypeUpdateFileTypes: (fileTypeId: string, hostSystemId: string, data: string[], params: RequestParams = {}) =>
      this.request<GetFileTypeData, any>({
        path: `/FileType/FileType/${fileTypeId}/HostSystem/${hostSystemId}/MatchingFiles`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags FileType
     * @name FileTypeGetScreenshots
     * @summary Gets the list of screenshots for a specific file type.
     * @request GET:/FileType/FileType/{fileTypeId}/Screenshots
     * @secure
     */
    fileTypeGetScreenshots: (fileTypeId: string, params: RequestParams = {}) =>
      this.request<ImageDto[], any>({
        path: `/FileType/FileType/${fileTypeId}/Screenshots`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags FileType
     * @name FileTypeAddLogo
     * @summary Adds a logo to a specific file type.
     * @request POST:/FileType/FileType/{fileTypeId}/Logo
     * @secure
     */
    fileTypeAddLogo: (
      fileTypeId: string,
      data: {
        /** @format binary */
        File?: File | null;
        Description?: string | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<ImageDto, any>({
        path: `/FileType/FileType/${fileTypeId}/Logo`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags FileType
     * @name FileTypeGetLogo
     * @summary Adds a logo to a specific file type.
     * @request GET:/FileType/FileType/{fileTypeId}/Logo
     * @secure
     */
    fileTypeGetLogo: (fileTypeId: string, params: RequestParams = {}) =>
      this.request<ImageDto, any>({
        path: `/FileType/FileType/${fileTypeId}/Logo`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags FileType
     * @name FileTypeAddScreenshot
     * @summary Adds a screenshot to a specific file type.
     * @request POST:/FileType/FileType/{fileTypeId}/Screenshot
     * @secure
     */
    fileTypeAddScreenshot: (
      fileTypeId: string,
      data: {
        /** @format binary */
        File?: File | null;
        Description?: string | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<ImageDto, any>({
        path: `/FileType/FileType/${fileTypeId}/Screenshot`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags FileType
     * @name FileTypeEditImageDescription
     * @summary Edits the description of a specific image.
     * @request PUT:/FileType/FileType/Image/{imageId}/Description
     * @secure
     */
    fileTypeEditImageDescription: (imageId: string, data: string, params: RequestParams = {}) =>
      this.request<ImageDto, any>({
        path: `/FileType/FileType/Image/${imageId}/Description`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags FileType
     * @name FileTypeDeleteImage
     * @summary Deletes a specific image.
     * @request DELETE:/FileType/FileType/Image/{imageId}
     * @secure
     */
    fileTypeDeleteImage: (imageId: string, params: RequestParams = {}) =>
      this.request<File, any>({
        path: `/FileType/FileType/Image/${imageId}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags FileType
     * @name FileTypeGetImageDataRaw
     * @summary Gets a specific image by its ID and serves it as a direct file response.
     * @request GET:/FileType/Image/{imageId}
     * @secure
     */
    fileTypeGetImageDataRaw: (imageId: string, params: RequestParams = {}) =>
      this.request<File, any>({
        path: `/FileType/Image/${imageId}`,
        method: "GET",
        secure: true,
        ...params,
      }),
  };
  filterTags = {
    /**
     * No description
     *
     * @tags FilterTags
     * @name FilterTagsListFilterTags
     * @summary Lists all filter tags
     * @request GET:/FilterTags
     * @secure
     */
    filterTagsListFilterTags: (params: RequestParams = {}) =>
      this.request<GetFilterTagData[], any>({
        path: `/FilterTags`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags FilterTags
     * @name FilterTagsAddFilterTag
     * @summary Add new filter tag
     * @request POST:/FilterTags
     * @secure
     */
    filterTagsAddFilterTag: (data: AddFilterTagData, params: RequestParams = {}) =>
      this.request<any, BadRequestResponse>({
        path: `/FilterTags`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),
  };
  gdbService = {
    /**
     * @description The payload is written to disk before the job row is committed. Earlier versions streamed it into a temp file opened with DeleteOnClose and pushed it straight to a service, so a failed push destroyed the only copy of the dump.
     *
     * @tags GdbService
     * @name GdbServiceRunGdbProcess
     * @summary Accepts a core dump archive and queues it for analysis.
     * @request POST:/GdbService/run-gdb-process
     * @secure
     */
    gdbServiceRunGdbProcess: (
      data: File,
      query?: {
        Command?: string | null;
        Interpreter?: string | null;
        FileName?: string;
        /** @format int32 */
        BuildId?: number | null;
        BuildType?: string | null;
        Debug?: boolean | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<any, ProblemDetails>({
        path: `/GdbService/run-gdb-process`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        ...params,
      }),

    /**
     * @description This is the lightweight counterpart to a core dump: kilobytes instead of gigabytes, so devices can forward it without anyone downloading a dump by hand. Analysis uses the same symbols and the same analyzer image, only with addr2line instead of gdb.
     *
     * @tags GdbService
     * @name GdbServiceSubmitStacktrace
     * @summary Accepts a stacktrace report captured by the crashing process itself.
     * @request POST:/GdbService/stacktrace
     * @secure
     */
    gdbServiceSubmitStacktrace: (data: StacktraceReportDto, params: RequestParams = {}) =>
      this.request<any, ProblemDetails>({
        path: `/GdbService/stacktrace`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags GdbService
     * @name GdbServiceHeartbeat
     * @summary Records a worker's liveness and capacity.
     * @request POST:/GdbService/workers/heartbeat
     * @secure
     */
    gdbServiceHeartbeat: (data: WorkerHeartbeatDto, params: RequestParams = {}) =>
      this.request<File, any>({
        path: `/GdbService/workers/heartbeat`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Claiming is a single UPDATE … FOR UPDATE SKIP LOCKED … RETURNING, so two workers polling at the same moment can never take the same job. Abandoned claims are recovered first, which is why a worker that dies mid-analysis costs a retry rather than the job.
     *
     * @tags GdbService
     * @name GdbServiceClaimJobs
     * @summary Hands queued jobs to a worker.
     * @request POST:/GdbService/jobs/claim
     * @secure
     */
    gdbServiceClaimJobs: (data: ClaimJobRequestDto, params: RequestParams = {}) =>
      this.request<AnalysisJobDto[], any>({
        path: `/GdbService/jobs/claim`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags GdbService
     * @name GdbServiceDownloadJobPayload
     * @summary Streams the stored payload of a core dump job.
     * @request GET:/GdbService/jobs/{id}/dump
     * @secure
     */
    gdbServiceDownloadJobPayload: (id: string, params: RequestParams = {}) =>
      this.request<any, ProblemDetails>({
        path: `/GdbService/jobs/${id}/dump`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags GdbService
     * @name GdbServiceReportResult
     * @summary Accepts the outcome of a completed analysis.
     * @request POST:/GdbService/jobs/{id}/result
     * @secure
     */
    gdbServiceReportResult: (id: string, data: AnalysisResultDto, params: RequestParams = {}) =>
      this.request<any, ProblemDetails>({
        path: `/GdbService/jobs/${id}/result`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description A job below the attempt limit returns to the queue so a transient fault — an unreachable registry, a TeamCity hiccup — does not discard the report.
     *
     * @tags GdbService
     * @name GdbServiceReportFailure
     * @summary Records that an analysis failed.
     * @request POST:/GdbService/jobs/{id}/failed
     * @secure
     */
    gdbServiceReportFailure: (id: string, data: string, params: RequestParams = {}) =>
      this.request<any, ProblemDetails>({
        path: `/GdbService/jobs/${id}/failed`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags GdbService
     * @name GdbServiceListResults
     * @summary Retrieves a list of core dump results.
     * @request GET:/GdbService/results
     * @secure
     */
    gdbServiceListResults: (
      query?: {
        /**
         * If true, only returns results that completed successfully.
         * @default true
         */
        onlyFinished?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetCoreDumpDTO[], any>({
        path: `/GdbService/results`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags GdbService
     * @name GdbServiceGetResultById
     * @summary Gets a single crash record by id.
     * @request GET:/GdbService/results/{id}
     * @secure
     */
    gdbServiceGetResultById: (id: string, params: RequestParams = {}) =>
      this.request<any, ProblemDetails>({
        path: `/GdbService/results/${id}`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags GdbService
     * @name GdbServiceDeleteCoreDumpById
     * @summary Soft-deletes a crash record and removes its stored artefacts.
     * @request DELETE:/GdbService/results/{id}
     * @secure
     */
    gdbServiceDeleteCoreDumpById: (id: string, params: RequestParams = {}) =>
      this.request<any, ProblemDetails>({
        path: `/GdbService/results/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags GdbService
     * @name GdbServiceGetResultDataById
     * @summary Retrieves the stored analysis result of a crash record.
     * @request GET:/GdbService/results/{id}/data
     * @secure
     */
    gdbServiceGetResultDataById: (id: string, params: RequestParams = {}) =>
      this.request<any, ProblemDetails>({
        path: `/GdbService/results/${id}/data`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags GdbService
     * @name GdbServiceServices
     * @summary Lists the registered analysis workers and whether they are currently alive.
     * @request GET:/GdbService/services
     * @secure
     */
    gdbServiceServices: (params: RequestParams = {}) =>
      this.request<AnalysisWorkerDTO[], any>({
        path: `/GdbService/services`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  geocoding = {
    /**
 * No description
 *
 * @tags Geocoding
 * @name GeocodingSearch
 * @summary Sucht Standorte zu einer Freitext-Adresse (Autocomplete-Quelle für die
Standort-Eingabe an der Anlage).
 * @request GET:/Geocoding/Search
 * @secure
 */
    geocodingSearch: (
      query?: {
        /** Die Adresse als Freitext, mindestens 3 Zeichen. */
        q?: string;
        /**
         * Optionale Trefferbegrenzung; wird serverseitig gedeckelt.
         * @format int32
         */
        limit?: number | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<GeocodeResultModel[], ProblemDetails | void>({
        path: `/Geocoding/Search`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Geocoding
     * @name GeocodingReverse
     * @summary Löst Koordinaten in die nächstgelegene Adresse auf.
     * @request GET:/Geocoding/Reverse
     * @secure
     */
    geocodingReverse: (
      query?: {
        /**
         * Breitengrad (WGS84).
         * @format double
         */
        lat?: number;
        /**
         * Längengrad (WGS84).
         * @format double
         */
        lon?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<GeocodeResultModel, ProblemDetails | void>({
        path: `/Geocoding/Reverse`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Geocoding
     * @name GeocodingGetSettings
     * @summary Liefert die aktuell wirksamen Geocoding-Einstellungen.
     * @request GET:/Geocoding/Settings
     * @secure
     */
    geocodingGetSettings: (params: RequestParams = {}) =>
      this.request<GeocodingSettingsDto, any>({
        path: `/Geocoding/Settings`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
 * No description
 *
 * @tags Geocoding
 * @name GeocodingSaveSettings
 * @summary Speichert die Geocoding-Einstellungen. Greift ohne Server-Neustart — die
nächste Adress-Suche benutzt die neuen Werte.
 * @request PUT:/Geocoding/Settings
 * @secure
 */
    geocodingSaveSettings: (data: UpdateGeocodingSettingsRequest, params: RequestParams = {}) =>
      this.request<GeocodingSettingsDto, ProblemDetails>({
        path: `/Geocoding/Settings`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
 * No description
 *
 * @tags Geocoding
 * @name GeocodingTestConnection
 * @summary Prüft die Anbindung mit einer echten Testanfrage gegen die konfigurierte
Instanz und liefert das Ergebnis in Klartext.
 * @request POST:/Geocoding/TestConnection
 * @secure
 */
    geocodingTestConnection: (params: RequestParams = {}) =>
      this.request<GeocodingTestResultDto, any>({
        path: `/Geocoding/TestConnection`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  geodata = {
    /**
 * No description
 *
 * @tags Geodata
 * @name GeodataSubmitJob
 * @summary Reicht eine .osm.pbf-Datei für die Konvertierung ein. Liefert sofort
das Job-Objekt zurück; der Fortschritt kommt über SignalR-Events oder
per Polling von GET /Geodata/jobs/{id}.
 * @request POST:/Geodata/jobs
 * @secure
 */
    geodataSubmitJob: (
      data: {
        /** @format binary */
        PbfFile?: File | null;
        OutputFormat?: string | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<GeodataConversionJobInfo, ProblemDetails>({
        path: `/Geodata/jobs`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Geodata
     * @name GeodataListJobs
     * @summary Listet Jobs. Office+ sieht alle Jobs, andere User nur die eigenen.
     * @request GET:/Geodata/jobs
     * @secure
     */
    geodataListJobs: (params: RequestParams = {}) =>
      this.request<GeodataConversionJobInfo[], any>({
        path: `/Geodata/jobs`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
 * No description
 *
 * @tags Geodata
 * @name GeodataHealth
 * @summary Verfügbarkeits-Check. Liefert das Preflight-Ergebnis (tilemaker / docker
auf der Maschine erreichbar?). Clients können vor dem Upload prüfen, ob
der Dienst überhaupt nutzbar ist.
 * @request GET:/Geodata/health
 * @secure
 */
    geodataHealth: (params: RequestParams = {}) =>
      this.request<GeodataConversionAvailabilityState, void>({
        path: `/Geodata/health`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Geodata
     * @name GeodataGetJob
     * @summary Einzel-Status für Polling-Clients.
     * @request GET:/Geodata/jobs/{jobId}
     * @secure
     */
    geodataGetJob: (jobId: string, params: RequestParams = {}) =>
      this.request<GeodataConversionJobInfo, ProblemDetails>({
        path: `/Geodata/jobs/${jobId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
 * No description
 *
 * @tags Geodata
 * @name GeodataDeleteJob
 * @summary Bricht einen laufenden Job ab oder löscht das Ergebnis sofort
(statt auf den Sweep zu warten).
 * @request DELETE:/Geodata/jobs/{jobId}
 * @secure
 */
    geodataDeleteJob: (jobId: string, params: RequestParams = {}) =>
      this.request<void, ProblemDetails>({
        path: `/Geodata/jobs/${jobId}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
 * No description
 *
 * @tags Geodata
 * @name GeodataDownloadResult
 * @summary Stream-Download des fertigen Outputs. Nur erlaubt, wenn Status==Completed
und Datei noch nicht durch den Sweep entfernt wurde.
 * @request GET:/Geodata/jobs/{jobId}/result
 * @secure
 */
    geodataDownloadResult: (jobId: string, params: RequestParams = {}) =>
      this.request<void, ProblemDetails>({
        path: `/Geodata/jobs/${jobId}/result`,
        method: "GET",
        secure: true,
        ...params,
      }),
  };
  labelConnect = {
    /**
     * No description
     *
     * @tags LabelConnect
     * @name LabelConnectGetSettings
     * @summary Die aktuell wirksamen Verbindungseinstellungen — ohne den API-Schlüssel.
     * @request GET:/LabelConnect/Settings
     * @secure
     */
    labelConnectGetSettings: (params: RequestParams = {}) =>
      this.request<LabelConnectSettingsDto, any>({
        path: `/LabelConnect/Settings`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
 * @description Für den API-Schlüssel gilt: null lässt den gespeicherten Wert unverändert, "" löscht ihn. Die Oberfläche schickt ihn deshalb nur, wenn er geändert wurde.
 *
 * @tags LabelConnect
 * @name LabelConnectSaveSettings
 * @summary Speichert die Verbindungseinstellungen. Greift ohne Server-Neustart — die nächste
Kalenderabfrage benutzt die neuen Werte.
 * @request PUT:/LabelConnect/Settings
 * @secure
 */
    labelConnectSaveSettings: (data: UpdateLabelConnectSettingsRequest, params: RequestParams = {}) =>
      this.request<LabelConnectSettingsDto, ProblemDetails>({
        path: `/LabelConnect/Settings`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Bewusst ein echter Aufruf statt eines Pings — und bewusst mit Blick auf die eigene Personenzuordnung: die häufigste Störung ist nicht der unerreichbare Dienst, sondern ein fehlender oder falsch geschriebener LabelBenutzer am Konto. Antwortet auch im Fehlerfall mit HTTP 200; die Ursache steht in Message.
     *
     * @tags LabelConnect
     * @name LabelConnectTestConnection
     * @summary Prüft die Anbindung mit einer echten Abfrage der Mitarbeiterliste.
     * @request POST:/LabelConnect/TestConnection
     * @secure
     */
    labelConnectTestConnection: (params: RequestParams = {}) =>
      this.request<LabelConnectTestResultDto, any>({
        path: `/LabelConnect/TestConnection`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags LabelConnect
     * @name LabelConnectGetConfiguration
     * @summary Die Zielwerte, mit denen LabelConnect in Projdat schreibt.
     * @request GET:/LabelConnect/Configuration
     * @secure
     */
    labelConnectGetConfiguration: (params: RequestParams = {}) =>
      this.request<LabelwinConfigurationDto, void>({
        path: `/LabelConnect/Configuration`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Die Projektnummer wird nicht mitgegeben — LabelConnect schlägt sie aus projgrund nach, damit Id und Nummer nicht auseinanderlaufen. Jeder Wert wird dort gegen Projdat geprüft, bevor die Datei angefasst wird; nach einer Ablehnung (HTTP 400) steht der alte Wert unverändert da. Wer geändert hat, ergibt sich aus dem angemeldeten Konto. Ohne hinterlegten LabelBenutzer antwortet dieser Endpunkt mit HTTP 403 — dann wäre nicht nachvollziehbar, wer den Zielwert verstellt hat.
     *
     * @tags LabelConnect
     * @name LabelConnectUpdateConfiguration
     * @summary Ändert einzelne Zielwerte von LabelConnect. Nur übergebene Felder werden geändert.
     * @request PATCH:/LabelConnect/Configuration
     * @secure
     */
    labelConnectUpdateConfiguration: (data: UpdateLabelwinConfigurationRequest, params: RequestParams = {}) =>
      this.request<LabelwinConfigurationDto, ProblemDetails | void>({
        path: `/LabelConnect/Configuration`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags LabelConnect
     * @name LabelConnectGetProjects
     * @summary Die Projekte aus projgrund für die Auswahl eines Zielprojekts.
     * @request GET:/LabelConnect/Configuration/Projects
     * @secure
     */
    labelConnectGetProjects: (
      query?: {
        /** Filter auf Projektnummer und Bezeichnung; leer = alle. */
        suche?: string | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<LabelwinProjectDto[], void>({
        path: `/LabelConnect/Configuration/Projects`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Ohne diese Liste müsste der LabelBenutzer abgetippt werden, und ein Tippfehler fällt erst auf, wenn der Kalender leer bleibt. Die Personalnummer steht bewusst mit dabei: sie ist der verlässliche Schlüssel, der LabelBenutzer ist in Labelwin nicht lückenlos gepflegt.
     *
     * @tags LabelConnect
     * @name LabelConnectGetEmployees
     * @summary Die Labelwin-Mitarbeiter — Vorlage für das Feld „LabelBenutzer" der Benutzerverwaltung.
     * @request GET:/LabelConnect/Employees
     * @secure
     */
    labelConnectGetEmployees: (params: RequestParams = {}) =>
      this.request<CalendarEmployeeDto[], void>({
        path: `/LabelConnect/Employees`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  o365 = {
    /**
     * No description
     *
     * @tags O365
     * @name O365GetSettings
     * @summary Die aktuell wirksamen Verbindungseinstellungen — ohne den Clientschlüssel.
     * @request GET:/O365/Settings
     * @secure
     */
    o365GetSettings: (params: RequestParams = {}) =>
      this.request<O365SettingsDto, any>({
        path: `/O365/Settings`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
 * @description Für den Clientschlüssel gilt: null lässt den gespeicherten Wert unverändert, "" löscht ihn. Die Oberfläche schickt ihn deshalb nur, wenn er geändert wurde.
 *
 * @tags O365
 * @name O365SaveSettings
 * @summary Speichert die Verbindungseinstellungen. Greift ohne Server-Neustart — die nächste
Graph-Anfrage benutzt die neuen Werte.
 * @request PUT:/O365/Settings
 * @secure
 */
    o365SaveSettings: (data: UpdateO365SettingsRequest, params: RequestParams = {}) =>
      this.request<O365SettingsDto, ProblemDetails>({
        path: `/O365/Settings`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Bewusst zwei getrennte Stufen: scheitert die Anmeldung, sind Mandant, Client-ID oder Schlüssel falsch; scheitert erst der Kalenderzugriff, fehlt die Berechtigung Calendars.Read, die Administratorzustimmung — oder eine Zugriffsrichtlinie schließt das Postfach aus. Antwortet auch im Fehlerfall mit HTTP 200.
     *
     * @tags O365
     * @name O365TestConnection
     * @summary Prüft die Anbindung in Stufen: Anmeldung bei Microsoft, dann Kalenderzugriff auf ein
Postfach.
     * @request POST:/O365/TestConnection
     * @secure
     */
    o365TestConnection: (data: TestO365ConnectionRequest, params: RequestParams = {}) =>
      this.request<O365TestResultDto, any>({
        path: `/O365/TestConnection`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Die Auskunft stammt aus dem Zugriffstoken selbst, in das Microsoft die erteilten Anwendungsberechtigungen schreibt. Gezeigt wird der Stand nach der Administratorzustimmung — eine eingetragene, aber nicht zugestimmte Berechtigung erscheint nicht.
     *
     * @tags O365
     * @name O365Permissions
     * @summary Zeigt, welche Graph-Berechtigungen die App-Registrierung tatsächlich hat.
     * @request GET:/O365/Permissions
     * @secure
     */
    o365Permissions: (params: RequestParams = {}) =>
      this.request<O365PermissionsDto, any>({
        path: `/O365/Permissions`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  ldapAdmin = {
    /**
     * No description
     *
     * @tags LdapAdmin
     * @name LdapAdminGetSettings
     * @summary Liefert die aktuell wirksamen Verbindungseinstellungen (ohne Passwort).
     * @request GET:/LdapAdmin/Settings
     * @secure
     */
    ldapAdminGetSettings: (params: RequestParams = {}) =>
      this.request<LdapSettingsDto, any>({
        path: `/LdapAdmin/Settings`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
 * No description
 *
 * @tags LdapAdmin
 * @name LdapAdminSaveSettings
 * @summary Speichert die Verbindungseinstellungen. Greift ohne Server-Neustart — der nächste Login
benutzt die neuen Werte.
 * @request PUT:/LdapAdmin/Settings
 * @secure
 */
    ldapAdminSaveSettings: (data: UpdateLdapSettingsRequest, params: RequestParams = {}) =>
      this.request<any, ProblemDetails>({
        path: `/LdapAdmin/Settings`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
 * No description
 *
 * @tags LdapAdmin
 * @name LdapAdminDiscover
 * @summary Auto-Konfiguration: ermittelt aus einem Domain-Login (vorname.nachname@firma.local
plus Passwort) Domain-Controller, Port, Verschlüsselung, BaseDn und die verfügbaren
Gruppen. Speichert nichts — das Ergebnis enthält einen Vorschlag, der nach Sichtprüfung
an PUT Settings geschickt wird.
 * @request POST:/LdapAdmin/Discover
 * @secure
 */
    ldapAdminDiscover: (data: LdapDiscoveryRequest, params: RequestParams = {}) =>
      this.request<LdapDiscoveryResultDto, any>({
        path: `/LdapAdmin/Discover`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
 * No description
 *
 * @tags LdapAdmin
 * @name LdapAdminTestConnection
 * @summary Prüft die gespeicherten Einstellungen gegen den Domain-Controller und meldet das Ergebnis
in Klartext.
 * @request POST:/LdapAdmin/TestConnection
 * @secure
 */
    ldapAdminTestConnection: (data: LdapCredentials, params: RequestParams = {}) =>
      this.request<LdapTestResultDto, any>({
        path: `/LdapAdmin/TestConnection`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
 * No description
 *
 * @tags LdapAdmin
 * @name LdapAdminListGroups
 * @summary Listet die Gruppen des Verzeichnisses, damit CNs in der UI ausgewählt statt getippt
werden — ein Tippfehler würde sonst nur als stumme Login-Ablehnung auffallen.
 * @request POST:/LdapAdmin/Groups
 * @secure
 */
    ldapAdminListGroups: (
      data: LdapCredentials,
      query?: {
        /** Optionaler Namensfilter (Teilstring). */
        search?: string | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<any, ProblemDetails>({
        path: `/LdapAdmin/Groups`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),
  };
  permissions = {
    /**
     * No description
     *
     * @tags MyPermissions
     * @name MyPermissionsGetMyPermissions
     * @summary Liefert die eigenen effektiven Berechtigungen samt Bequem-Flags.
     * @request GET:/Permissions/me
     * @secure
     */
    myPermissionsGetMyPermissions: (params: RequestParams = {}) =>
      this.request<any, ProblemDetails>({
        path: `/Permissions/me`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags PermissionAdmin
     * @name PermissionAdminGetCatalog
     * @summary Liefert den Katalog aller bekannten Berechtigungen (für die Verwaltungs-UI).
     * @request GET:/Permissions/catalog
     * @secure
     */
    permissionAdminGetCatalog: (params: RequestParams = {}) =>
      this.request<PermissionDefinitionDto[], any>({
        path: `/Permissions/catalog`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PermissionAdmin
     * @name PermissionAdminListGroups
     * @summary Listet alle Berechtigungs-Gruppen (Kurzfassung).
     * @request GET:/Permissions/groups
     * @secure
     */
    permissionAdminListGroups: (params: RequestParams = {}) =>
      this.request<PermissionGroupSummaryDto[], any>({
        path: `/Permissions/groups`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PermissionAdmin
     * @name PermissionAdminCreateGroup
     * @summary Legt eine neue Gruppe an.
     * @request POST:/Permissions/groups
     * @secure
     */
    permissionAdminCreateGroup: (data: CreatePermissionGroupRequest, params: RequestParams = {}) =>
      this.request<any, ProblemDetails>({
        path: `/Permissions/groups`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags PermissionAdmin
     * @name PermissionAdminGetGroup
     * @summary Liefert eine Gruppe inkl. Berechtigungen und Mitglieder.
     * @request GET:/Permissions/groups/{id}
     * @secure
     */
    permissionAdminGetGroup: (id: string, params: RequestParams = {}) =>
      this.request<any, ProblemDetails>({
        path: `/Permissions/groups/${id}`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags PermissionAdmin
     * @name PermissionAdminUpdateGroup
     * @summary Ändert Name/Beschreibung einer Gruppe.
     * @request PUT:/Permissions/groups/{id}
     * @secure
     */
    permissionAdminUpdateGroup: (id: string, data: UpdatePermissionGroupRequest, params: RequestParams = {}) =>
      this.request<any, ProblemDetails>({
        path: `/Permissions/groups/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags PermissionAdmin
     * @name PermissionAdminDeleteGroup
     * @summary Löscht eine Gruppe.
     * @request DELETE:/Permissions/groups/{id}
     * @secure
     */
    permissionAdminDeleteGroup: (id: string, params: RequestParams = {}) =>
      this.request<void, ProblemDetails>({
        path: `/Permissions/groups/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags PermissionAdmin
     * @name PermissionAdminSetGrants
     * @summary Ersetzt die Berechtigungen einer Gruppe vollständig.
     * @request PUT:/Permissions/groups/{id}/permissions
     * @secure
     */
    permissionAdminSetGrants: (id: string, data: SetGrantsRequest, params: RequestParams = {}) =>
      this.request<any, ProblemDetails>({
        path: `/Permissions/groups/${id}/permissions`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags PermissionAdmin
     * @name PermissionAdminAddMember
     * @summary Fügt einen Benutzer einer Gruppe hinzu.
     * @request POST:/Permissions/groups/{id}/members
     * @secure
     */
    permissionAdminAddMember: (id: string, data: AddMemberRequest, params: RequestParams = {}) =>
      this.request<any, ProblemDetails>({
        path: `/Permissions/groups/${id}/members`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags PermissionAdmin
     * @name PermissionAdminRemoveMember
     * @summary Entfernt einen Benutzer aus einer Gruppe.
     * @request DELETE:/Permissions/groups/{id}/members/{userId}
     * @secure
     */
    permissionAdminRemoveMember: (id: string, userId: string, params: RequestParams = {}) =>
      this.request<void, ProblemDetails>({
        path: `/Permissions/groups/${id}/members/${userId}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags PermissionAdmin
     * @name PermissionAdminGetUserPermissions
     * @summary Liefert die effektiven Berechtigungen eines Benutzers (Diagnose/Anzeige).
     * @request GET:/Permissions/users/{userId}
     * @secure
     */
    permissionAdminGetUserPermissions: (userId: string, params: RequestParams = {}) =>
      this.request<EffectivePermissionsDto, any>({
        path: `/Permissions/users/${userId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  oidcClients = {
    /**
     * No description
     *
     * @tags OidcClients
     * @name OidcClientsList
     * @summary List all registered OIDC clients.
     * @request GET:/OidcClients
     * @secure
     */
    oidcClientsList: (params: RequestParams = {}) =>
      this.request<OidcClientDto[], any>({
        path: `/OidcClients`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
 * No description
 *
 * @tags OidcClients
 * @name OidcClientsCreate
 * @summary Create an OIDC client. The plaintext ClientSecret is
returned exactly once — store it securely; only a hash is kept.
For PKCE-only public clients (SPAs, native apps), pass
ClientType=public; the secret is then ignored.
 * @request POST:/OidcClients
 * @secure
 */
    oidcClientsCreate: (data: CreateOidcClientRequest, params: RequestParams = {}) =>
      this.request<OidcClientCreatedDto, any>({
        path: `/OidcClients`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
 * No description
 *
 * @tags OidcClients
 * @name OidcClientsDelete
 * @summary Delete an OIDC client. Existing access/refresh tokens issued for
it become invalid on next validation (OpenIddict checks the
application reference).
 * @request DELETE:/OidcClients/{clientId}
 * @secure
 */
    oidcClientsDelete: (clientId: string, params: RequestParams = {}) =>
      this.request<File, any>({
        path: `/OidcClients/${clientId}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),
  };
  productExample = {
    /**
     * No description
     *
     * @tags ProductExample
     * @name ProductExampleList
     * @summary Liste aller Produkt-Beispiele (ohne Snippet-Inhalte für kompakte Antwort).
     * @request GET:/ProductExample
     * @secure
     */
    productExampleList: (
      query?: {
        /** Optional: nur Beispiele eines bestimmten Status. */
        status?: ProductExampleStatus | null;
        /**
         * Optional: nur Beispiele für dieses Produkt (FileType).
         * @format guid
         */
        fileTypeId?: string | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<ProductExampleSummaryDto[], any>({
        path: `/ProductExample`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
 * No description
 *
 * @tags ProductExample
 * @name ProductExampleCreate
 * @summary Legt ein neues Produkt-Beispiel an. Re-Embedding läuft asynchron im
Hintergrund (typisch ~1 s bis es in der Suche auftaucht).
 * @request POST:/ProductExample
 * @secure
 */
    productExampleCreate: (data: CreateProductExampleModel, params: RequestParams = {}) =>
      this.request<GetProductExampleData, ProblemDetails>({
        path: `/ProductExample`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ProductExample
     * @name ProductExampleGet
     * @summary Einzelnes Produkt-Beispiel inkl. Snippet-Inhalte.
     * @request GET:/ProductExample/{id}
     * @secure
     */
    productExampleGet: (id: string, params: RequestParams = {}) =>
      this.request<GetProductExampleData, ProblemDetails>({
        path: `/ProductExample/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
 * No description
 *
 * @tags ProductExample
 * @name ProductExampleUpdate
 * @summary Aktualisiert ein bestehendes Produkt-Beispiel komplett (PUT-Semantik).
Wechsel des FileTypeId ist erlaubt und löst Re-Embedding aus.
 * @request PUT:/ProductExample/{id}
 * @secure
 */
    productExampleUpdate: (id: string, data: UpdateProductExampleModel, params: RequestParams = {}) =>
      this.request<GetProductExampleData, ProblemDetails>({
        path: `/ProductExample/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ProductExample
     * @name ProductExampleDelete
     * @summary Löscht ein Produkt-Beispiel endgültig (kein Soft-Delete).
     * @request DELETE:/ProductExample/{id}
     * @secure
     */
    productExampleDelete: (id: string, params: RequestParams = {}) =>
      this.request<void, ProblemDetails>({
        path: `/ProductExample/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
 * No description
 *
 * @tags ProductExample
 * @name ProductExampleGetSnippetContent
 * @summary Lädt den Inhalt eines einzelnen Snippets im passenden MIME-Type
herunter (XML → application/xml, JSON → application/json, YAML →
application/yaml, INI/PlainText → text/plain).
 * @request GET:/ProductExample/{id}/snippets/{snippetId}/content
 * @secure
 */
    productExampleGetSnippetContent: (id: string, snippetId: string, params: RequestParams = {}) =>
      this.request<void, ProblemDetails>({
        path: `/ProductExample/${id}/snippets/${snippetId}/content`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
 * No description
 *
 * @tags ProductExample
 * @name ProductExampleCreateDraft
 * @summary Legt einen leeren Draft-Artikel an — generischer Titel, Status
Draft, keine Description/Snippets/Features. Dient dem
„Neu"-Button im UI: liefert sofort eine Artikel-Id zurück, an die
Attachments hochgeladen werden können, bevor der Redakteur den
Inhalt editiert. Der finale Save läuft dann über PUT /{id}.
 * @request POST:/ProductExample/draft
 * @secure
 */
    productExampleCreateDraft: (
      query?: {
        /**
         * Produkt (FileType), zu dem der Draft gehört.
         * @format guid
         */
        fileTypeId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetProductExampleData, ProblemDetails>({
        path: `/ProductExample/draft`,
        method: "POST",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
 * No description
 *
 * @tags ProductExample
 * @name ProductExampleUploadAttachment
 * @summary Lädt eine Datei als Anhang hoch (PDF, Bild, ...). Bilder können
anschließend inline im Markdown referenziert werden über die
zurückgegebene Url.
 * @request POST:/ProductExample/{id}/attachments
 * @secure
 */
    productExampleUploadAttachment: (
      id: string,
      data: {
        /** @format binary */
        File?: File | null;
        /**
         * User Group Enum
         *
         */
        RequiredUserGroup?: EUserGroup;
      },
      params: RequestParams = {},
    ) =>
      this.request<ProductExampleAttachmentDto, ProblemDetails>({
        path: `/ProductExample/${id}/attachments`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
 * No description
 *
 * @tags ProductExample
 * @name ProductExampleDownloadAttachment
 * @summary Liefert den Datei-Inhalt eines Anhangs aus. Zugriff wird serverseitig
gegen RequiredUserGroup des Anhangs geprüft; ungenügende
Berechtigungen liefern 404 (keine Existenz-Preisgabe). Der Browser
rendert Bilder/PDFs inline (kein Content-Disposition), unbekannte
Binärtypen werden zum Download angeboten.
 * @request GET:/ProductExample/{id}/attachments/{attachmentId}
 * @secure
 */
    productExampleDownloadAttachment: (
      id: string,
      attachmentId: string,
      query?: {
        /**
         * Wenn true, wird Content-Disposition=attachment gesetzt.
         * @default false
         */
        download?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, ProblemDetails>({
        path: `/ProductExample/${id}/attachments/${attachmentId}`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ProductExample
     * @name ProductExampleDeleteAttachment
     * @summary Entfernt einen Anhang endgültig (Datei + DB-Eintrag).
     * @request DELETE:/ProductExample/{id}/attachments/{attachmentId}
     * @secure
     */
    productExampleDeleteAttachment: (id: string, attachmentId: string, params: RequestParams = {}) =>
      this.request<void, ProblemDetails>({
        path: `/ProductExample/${id}/attachments/${attachmentId}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
 * No description
 *
 * @tags ProductExample
 * @name ProductExampleIssueAttachmentAccessToken
 * @summary Stellt ein kurzlebiges Access-Token (10 min TTL) aus, mit dem der
Browser den Anhang über den anonymen Download-Endpoint laden kann
(GET /ProductExample/attachments/by-token/{token}). Gedacht für
<img src>/<a href>, wo der Authorization-Header
nicht mitgeschickt werden kann. Visibility-Check passiert hier einmalig
gegen den aktuellen User; der Download-Endpoint prüft dann nur noch das
Token. Bei fehlendem Zugriff oder unbekannter Attachment-Id → 404.
 * @request POST:/ProductExample/{id}/attachments/{attachmentId}/access-token
 * @secure
 */
    productExampleIssueAttachmentAccessToken: (id: string, attachmentId: string, params: RequestParams = {}) =>
      this.request<AttachmentAccessTokenResponse, ProblemDetails>({
        path: `/ProductExample/${id}/attachments/${attachmentId}/access-token`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
 * No description
 *
 * @tags ProductExample
 * @name ProductExampleDownloadAttachmentByToken
 * @summary Anonymer Download-Endpoint für Attachments. Erwartet ein gültiges,
zuvor per POST .../access-token ausgestelltes Token. Keine
User-Auth — das Token selbst ist das Capability (TTL 10 min). Inline
ausgeliefert (kein Content-Disposition), damit der Browser Bilder/PDFs
direkt rendern kann. Unbekanntes/abgelaufenes Token → 404.
 * @request GET:/ProductExample/attachments/by-token/{token}
 * @secure
 */
    productExampleDownloadAttachmentByToken: (
      token: string,
      query?: {
        /** @default false */
        download?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, ProblemDetails>({
        path: `/ProductExample/attachments/by-token/${token}`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),
  };
  products = {
    /**
     * No description
     *
     * @tags Products
     * @name ProductsGetProducts
     * @summary Get all products.
     * @request GET:/Products
     * @secure
     */
    productsGetProducts: (params: RequestParams = {}) =>
      this.request<GetProductsData[], any>({
        path: `/Products`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Products
     * @name ProductsGetProductByLink
     * @summary Get a specific product by its link.
     * @request GET:/Products/Link/{link}
     * @secure
     */
    productsGetProductByLink: (link: string, params: RequestParams = {}) =>
      this.request<GetProductsData, any>({
        path: `/Products/Link/${link}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Products
     * @name ProductsUploadFileToProduct
     * @summary Uploads a file to a specific product.
     * @request POST:/Products/UploadFile
     * @secure
     */
    productsUploadFileToProduct: (data: File, params: RequestParams = {}) =>
      this.request<FileDataResponse, any>({
        path: `/Products/UploadFile`,
        method: "POST",
        body: data,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Products
     * @name ProductsGetFilesByProductLink
     * @summary Gets all files for a specific product.
     * @request GET:/Products/Files/{productLink}
     * @secure
     */
    productsGetFilesByProductLink: (productLink: string, params: RequestParams = {}) =>
      this.request<FileDataResponse[], any>({
        path: `/Products/Files/${productLink}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  public = {
    /**
     * No description
     *
     * @tags PublicConfigurator
     * @name PublicConfiguratorOpen
     * @summary Öffnet einen Freigabe-Link mit dem zugeschickten Passwort und liefert ein Session-Token.
     * @request POST:/public/links/{token}/open
     * @secure
     */
    publicConfiguratorOpen: (token: string, data: OpenShareLinkRequest, params: RequestParams = {}) =>
      this.request<any, ProblemDetails>({
        path: `/public/links/${token}/open`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags PublicConfigurator
     * @name PublicConfiguratorGetState
     * @summary Liefert den aktuellen Konfigurator-Zustand des verlinkten Projekts.
     * @request GET:/public/config
     * @secure
     */
    publicConfiguratorGetState: (params: RequestParams = {}) =>
      this.request<any, ProblemDetails>({
        path: `/public/config`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags PublicConfigurator
     * @name PublicConfiguratorSave
     * @summary Speichert Konfiguration (nur im Modus Bearbeiten) und/oder Kundennotizen (immer).
     * @request PUT:/public/config
     * @secure
     */
    publicConfiguratorSave: (data: SavePublicConfigRequest, params: RequestParams = {}) =>
      this.request<any, ProblemDetails>({
        path: `/public/config`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags PublicConfigurator
     * @name PublicConfiguratorDownloadOffer
     * @summary Lädt ein freigegebenes Angebots-PDF des verlinkten Projekts herunter.
     * @request GET:/public/config/offers/{offerId}/download
     * @secure
     */
    publicConfiguratorDownloadOffer: (offerId: string, params: RequestParams = {}) =>
      this.request<any, ProblemDetails>({
        path: `/public/config/offers/${offerId}/download`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
 * No description
 *
 * @tags PublicConfigurator
 * @name PublicConfiguratorRespondToOffer
 * @summary Erfasst die Kundenantwort auf ein freigegebenes Angebot (mehrstufig: „in Ordnung, intern
weiterbearbeiten" oder „nicht zufrieden" mit Nachricht). Protokolliert + benachrichtigt das Office.
 * @request POST:/public/config/offers/{offerId}/respond
 * @secure
 */
    publicConfiguratorRespondToOffer: (offerId: string, data: RespondToOfferRequest, params: RequestParams = {}) =>
      this.request<any, ProblemDetails>({
        path: `/public/config/offers/${offerId}/respond`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),
  };
  search = {
    /**
 * No description
 *
 * @tags Search
 * @name SearchSearchDevices
 * @summary Sucht Devices semantisch nach freier Sprache. Trefferreihenfolge =
absteigender Score (1 = identisch, 0 = unverwandt). Gibt 503 zurück
wenn das Embedding-Backend (Ollama) nicht erreichbar ist.
 * @request POST:/Search/Semantic/Devices
 * @secure
 */
    searchSearchDevices: (data: SemanticSearchRequest, params: RequestParams = {}) =>
      this.request<DeviceSearchHit[], ProblemDetails | void>({
        path: `/Search/Semantic/Devices`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Search
     * @name SearchSearchContracts
     * @summary Sucht SupportContracts semantisch nach freier Sprache.
     * @request POST:/Search/Semantic/Contracts
     * @secure
     */
    searchSearchContracts: (data: SemanticSearchRequest, params: RequestParams = {}) =>
      this.request<ContractSearchHit[], ProblemDetails | void>({
        path: `/Search/Semantic/Contracts`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
 * No description
 *
 * @tags Search
 * @name SearchSearchProductExamples
 * @summary Sucht Produkt-Beispiel-Konfigurationen semantisch. Nur Approved-
Einträge werden zurückgegeben. Optional kann per fileTypeId
auf ein Produkt eingegrenzt werden. Service-intern (OFFICE+).
 * @request POST:/Search/Semantic/ProductExamples
 * @secure
 */
    searchSearchProductExamples: (data: ProductExampleSearchRequest, params: RequestParams = {}) =>
      this.request<ProductExampleSearchHit[], ProblemDetails | void>({
        path: `/Search/Semantic/ProductExamples`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
 * No description
 *
 * @tags Search
 * @name SearchSearchUnified
 * @summary Vereinte semantische Suche über Devices (Anlagen) und
ProductExamples (Service-Beispiele). Treffer kommen gemischt nach
Score sortiert zurück, jeder mit einem type-Diskriminator.
Optional kann per types auf einen Subset und per
fileTypeId auf ein Produkt eingegrenzt werden.
Service-intern (OFFICE+), weil ProductExamples sonst leaken würden.
 * @request POST:/Search/Semantic
 * @secure
 */
    searchSearchUnified: (data: UnifiedSearchRequest, params: RequestParams = {}) =>
      this.request<UnifiedSearchHit[], ProblemDetails | void>({
        path: `/Search/Semantic`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
 * No description
 *
 * @tags Search
 * @name SearchHealth
 * @summary Aktueller Zustand der Embedding-Pipeline: Ollama erreichbar,
Modell, Anzahl indizierter Dokumente. Für Monitoring + Debug.
 * @request GET:/Search/Health
 * @secure
 */
    searchHealth: (params: RequestParams = {}) =>
      this.request<EmbeddingHealthDto, any>({
        path: `/Search/Health`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
 * No description
 *
 * @tags Search
 * @name SearchReindex
 * @summary Stößt ein vollständiges Re-Indexing an (alle Devices mit
Beschreibung + alle Verträge). Läuft asynchron im Hintergrund.
Antwort enthält die Anzahl in die Queue gestellter Jobs.
Notfall-Werkzeug — normaler Betrieb braucht das nicht.
 * @request POST:/Search/Reindex
 * @secure
 */
    searchReindex: (params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/Search/Reindex`,
        method: "POST",
        secure: true,
        ...params,
      }),
  };
  service = {
    /**
     * No description
     *
     * @tags Service
     * @name ServiceGeneratePassword
     * @summary This method is used to generate a password.
     * @request POST:/Service/password/generate
     * @secure
     */
    serviceGeneratePassword: (data: ResolveServiceData, params: RequestParams = {}) =>
      this.request<GetServiceData, any>({
        path: `/Service/password/generate`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Service
     * @name ServiceGetLicenseVersions
     * @request GET:/Service/licenses/versions
     * @secure
     */
    serviceGetLicenseVersions: (params: RequestParams = {}) =>
      this.request<FileTypeLicenseDto[], any>({
        path: `/Service/licenses/versions`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description This method requires the user to be in the DEVELOPMENT user group.
     *
     * @tags Service
     * @name ServiceGenerateLicenceKey
     * @summary Generates a license key for the specified host and mode.
     * @request GET:/Service/licenses/generate-key
     * @secure
     */
    serviceGenerateLicenceKey: (
      query?: {
        /** The identifier of the host for which the license key is to be generated. */
        hostId?: string;
        /**
         * The product identifier (FileType ID).
         * @format guid
         */
        product?: string;
        /** Optional variant of the product. */
        variant?: string | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/Service/licenses/generate-key`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Service
     * @name ServiceGenerateAndStoreLicense
     * @request POST:/Service/licenses/{requestId}/generate
     * @secure
     */
    serviceGenerateAndStoreLicense: (requestId: string, params: RequestParams = {}) =>
      this.request<LicenseResponseDto, any>({
        path: `/Service/licenses/${requestId}/generate`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Service
     * @name ServiceRequestLicense
     * @request POST:/Service/licenses/request
     * @secure
     */
    serviceRequestLicense: (data: RequestsLicenseDto, params: RequestParams = {}) =>
      this.request<LicenseResponseDto, any>({
        path: `/Service/licenses/request`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Service
     * @name ServiceGetAllRequestedLicenses
     * @request GET:/Service/licenses/requested
     * @secure
     */
    serviceGetAllRequestedLicenses: (params: RequestParams = {}) =>
      this.request<LicenseResponseDto[], any>({
        path: `/Service/licenses/requested`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Service
     * @name ServiceGetLicensesBySupportId
     * @request GET:/Service/licenses/support/{supportId}
     * @secure
     */
    serviceGetLicensesBySupportId: (supportId: string, params: RequestParams = {}) =>
      this.request<LicenseResponseDto[], any>({
        path: `/Service/licenses/support/${supportId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Service
     * @name ServiceOrderLicenses
     * @summary Orders licenses in the shopping cart based on a list of IDs.
     * @request POST:/Service/licenses/order
     * @secure
     */
    serviceOrderLicenses: (data: string[], params: RequestParams = {}) =>
      this.request<File, any>({
        path: `/Service/licenses/order`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Service
     * @name ServiceOrderLicense
     * @summary Orders licenses in the shopping cart based on a list of IDs.
     * @request POST:/Service/licenses/{licenseId}/order
     * @secure
     */
    serviceOrderLicense: (licenseId: string, params: RequestParams = {}) =>
      this.request<File, any>({
        path: `/Service/licenses/${licenseId}/order`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Service
     * @name ServiceRevokeLicense
     * @summary Revokes the specified license.
     * @request POST:/Service/licenses/{licenseId}/revoke
     * @secure
     */
    serviceRevokeLicense: (licenseId: string, params: RequestParams = {}) =>
      this.request<LicenseResponseDto, any>({
        path: `/Service/licenses/${licenseId}/revoke`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Service
     * @name ServiceRejectLicense
     * @summary Rejects the specified license.
     * @request POST:/Service/licenses/{licenseId}/reject
     * @secure
     */
    serviceRejectLicense: (licenseId: string, params: RequestParams = {}) =>
      this.request<LicenseResponseDto, any>({
        path: `/Service/licenses/${licenseId}/reject`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Service
     * @name ServiceDeleteLicense
     * @summary Deletes the specified license.
     * @request DELETE:/Service/licenses/{licenseId}
     * @secure
     */
    serviceDeleteLicense: (licenseId: string, params: RequestParams = {}) =>
      this.request<LicenseResponseDto, any>({
        path: `/Service/licenses/${licenseId}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
 * No description
 *
 * @tags Service
 * @name ServiceUpdateLicense
 * @summary Updates (remaps) an existing license request to a different product/variant.
Only allowed for licenses that haven't been generated yet (InCart or Ordered status).
 * @request PUT:/Service/licenses/{licenseId}
 * @secure
 */
    serviceUpdateLicense: (licenseId: string, data: UpdateLicenseDto, params: RequestParams = {}) =>
      this.request<LicenseResponseDto, any>({
        path: `/Service/licenses/${licenseId}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
 * No description
 *
 * @tags Service
 * @name ServiceRevokeAndRemapLicense
 * @summary Revokes an already generated license and creates a new license with corrected product/variant.
This is used when a customer made a mistake and needs to change an already issued license.
The old license will be revoked, and a new license will be created and immediately generated
with the same parameters (HostId, SupportCodeId, Description, UserId) but with the new FileTypeId and Tag.
 * @request PUT:/Service/licenses/{licenseId}/revoke-and-remap
 * @secure
 */
    serviceRevokeAndRemapLicense: (licenseId: string, data: UpdateLicenseDto, params: RequestParams = {}) =>
      this.request<LicenseResponseDto, any>({
        path: `/Service/licenses/${licenseId}/revoke-and-remap`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  settings = {
    /**
     * @description Antwortet auch dann mit HTTP 200, wenn einzelne Prüfungen fehlschlagen — der Fehler steht dann im jeweiligen detail. Das Ergebnis wird 30 Sekunden zwischengespeichert.
     *
     * @tags Settings
     * @name SettingsGetStatus
     * @summary Zustand aller zur Laufzeit konfigurierbaren Bereiche für die Übersicht der Verwaltung.
     * @request GET:/Settings/Status
     * @secure
     */
    settingsGetStatus: (
      query?: {
        /**
         * Zwischenspeicher übergehen und neu prüfen.
         * @default false
         */
        refresh?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<SettingsStatusDto, any>({
        path: `/Settings/Status`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  speech = {
    /**
     * No description
     *
     * @tags Speech
     * @name SpeechTranscribe
     * @summary Transkribiert eine hochgeladene Aufnahme.
     * @request POST:/Speech/Transcribe
     * @secure
     */
    speechTranscribe: (
      data: {
        /** @format binary */
        file?: File | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<TranscriptionResult, any>({
        path: `/Speech/Transcribe`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),
  };
  supportCode = {
    /**
     * @description This method retrieves support codes accessible to the authenticated user. Customers can only see their own support codes, while admins can see all.
     *
     * @tags SupportCode
     * @name SupportCodeListSupportCodes
     * @summary Lists the support codes.
     * @request GET:/SupportCode
     * @secure
     */
    supportCodeListSupportCodes: (params: RequestParams = {}) =>
      this.request<GetSupportCodeData[], any>({
        path: `/SupportCode`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description This function accepts a data model via HTTP POST method to introduce a new support code into the system. It is vital that the data model contains all necessary details for the creation of a support code. If the provided contract is not found in the system, it will return an EntityNotFound result.
     *
     * @tags SupportCode
     * @name SupportCodeAddSupportCode
     * @summary Creates and adds a new support code into the system.
     * @request POST:/SupportCode
     * @secure
     */
    supportCodeAddSupportCode: (data: AddSupportCodeData, params: RequestParams = {}) =>
      this.request<GetSupportCodeData, NotFoundResponse>({
        path: `/SupportCode`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description This method is used to quickly get support based on the provided data. It's an asynchronous operation and allows anonymous access.
     *
     * @tags SupportCode
     * @name SupportCodeQuickSupport
     * @summary This is the QuickSupport action method in the Controller
     * @request GET:/SupportCode/quicksupport
     * @secure
     */
    supportCodeQuickSupport: (
      query?: {
        /**
         * The data based on which support is provided. This could be an issue description or relevant
         * code/conditions to troubleshoot.
         *
         */
        data?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetQuickSupportData, NotFoundResponse>({
        path: `/SupportCode/quicksupport`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SupportCode
     * @name SupportCodeGetSupportCode
     * @summary An HTTP GET endpoint that retrieves support code data associated with the provided `id`.
     * @request GET:/SupportCode/{id}
     * @secure
     */
    supportCodeGetSupportCode: (id: string, params: RequestParams = {}) =>
      this.request<GetSupportCodeData, NotFoundResponse>({
        path: `/SupportCode/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Use this method to delete the specific support code from the system. This operation will only be successful if the logged-in user is a super admin. Once the support code is deleted, the operation cannot be undone.
     *
     * @tags SupportCode
     * @name SupportCodeDeleteSupportCode
     * @summary Deletes the specified support code.
     * @request DELETE:/SupportCode/{id}
     * @secure
     */
    supportCodeDeleteSupportCode: (id: string, params: RequestParams = {}) =>
      this.request<boolean, BadRequestResponse | NotFoundResponse>({
        path: `/SupportCode/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Sample request: POST /QuickSupport/Create { "Parameter1": "value", "Parameter2": "value" }
     *
     * @tags SupportCode
     * @name SupportCodeCreateQuickSupport
     * @summary Initiates a request for Quick Support
     * @request POST:/SupportCode/QuickSupport/Create
     * @secure
     */
    supportCodeCreateQuickSupport: (
      data: {
        Title?: string;
        Name?: string;
        EMail?: string;
        Phone?: string | null;
        /** @format int32 */
        RequestType?: number;
        SystemId?: string | null;
        CurrentVersion?: string;
        HostId?: string | null;
        SystemName?: string | null;
        SupportContractId?: string | null;
        ReCaptchaToken?: string | null;
        SelectedDSGVO?: boolean;
        SelectedPaySelf?: boolean | null;
        SelectedPayOwner?: boolean | null;
        SelectedIsGuarantee?: boolean | null;
        Text?: string;
        /** @format binary */
        File?: File | null;
        /** @format binary */
        CoreDump?: File | null;
        TestMessage?: boolean | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<string, BadRequestResponse>({
        path: `/SupportCode/QuickSupport/Create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SupportCode
     * @name SupportCodeGetValuesForField
     * @request GET:/SupportCode/QuickSupport/Field/{fieldId}
     * @secure
     */
    supportCodeGetValuesForField: (fieldId: string, params: RequestParams = {}) =>
      this.request<string, BadRequestResponse>({
        path: `/SupportCode/QuickSupport/Field/${fieldId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  supportContract = {
    /**
     * No description
     *
     * @tags SupportContract
     * @name SupportContractListSupportContracts
     * @summary An HTTP GET endpoint that retrieves a list of support contracts.
     * @request GET:/SupportContract
     * @secure
     */
    supportContractListSupportContracts: (
      query?: {
        /** Optional: Filter by Support Code ID (partial match) */
        supportCodeId?: string | null;
        /** Optional: Filter by Customer ID (partial match) */
        customerId?: string | null;
        /** Optional: Filter by Customer Name (partial match) */
        customerName?: string | null;
        /** Optional: General search across all fields (Support Code ID, Customer ID, Customer Name) */
        searchTerm?: string | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetSupportContractData[], any>({
        path: `/SupportContract`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description This method is decorated with the HttpPost attribute, indicating that it is intended to handle HTTP POST requests. Any data necessary for the creation of the support contract needs to be included in the request body (as the parameter of type AddSupportContractData).
     *
     * @tags SupportContract
     * @name SupportContractAddSupportContract
     * @summary This method is intended to add a new support contract using the provided data.
     * @request POST:/SupportContract
     * @secure
     */
    supportContractAddSupportContract: (data: AddSupportContractData, params: RequestParams = {}) =>
      this.request<GetSupportContractData, any>({
        path: `/SupportContract`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SupportContract
     * @name SupportContractGetSummary
     * @summary Retrieves a summary of support contracts grouped by status.
     * @request GET:/SupportContract/summary
     * @secure
     */
    supportContractGetSummary: (
      query?: {
        /**
         * Window in days for expiring contracts.
         * @format int32
         * @default 30
         */
        expiringSoonDays?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<SupportContractSummaryDto, any>({
        path: `/SupportContract/summary`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SupportContract
     * @name SupportContractCreateNewContact
     * @summary Create new contact in external system. Contacts need to belong to support contracts
     * @request POST:/SupportContract/contact
     * @secure
     */
    supportContractCreateNewContact: (data: CreateContactData, params: RequestParams = {}) =>
      this.request<number, any>({
        path: `/SupportContract/contact`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SupportContract
     * @name SupportContractRemewContract
     * @summary Create new contact in external system. Contacts need to belong to support contracts
     * @request POST:/SupportContract/contact/renew
     * @secure
     */
    supportContractRemewContract: (
      query?: {
        contract?: string;
        /** @format int32 */
        duration?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<number, any>({
        path: `/SupportContract/contact/renew`,
        method: "POST",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description This API will return the entire support contract data, including all its related details.
     *
     * @tags SupportContract
     * @name SupportContractGetSupportContract
     * @summary Asynchronously gets the support contract data for a specific id.
     * @request GET:/SupportContract/{id}
     * @secure
     */
    supportContractGetSupportContract: (id: string, params: RequestParams = {}) =>
      this.request<GetSupportContractData, any>({
        path: `/SupportContract/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description This API has a DELETE method signature and will respond with a boolean indicating the outcome of the deletion operation.
     *
     * @tags SupportContract
     * @name SupportContractDeleteSupportContract
     * @summary Deletes a support contract.
     * @request DELETE:/SupportContract/{id}
     * @secure
     */
    supportContractDeleteSupportContract: (id: string, params: RequestParams = {}) =>
      this.request<boolean, any>({
        path: `/SupportContract/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description This method will update the support contract information in the database, including setting a new expiration date. If the contract does not exist, it will return a NotFoundResult.
     *
     * @tags SupportContract
     * @name SupportContractRenewSupportContract
     * @summary Renews a support contract.
     * @request POST:/SupportContract/{id}/Renew
     * @secure
     */
    supportContractRenewSupportContract: (
      id: string,
      query?: {
        /**
         * A DateOnly instance representing the new expiration date of the contract.
         * This value is required.
         *
         * @format date
         */
        expire?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetSupportContractData, any>({
        path: `/SupportContract/${id}/Renew`,
        method: "POST",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description The users returned are only those associated with the specific support contract identified by the given ID. If no such contract exists, or if it has no associated users, the method will return an empty list.
     *
     * @tags SupportContract
     * @name SupportContractGetSupportContractUsers
     * @summary Fetches a list of users associated with a given support contract.
     * @request GET:/SupportContract/{id}/Users
     * @secure
     */
    supportContractGetSupportContractUsers: (id: string, params: RequestParams = {}) =>
      this.request<GetUserData[], any>({
        path: `/SupportContract/${id}/Users`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description This controller action handles the addition of a user to a specified support contract by their respective identifiers.
     *
     * @tags SupportContract
     * @name SupportContractAddUserToSupportContract
     * @summary Adds a user to the support contract by the provided IDs.
     * @request POST:/SupportContract/{id}/Users/{userid}
     * @secure
     */
    supportContractAddUserToSupportContract: (id: string, userid: string, params: RequestParams = {}) =>
      this.request<GetUserData[], any>({
        path: `/SupportContract/${id}/Users/${userid}`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description This method removes a specific user from a specified support contract.
     *
     * @tags SupportContract
     * @name SupportContractRemoveUserToSupportContract
     * @summary Removes a user from a support contract.
     * @request DELETE:/SupportContract/{id}/Users/{userid}
     * @secure
     */
    supportContractRemoveUserToSupportContract: (id: string, userid: string, params: RequestParams = {}) =>
      this.request<GetUserData[], any>({
        path: `/SupportContract/${id}/Users/${userid}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description This method executes asynchronously and is accessible via an HTTP GET request.
     *
     * @tags SupportContract
     * @name SupportContractGetSupportCodes
     * @summary Fetches a list of GetSupportCodeData instances associated with a specified ID.
     * @request GET:/SupportContract/{id}/SupportCodes
     * @secure
     */
    supportContractGetSupportCodes: (id: string, params: RequestParams = {}) =>
      this.request<GetSupportCodeData[], any>({
        path: `/SupportContract/${id}/SupportCodes`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description This function can be accessed using the HttpGET method and the Sync route. The function calls the ReadFromExternal method on the _supportContractService object. This ReadFromExternal method is responsible for reading data from an external source. The function is asynchronous, meaning it runs in the background and does not block the main application thread.
     *
     * @tags SupportContract
     * @name SupportContractSync
     * @summary This function performs synchronization with the external source.
     * @request GET:/SupportContract/Sync
     * @secure
     */
    supportContractSync: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/SupportContract/Sync`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags SupportContract
     * @name SupportContractGetAllContractServiceUnits
     * @summary Liefert die Service-Einheiten-Snapshots aller Support-Verträge (für Listenansicht).
     * @request GET:/SupportContract/service-units
     * @secure
     */
    supportContractGetAllContractServiceUnits: (
      query?: {
        /**
         * Wenn true, nur Verträge deren Snapshot veraltet ist
         * @default false
         */
        staleOnly?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<SupportContractServiceUnitsResponse[], any>({
        path: `/SupportContract/service-units`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SupportContract
     * @name SupportContractGetContractServiceUnits
     * @summary Liefert die Service-Einheiten-Info eines Support-Vertrags (nur persistierter Snapshot).
     * @request GET:/SupportContract/{id}/service-units
     * @secure
     */
    supportContractGetContractServiceUnits: (id: string, params: RequestParams = {}) =>
      this.request<SupportContractServiceUnitsResponse, ProblemDetails>({
        path: `/SupportContract/${id}/service-units`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
 * No description
 *
 * @tags SupportContract
 * @name SupportContractRecalculateContractServiceUnits
 * @summary Berechnet die Service-Einheiten eines Support-Vertrags neu und liefert eine Preview
mit Token. Die Werte werden erst durch den Confirm-Endpoint persistiert (Token 10 Min gültig).
 * @request POST:/SupportContract/{id}/service-units/recalculate
 * @secure
 */
    supportContractRecalculateContractServiceUnits: (id: string, params: RequestParams = {}) =>
      this.request<ContractReconciliationPreview, ProblemDetails>({
        path: `/SupportContract/${id}/service-units/recalculate`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SupportContract
     * @name SupportContractConfirmContractServiceUnits
     * @summary Bestätigt eine Service-Unit-Preview mit Token und persistiert Lizenz-Snapshots + Vertrags-Total.
     * @request POST:/SupportContract/{id}/service-units/confirm
     * @secure
     */
    supportContractConfirmContractServiceUnits: (
      id: string,
      data: ConfirmReconciliationRequest,
      params: RequestParams = {},
    ) =>
      this.request<ContractReconciliationResult, ProblemDetails>({
        path: `/SupportContract/${id}/service-units/confirm`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  teamCity = {
    /**
     * No description
     *
     * @tags TeamCity
     * @name TeamCityTeamCityBuilds
     * @request GET:/TeamCity
     * @secure
     */
    teamCityTeamCityBuilds: (params: RequestParams = {}) =>
      this.request<GetBuildsDto[], any>({
        path: `/TeamCity`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags TeamCity
     * @name TeamCityTeamCityArtifacts
     * @request GET:/TeamCity/{id}
     * @secure
     */
    teamCityTeamCityArtifacts: (id: string, params: RequestParams = {}) =>
      this.request<File, any>({
        path: `/TeamCity/${id}`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags TeamCity
     * @name TeamCityDownloadFile
     * @request POST:/TeamCity/download
     * @secure
     */
    teamCityDownloadFile: (data: FileDownloadDto, params: RequestParams = {}) =>
      this.request<File, any>({
        path: `/TeamCity/download`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),
  };
  templateGenerator = {
    /**
     * No description
     *
     * @tags TemplateGenerator
     * @name TemplateGeneratorSuggest
     * @summary Schlägt eine Vorlage vor. Speichert nichts — das Ergebnis geht ins Formular.
     * @request POST:/TemplateGenerator/suggest
     * @secure
     */
    templateGeneratorSuggest: (data: TemplateSuggestionRequest, params: RequestParams = {}) =>
      this.request<TemplateSuggestion, any>({
        path: `/TemplateGenerator/suggest`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  terms = {
    /**
     * No description
     *
     * @tags Terms
     * @name TermsGetLatestTerms
     * @summary Description for the GetLatestTerms action method
     * @request GET:/Terms/latest
     * @secure
     */
    termsGetLatestTerms: (params: RequestParams = {}) =>
      this.request<GetTermsData, any>({
        path: `/Terms/latest`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description This action takes an AddTermsData object and replaces the existing terms with the new values provided. The new terms data is returned after the operation is completed.
     *
     * @tags Terms
     * @name TermsReplaceTerms
     * @summary Retrieves terms data by replacing existing terms with new ones.
     * @request POST:/Terms
     * @secure
     */
    termsReplaceTerms: (data: AddTermsData, params: RequestParams = {}) =>
      this.request<GetTermsData, any>({
        path: `/Terms`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  user = {
    /**
     * No description
     *
     * @tags User
     * @name UserSignUp
     * @summary An HTTP POST endpoint that registers a new user.
     * @request POST:/User/SignUp
     * @secure
     */
    userSignUp: (data: RegisterUserData, params: RequestParams = {}) =>
      this.request<boolean, any>({
        path: `/User/SignUp`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
 * No description
 *
 * @tags User
 * @name UserAcknowledgeRegistration
 * @summary Acknowledge-Endpoint für offene Registrierungs-Follow-Ups. Aufrufer
muss als OFFICE+ eingeloggt sein — der Klick wird dem aktuellen User
zugeschrieben (AcknowledgedByUserId) und stoppt die 3-Tage-
Reminder-Schleife. Wird vom SPA aufgerufen, nachdem der Vertrieb
den Link aus der Mail (= SPA-Route mit Token) geöffnet hat.
 * @request POST:/User/Registration/FollowUps/{token}/Acknowledge
 * @secure
 */
    userAcknowledgeRegistration: (token: string, params: RequestParams = {}) =>
      this.request<any, ProblemDetails>({
        path: `/User/Registration/FollowUps/${token}/Acknowledge`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
 * No description
 *
 * @tags User
 * @name UserListRegistrationFollowUps
 * @summary Liefert die Liste aller Registrierungs-Follow-Ups für die interne
Vertriebs-Übersicht. Per Default werden nur offene Einträge geliefert,
mit includeAcknowledged=true auch bereits bearbeitete.
 * @request GET:/User/Registration/FollowUps
 * @secure
 */
    userListRegistrationFollowUps: (
      query?: {
        /**
         * Wenn true, werden auch acknowledged Follow-Ups mit zurückgegeben.
         * @default false
         */
        includeAcknowledged?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<RegistrationFollowUpDto[], any>({
        path: `/User/Registration/FollowUps`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name UserAlive
     * @request GET:/User/Alive
     * @secure
     */
    userAlive: (params: RequestParams = {}) =>
      this.request<boolean, any>({
        path: `/User/Alive`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name UserSignIn
     * @summary An HTTP POST endpoint that allows a new user to sign up for the application.
     * @request POST:/User/SignIn
     * @secure
     */
    userSignIn: (
      query?: {
        /** The username of the user who wants to sign up. */
        username?: string;
        /** The password of the user who wants to sign up. */
        password?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<SignInUserData, any>({
        path: `/User/SignIn`,
        method: "POST",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
 * No description
 *
 * @tags User
 * @name UserSignInTotp
 * @summary Step 2 of the SignIn flow when the user has TOTP enrolled. Posts
the intermediate mfaToken from /SignIn together with the
6-digit code or a recovery code; on success a full JWT is issued.
 * @request POST:/User/SignIn/Totp
 * @secure
 */
    userSignInTotp: (data: SignInTotpRequest, params: RequestParams = {}) =>
      this.request<SignInUserData, any>({
        path: `/User/SignIn/Totp`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
 * No description
 *
 * @tags User
 * @name UserSignInPasskeyBegin
 * @summary Passwordless login — step 1. Returns AssertionOptions plus a
server-side session id; client feeds the options into
navigator.credentials.get().
 * @request POST:/User/SignIn/Passkey/Begin
 * @secure
 */
    userSignInPasskeyBegin: (data: SignInPasskeyBeginRequest, params: RequestParams = {}) =>
      this.request<WebAuthnOptionsDto, any>({
        path: `/User/SignIn/Passkey/Begin`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
 * No description
 *
 * @tags User
 * @name UserSignInPasskeyComplete
 * @summary Passwordless login — step 2. Verifies the assertion against the
stored credential and issues a full JWT for the matching user.
 * @request POST:/User/SignIn/Passkey/Complete
 * @secure
 */
    userSignInPasskeyComplete: (data: SignInPasskeyCompleteRequest, params: RequestParams = {}) =>
      this.request<SignInUserData, any>({
        path: `/User/SignIn/Passkey/Complete`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
 * @description Antwortet immer mit HTTP 200. Die Oberfläche entscheidet damit, ob sie die Umstellung anbietet, ohne dafür erst in einen Fehler zu laufen.
 *
 * @tags User
 * @name UserGetAdConversionStatus
 * @summary Ob das eigene Konto auf AD-Anmeldung umgestellt werden kann — und wenn nicht, warum.
 * @request GET:/User/Me/AdConversion
 * @secure
 */
    userGetMySetting: (key: string, params: RequestParams = {}) =>
      this.request<UserSettingDto, ProblemDetails>({
        path: `/User/Me/Settings/${key}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Ein leerer Wert löscht die Einstellung und stellt damit die Vorgabe wieder her.
     *
     * @tags User
     * @name UserSetMySetting
     * @summary Schreibt eine persönliche Einstellung des angemeldeten Benutzers.
     * @request PUT:/User/Me/Settings/{key}
     * @secure
     */
    userSetMySetting: (key: string, data: UpdateUserSettingRequest, params: RequestParams = {}) =>
      this.request<UserSettingDto, ProblemDetails>({
        path: `/User/Me/Settings/${key}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Der Benutzer ist nie Teil der Anfrage. Erlaubt sind nur bekannte Schlüssel.
     *
     * @tags User
     * @name UserGetAdConversionStatus
     * @request GET:/User/Me/AdConversion
     * @secure
     */
    userGetAdConversionStatus: (params: RequestParams = {}) =>
      this.request<AdConversionStatusDto, any>({
        path: `/User/Me/AdConversion`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
 * @description Besitznachweis ist das AD-Passwort (LDAP-Bind, wird nie gespeichert). Die Rolle verschlechtert sich dabei nie: ergeben die AD-Gruppen eine niedrigere Rolle als die aktuelle, wird mit HTTP 400 und Klartext abgelehnt. Nach der Umstellung gilt nur noch das AD-Passwort; TOTP und Passkeys bleiben unverändert.
 *
 * @tags User
 * @name UserConvertToAd
 * @summary Stellt das eigene Konto auf AD-Anmeldung um.
 * @request POST:/User/Me/AdConversion
 * @secure
 */
    userConvertToAd: (data: ConvertToAdRequest, params: RequestParams = {}) =>
      this.request<AdConversionResultDto, ProblemDetails>({
        path: `/User/Me/AdConversion`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
 * No description
 *
 * @tags User
 * @name UserGetMfaStatus
 * @summary Snapshot of the caller's MFA state — for the management UI to
decide which buttons to show.
 * @request GET:/User/Me/Mfa/Status
 * @secure
 */
    userGetMfaStatus: (params: RequestParams = {}) =>
      this.request<MfaStatusDto, any>({
        path: `/User/Me/Mfa/Status`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
 * No description
 *
 * @tags User
 * @name UserStartTotpSetup
 * @summary Step 1 of TOTP enrollment — generates a fresh secret + otpauth URI.
Nothing is persisted yet; the secret must be confirmed via
/Mfa/Totp/Enable with a valid 6-digit code.
 * @request POST:/User/Me/Mfa/Totp/Setup
 * @secure
 */
    userStartTotpSetup: (params: RequestParams = {}) =>
      this.request<TotpSetupDto, any>({
        path: `/User/Me/Mfa/Totp/Setup`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
 * No description
 *
 * @tags User
 * @name UserEnableTotp
 * @summary Step 2 of TOTP enrollment — verifies the user-supplied code
against the freshly-generated secret. On success the secret is
persisted (encrypted) and a fresh set of recovery codes is
returned (exactly once).
 * @request POST:/User/Me/Mfa/Totp/Enable
 * @secure
 */
    userEnableTotp: (data: EnableTotpRequest, params: RequestParams = {}) =>
      this.request<EnableTotpResultDto, any>({
        path: `/User/Me/Mfa/Totp/Enable`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
 * No description
 *
 * @tags User
 * @name UserDisableTotp
 * @summary Disable TOTP. Requires either the current 6-digit code or a valid
recovery code as proof — never just session JWT, so a stolen
session can't silently strip the second factor.
 * @request POST:/User/Me/Mfa/Totp/Disable
 * @secure
 */
    userDisableTotp: (data: DisableTotpRequest, params: RequestParams = {}) =>
      this.request<File, any>({
        path: `/User/Me/Mfa/Totp/Disable`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name UserRegenerateRecoveryCodes
     * @summary Replace any unused recovery codes with a fresh batch (returned once).
     * @request POST:/User/Me/Mfa/Totp/RecoveryCodes/Regenerate
     * @secure
     */
    userRegenerateRecoveryCodes: (params: RequestParams = {}) =>
      this.request<EnableTotpResultDto, any>({
        path: `/User/Me/Mfa/Totp/RecoveryCodes/Regenerate`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
 * No description
 *
 * @tags User
 * @name UserBeginPasskeyRegistration
 * @summary Step 1 of passkey registration — returns CredentialCreateOptions
plus a server-side session id. Client feeds the options into
navigator.credentials.create().
 * @request POST:/User/Me/Mfa/Passkey/Register/Begin
 * @secure
 */
    userBeginPasskeyRegistration: (params: RequestParams = {}) =>
      this.request<WebAuthnOptionsDto, any>({
        path: `/User/Me/Mfa/Passkey/Register/Begin`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
 * No description
 *
 * @tags User
 * @name UserCompletePasskeyRegistration
 * @summary Step 2 of passkey registration — verifies the attestation and
persists the credential.
 * @request POST:/User/Me/Mfa/Passkey/Register/Complete
 * @secure
 */
    userCompletePasskeyRegistration: (data: RegisterPasskeyCompleteRequest, params: RequestParams = {}) =>
      this.request<PasskeyDto, any>({
        path: `/User/Me/Mfa/Passkey/Register/Complete`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name UserDeletePasskey
     * @summary Remove a registered passkey by surrogate id.
     * @request DELETE:/User/Me/Mfa/Passkey/{id}
     * @secure
     */
    userDeletePasskey: (id: string, params: RequestParams = {}) =>
      this.request<File, any>({
        path: `/User/Me/Mfa/Passkey/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * @description This method handles HTTP POST requests at the endpoint: `/Lock/{id}`. It requires the request to be authorized under the User Group named 'OFFICE'.
     *
     * @tags User
     * @name UserLockUser
     * @summary Locks a user by their unique identifier.
     * @request POST:/User/Lock/{id}
     * @secure
     */
    userLockUser: (id: string, params: RequestParams = {}) =>
      this.request<boolean, any>({
        path: `/User/Lock/${id}`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description This controller action will return a boolean value determining if the user has accepted the terms.
     *
     * @tags User
     * @name UserAcceptedTerms
     * @summary Checks if current user accepted terms.
     * @request GET:/User/Me/Terms
     * @secure
     */
    userAcceptedTerms: (params: RequestParams = {}) =>
      this.request<boolean, any>({
        path: `/User/Me/Terms`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description This endpoint can be accessed by anyone without the need for authentication. It takes a username as a parameter in HTTP body.
     *
     * @tags User
     * @name UserPasswordForgotten
     * @summary Endpoint to trigger the forgotten password functionality.
     * @request POST:/User/PasswordForgotten
     * @secure
     */
    userPasswordForgotten: (data: string, params: RequestParams = {}) =>
      this.request<boolean, any>({
        path: `/User/PasswordForgotten`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description This method is a POST endpoint that allows users to accept the terms. It uses the _userService object and its AcceptTerms method.
     *
     * @tags User
     * @name UserAcceptTerms
     * @summary Accepts the terms.
     * @request POST:/User/Me/Terms/Accept
     * @secure
     */
    userAcceptTerms: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/User/Me/Terms/Accept`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * @description This method accepts a POST request and requires authorization from the specified user group. Execute this operation with caution as it directly affects the system users. If the operation encounters a BadRequestException, the bad request response will return with a related message. Any other exceptions will also be handled and result in a bad request response.
     *
     * @tags User
     * @name UserAddUser
     * @summary Adds a new user to the system.
     * @request POST:/User
     * @secure
     */
    userAddUser: (data: AddUserData, params: RequestParams = {}) =>
      this.request<GetUserData, any>({
        path: `/User`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description This function requires authorization with User Group Names of type OFFICE It returns an ActionResult containing a list of GetUserData objects It makes use of the UserService to fetch the list of users This method is asynchronous and should be awaited for the task to complete
     *
     * @tags User
     * @name UserListUsers
     * @summary This method is used to list all users
     * @request GET:/User
     * @secure
     */
    userListUsers: (params: RequestParams = {}) =>
      this.request<GetUserData[], any>({
        path: `/User`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name UserResendFirstLogin
     * @summary Resends first login mail with new password if not already logged in
     * @request POST:/User/{id}/ResendFirstLogin
     * @secure
     */
    userResendFirstLogin: (id: string, params: RequestParams = {}) =>
      this.request<boolean, any>({
        path: `/User/${id}/ResendFirstLogin`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name UserResendPasswordReset
     * @summary Admin function: Resend password reset email with new temporary password.
     * @request POST:/User/{id}/ResendPasswordReset
     * @secure
     */
    userResendPasswordReset: (id: string, params: RequestParams = {}) =>
      this.request<boolean, string>({
        path: `/User/${id}/ResendPasswordReset`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description This method is protected by the authorization policy "UserGroupNames.OFFICE".
     *
     * @tags User
     * @name UserEditUser
     * @summary Edits a user by Id.
     * @request PUT:/User/{id}
     * @secure
     */
    userEditUser: (id: string, data: EditUserData, params: RequestParams = {}) =>
      this.request<GetUserData, any>({
        path: `/User/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description This method takes user's id as parameter and passes it to the user service to delete the user. Only the users in the OFFICE UserGroup have the authorization to delete a user. It returns a boolean value, true indicating deletion was successful and false indicating otherwise.
     *
     * @tags User
     * @name UserDeleteUser
     * @summary Deletes a user from the system.
     * @request DELETE:/User/{id}
     * @secure
     */
    userDeleteUser: (id: string, params: RequestParams = {}) =>
      this.request<boolean, any>({
        path: `/User/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description The HTTP Get method is used to get the user data. Only authorized users can invoke this method. The method is bound to the route 'api/controller/{id}' where 'id' is a placeholder for the user's ID. Any further specific behavior, performance considerations or limitations can be placed here.
     *
     * @tags User
     * @name UserGetUser
     * @summary This asynchronous method retrieves user data based on the provided user ID.
     * @request GET:/User/{id}
     * @secure
     */
    userGetUser: (id: string, params: RequestParams = {}) =>
      this.request<GetUserData, any>({
        path: `/User/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
 * No description
 *
 * @tags User
 * @name UserSetLabelUser
 * @summary Sets the LabelWin user (offer-export bridge) for a user. Only Administrators (and higher)
may edit this mapping.
 * @request PUT:/User/{id}/LabelUser
 * @secure
 */
    userSetLabelUser: (id: string, data: SetLabelUserData, params: RequestParams = {}) =>
      this.request<GetUserData, any>({
        path: `/User/${id}/LabelUser`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Uses the UserService to handle the actual password changing process. The task represents ongoing work. The result of the work is a boolean value that corresponds to the success or failure of the update operation.
     *
     * @tags User
     * @name UserChangePassword
     * @summary Changes the password for a user.
     * @request POST:/User/ChangePassword
     * @secure
     */
    userChangePassword: (data: ChangePasswordData, params: RequestParams = {}) =>
      this.request<boolean, any>({
        path: `/User/ChangePassword`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description This method fetches detailed support data tied to a specific user identified by id. For optimal results, ensure that the id parameter is valid and non-null.
     *
     * @tags User
     * @name UserGetSupportUserData
     * @summary Fetches user's support data.
     * @request GET:/User/{id}/SupportData
     * @secure
     */
    userGetSupportUserData: (id: string, params: RequestParams = {}) =>
      this.request<GetSupportUserData, any>({
        path: `/User/${id}/SupportData`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  version = {
    /**
     * No description
     *
     * @tags Version
     * @name VersionGetServerVersion
     * @summary Gets the current server version.
     * @request GET:/Version/server-version
     * @secure
     */
    versionGetServerVersion: (params: RequestParams = {}) =>
      this.request<File, any>({
        path: `/Version/server-version`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
 * No description
 *
 * @tags Version
 * @name VersionGetRecentVersions
 * @summary Retrieves recent versions across products.
If no versions exist in the time window, the latest versions are returned.
 * @request GET:/Version/recent
 * @secure
 */
    versionGetRecentVersions: (
      query?: {
        /**
         * Number of days to look back.
         * @format int32
         * @default 30
         */
        days?: number;
        /**
         * Maximum number of versions to return.
         * @format int32
         * @default 5
         */
        limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<RecentVersionDto[], any>({
        path: `/Version/recent`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Version
     * @name VersionGetVersionByKey
     * @summary Gets a single version by key for internal users (OFFICE/DEVELOPMENT).
     * @request POST:/Version/byKey
     * @secure
     */
    versionGetVersionByKey: (data: VersionKey, params: RequestParams = {}) =>
      this.request<GetVersionData, ProblemDetails>({
        path: `/Version/byKey`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Version
     * @name VersionGetVersionByKeyForCustomer
     * @summary Gets a single version by key for customers.
     * @request POST:/Version/Customer/byKey
     * @secure
     */
    versionGetVersionByKeyForCustomer: (data: VersionKey, params: RequestParams = {}) =>
      this.request<GetVersionDataCustomer, ProblemDetails>({
        path: `/Version/Customer/byKey`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description This method adds a version
     *
     * @tags Version
     * @name VersionAddVersion
     * @summary Adds version
     * @request POST:/Version
     * @secure
     */
    versionAddVersion: (data: AddVersionData, params: RequestParams = {}) =>
      this.request<GetVersionData, any>({
        path: `/Version`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description This method updates a version
     *
     * @tags Version
     * @name VersionUpdateVersion
     * @summary Updates version
     * @request PUT:/Version
     * @secure
     */
    versionUpdateVersion: (data: AddVersionData, params: RequestParams = {}) =>
      this.request<GetVersionData, ProblemDetails>({
        path: `/Version`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
 * No description
 *
 * @tags Version
 * @name VersionGetPublicVersions
 * @summary Returns the public version tree for a product. No files — fetch them per version
via GET /Version/{productId}/{major}/{minor}/{patch}/files.
 * @request GET:/Version/{link}/public
 * @secure
 */
    versionGetPublicVersions: (link: string, params: RequestParams = {}) =>
      this.request<VersionTreeNodeDto[], any>({
        path: `/Version/${link}/public`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
 * No description
 *
 * @tags Version
 * @name VersionGetCustomerVersions
 * @summary Returns the customer version tree for a product. Customers see every version
they are authorized for (approved + matching stage), including revoked ones —
files have to be fetched separately per version.
 * @request GET:/Version/{link}/customer
 * @secure
 */
    versionGetCustomerVersions: (link: string, params: RequestParams = {}) =>
      this.request<VersionTreeNodeDto[], any>({
        path: `/Version/${link}/customer`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
 * No description
 *
 * @tags Version
 * @name VersionGetVersions
 * @summary Returns the full version tree (incl. unapproved / revoked / blocked) for
OFFICE / DEVELOPMENT consumers. Files have to be fetched separately per version.
 * @request GET:/Version/{link}
 * @secure
 */
    versionGetVersions: (link: string, params: RequestParams = {}) =>
      this.request<VersionTreeNodeDto[], any>({
        path: `/Version/${link}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Version
     * @name VersionGetVersionsFlat
     * @summary Returns the full version list as a flat (non-hierarchical) array.
     * @request GET:/Version/{link}/Flat
     * @secure
     */
    versionGetVersionsFlat: (link: string, params: RequestParams = {}) =>
      this.request<VersionTreeNodeDto[], any>({
        path: `/Version/${link}/Flat`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
 * No description
 *
 * @tags Version
 * @name VersionGetVersionFiles
 * @summary Returns the file list for a single version. Customers receive only the files
they are entitled to (FilterTags + support contract / expiration filter).
OFFICE / DEVELOPMENT consumers receive the complete file list.
 * @request GET:/Version/{productId}/{major}/{minor}/{patch}/files
 * @secure
 */
    versionGetVersionFiles: (
      productId: string,
      major: number,
      minor: number,
      patch: number,
      query?: {
        /** Optional host system filter (OR-linked). */
        hostSystemIds?: string[] | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<VersionVersionFileData[], any>({
        path: `/Version/${productId}/${major}/${minor}/${patch}/files`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description This method approves a version
     *
     * @tags Version
     * @name VersionApproveVersion
     * @summary Approve Version
     * @request POST:/Version/approve
     * @secure
     */
    versionApproveVersion: (data: VersionKey, params: RequestParams = {}) =>
      this.request<GetVersionData, ProblemDetails>({
        path: `/Version/approve`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
 * No description
 *
 * @tags Version
 * @name VersionHideVersion
 * @summary Hides a previously approved version from customers (clears Approved).
The version itself stays in the database and can be re-approved later.
 * @request DELETE:/Version/approve
 * @secure
 */
    versionHideVersion: (data: VersionKey, params: RequestParams = {}) =>
      this.request<GetVersionData, ProblemDetails>({
        path: `/Version/approve`,
        method: "DELETE",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
 * No description
 *
 * @tags Version
 * @name VersionRevokeVersion
 * @summary Marks a version as revoked. The version stays visible to customers but with the
supplied reason text. Approving the same version again clears the revoke state.
 * @request POST:/Version/revoke
 * @secure
 */
    versionRevokeVersion: (data: RevokeVersionRequest, params: RequestParams = {}) =>
      this.request<GetVersionData, ProblemDetails>({
        path: `/Version/revoke`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Version
     * @name VersionRestoreVersion
     * @summary Clears the revoke state of a version without changing its approval state.
     * @request DELETE:/Version/revoke
     * @secure
     */
    versionRestoreVersion: (data: VersionKey, params: RequestParams = {}) =>
      this.request<GetVersionData, ProblemDetails>({
        path: `/Version/revoke`,
        method: "DELETE",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Version
     * @name VersionSetDownloadBlocked
     * @summary Blocks or unblocks the download of a single version. Independent of revoke.
     * @request POST:/Version/downloadBlocked
     * @secure
     */
    versionSetDownloadBlocked: (data: SetDownloadBlockedRequest, params: RequestParams = {}) =>
      this.request<GetVersionData, ProblemDetails>({
        path: `/Version/downloadBlocked`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description This method deletes a specific file
     *
     * @tags Version
     * @name VersionDeleteFile
     * @summary Deletes a file
     * @request DELETE:/Version/File/{id}
     * @secure
     */
    versionDeleteFile: (id: string, params: RequestParams = {}) =>
      this.request<File, any>({
        path: `/Version/File/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * @description This method will return a file stream, allowing the client to download the file. The type returned is a FileStreamResult. Use the id parameter to specify the desired file. Requires authorization of a user within the CUSTOMER group.
     *
     * @tags Version
     * @name VersionGetFile
     * @summary Gets the file.
     * @request GET:/Version/File/{id}
     * @secure
     */
    versionGetFile: (id: string, params: RequestParams = {}) =>
      this.request<File, any>({
        path: `/Version/File/${id}`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Version
     * @name VersionGetFileDetails
     * @summary Get details of single file
     * @request GET:/Version/File/{id}/Details
     * @secure
     */
    versionGetFileDetails: (id: string, params: RequestParams = {}) =>
      this.request<File, any>({
        path: `/Version/File/${id}/Details`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Version
     * @name VersionCheckFileBeforeDownload
     * @summary Check file before download to display error messages
     * @request GET:/Version/File/{id}/CheckDownload
     * @secure
     */
    versionCheckFileBeforeDownload: (id: string, params: RequestParams = {}) =>
      this.request<GetFileCheckDownload, any>({
        path: `/Version/File/${id}/CheckDownload`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Version
     * @name VersionSendMailToUsers
     * @summary Send mail to all users which downloaded a file
     * @request POST:/Version/{major}/{minor}/{patch}/Mail
     * @secure
     */
    versionSendMailToUsers: (major: number, minor: number, patch: number, data: string, params: RequestParams = {}) =>
      this.request<boolean, any>({
        path: `/Version/${major}/${minor}/${patch}/Mail`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description This method will validate the request to ensure that it is a valid form-data request and that the Content-Type header contains a boundary. If the request is not valid, an UnsupportedMediaTypeException will be thrown. Any BadRequestException or EntityNotFoundException that are thrown during the processing of the file will be caught and their messages will be returned as the result of the action.
     *
     * @tags Version
     * @name VersionOnPostUpload
     * @summary Handles the upload of a file.
     * @request POST:/Version/File
     * @secure
     */
    versionOnPostUpload: (
      data: File,
      query?: {
        /**
         * The major version number.
         * @format int32
         * @example 3
         */
        Major?: number;
        /**
         * The minor version number.
         * @format int32
         * @example 1
         */
        Minor?: number;
        /**
         * The patch version number.
         * @format int32
         * @example 0
         */
        Patch?: number;
        /**
         * The unique identifier for the product.
         * @format guid
         * @example "3D290374-8689-4856-B5C4-35E0414F66E8"
         */
        ProductId?: string;
        /**
         * FileTypeId of FileType which belongs to this file
         * @format guid
         */
        FileTypeId?: string;
        /**
         * HostSystemId specifies which platform this file is for
         * @format guid
         */
        HostSystemId?: string | null;
        /** Filename of the file uploaded */
        FileName?: string;
        /** File which will be uploaded */
        ContentType?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetVersionFileData, ProblemDetails>({
        path: `/Version/File`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  youTrack = {
    /**
 * No description
 *
 * @tags YouTrack
 * @name YouTrackGetTickets
 * @summary Retrieves a list of YouTrack tickets/issues from the SupportHelpdesk project with basic information (title and status).
Automatically filters tickets based on the authenticated user's email and their associated support contract IDs.
OFFICE users can optionally filter by a different email address.
 * @request GET:/YouTrack/tickets
 * @secure
 */
    youTrackGetTickets: (
      query?: {
        /**
         * Maximum number of tickets to retrieve. Defaults to 100.
         * @format int32
         * @default 100
         */
        top?: number;
        /**
         * Number of tickets to skip for pagination. Defaults to 0.
         * @format int32
         * @default 0
         */
        skip?: number;
        onlyOpen?: boolean | null;
        /** Optional email to filter tickets for (only for OFFICE users). */
        filterEmail?: string | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<YouTrackIssueDTO[], ProblemDetails>({
        path: `/YouTrack/tickets`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
 * No description
 *
 * @tags YouTrack
 * @name YouTrackGetStatistics
 * @summary Retrieves statistics for YouTrack tickets.
Includes total open Helpdesk tickets count (only for DEVELOPMENT users).
 * @request GET:/YouTrack/statistics
 * @secure
 */
    youTrackGetStatistics: (
      query?: {
        /**
         * Maximum number of tickets to retrieve. Defaults to 500.
         * @format int32
         * @default 500
         */
        top?: number;
        /**
         * Number of tickets to skip for pagination. Defaults to 0.
         * @format int32
         * @default 0
         */
        skip?: number;
        /** Optional email to filter tickets for (only for OFFICE users). */
        filterEmail?: string | null;
        /**
         * Maximum number of tickets used for response time calculation.
         * @format int32
         * @default 50
         */
        responseSampleLimit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<YouTrackStatisticsDto, ProblemDetails>({
        path: `/YouTrack/statistics`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
 * No description
 *
 * @tags YouTrack
 * @name YouTrackGetAllTickets
 * @summary Retrieves ALL non-solved tickets from the SupportHelpdesk project.
This is an admin function - only available to DEVELOPMENT users and above.
 * @request GET:/YouTrack/tickets/all
 * @secure
 */
    youTrackGetAllTickets: (
      query?: {
        /**
         * Maximum number of tickets to retrieve. Defaults to 100.
         * @format int32
         * @default 100
         */
        top?: number;
        /**
         * Number of tickets to skip for pagination. Defaults to 0.
         * @format int32
         * @default 0
         */
        skip?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<YouTrackIssueDTO[], ProblemDetails>({
        path: `/YouTrack/tickets/all`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
 * No description
 *
 * @tags YouTrack
 * @name YouTrackGetTicketDetails
 * @summary Retrieves detailed information about a specific YouTrack ticket including description and public comments.
OFFICE users can optionally filter by email to check access.
 * @request GET:/YouTrack/tickets/{issueId}
 * @secure
 */
    youTrackGetTicketDetails: (
      issueId: string,
      query?: {
        /** Optional email to filter access check for (only for OFFICE users). */
        filterEmail?: string | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<YouTrackIssueDetailDTO, ProblemDetails>({
        path: `/YouTrack/tickets/${issueId}`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
 * No description
 *
 * @tags YouTrack
 * @name YouTrackIsReporter
 * @summary Checks if the currently authenticated user is the reporter of a specific ticket.
OFFICE users can optionally check for a different email.
 * @request GET:/YouTrack/tickets/{issueId}/is-reporter
 * @secure
 */
    youTrackIsReporter: (
      issueId: string,
      query?: {
        /** Optional email to check for (only for OFFICE users). */
        filterEmail?: string | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/YouTrack/tickets/${issueId}/is-reporter`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
 * No description
 *
 * @tags YouTrack
 * @name YouTrackCreateComment
 * @summary Creates a new comment on a YouTrack ticket on behalf of the currently authenticated user.
Only works if the user is the reporter of the ticket.
OFFICE users can optionally comment on behalf of a different email.
 * @request POST:/YouTrack/tickets/{issueId}/comments
 * @secure
 */
    youTrackCreateComment: (
      issueId: string,
      data: CreateCommentRequest,
      query?: {
        /** Optional email to comment on behalf of (only for OFFICE users). */
        filterEmail?: string | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, ProblemDetails | void>({
        path: `/YouTrack/tickets/${issueId}/comments`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),
  };
}
